webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(261)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(319),
  /* scopeId */
  "data-v-970b8c72",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(264)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(322),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOGGLE_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOGGLE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TOGGLE_NAVBAR_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EXPAND_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SWITCH_EFFECT; });
var TOGGLE_DEVICE = 'TOGGLE_DEVICE';

var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
var TOGGLE_NAVBAR_MENU = 'TOGGLE_NAVBAR_MENU';

var EXPAND_MENU = 'EXPAND_MENU';

var SWITCH_EFFECT = 'SWITCH_EFFECT';

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(242)
__webpack_require__(243)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(300),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lazyLoading__ = __webpack_require__(204);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// import charts from './charts'
// import uifeatures from './uifeatures'
// import components from './components'
// import tables from './tables'

// show: meta.label -> name
// name: component name
// meta.label: display label

var state = {
  items: [{
    name: 'index.administration',
    path: '/administration_manager',
    meta: {
      auth: true,
      icon: 'fa-cogs',
      link: 'administration_manager/index.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('administration_manager', true)
  }, {
    name: 'index.reception',
    path: '/reception_manager',
    meta: {
      auth: true,
      icon: 'fa-id-card',
      link: 'reseption_manager/index.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('reseption_manager', true)
  }, {
    name: 'index.user_profile',
    path: '/',
    meta: {
      auth: true,
      icon: 'fa-info',
      link: 'profile/index.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('profile', true)
    // charts,
    // uifeatures,
    // components,
    // tables
  }]
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* EXPAND_MENU */], function (state, menuItem) {
  if (menuItem.index > -1) {
    if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
      state.items[menuItem.index].meta.expanded = menuItem.expanded;
    }
  } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
    menuItem.item.meta.expanded = menuItem.expanded;
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(260)
__webpack_require__(259)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(318),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(244)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(301),
  /* scopeId */
  "data-v-18afcd9b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(296),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(297),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(258)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(317),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(249)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(305),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(256)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(315),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(247)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(303),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(266)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(324),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(240)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(298),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(265)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(323),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(246)
__webpack_require__(245)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(302),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(310),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */,
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_regenerator_runtime_runtime_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(193);




__WEBPACK_IMPORTED_MODULE_1__app__["a" /* app */].$mount('#app');

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = {"administration":"Administration","reception":"Devices","user_profile":"User profile","administrating_objects":"Administrating objects","administrating_reception":"Device management","custom":"Custom","rooms_hotel":"Rooms","rooms_workplace":"Workplaces","set_fields":"Set fields","delete":"Delete","fields":"Fields","additional_fields":"Additional fields for {tagname} configuration","select_fields":"Select fields","add_selected":"Add selected","type":"Type","value":"Value","system_field":"system","custom_field":"custom","custom_time":"Custom time","custom_time_cb":"Custom","minutes":"Minutes","object":"Object","configuration":"Configuration","set_room_fields_hotel":"Set fields for {roomname} room in configuration {roomtag}","set_room_fields_workplace":"Set fields for {roomname} workplace in configuration {roomtag}","name":"Name","default_value":"Default value","edit_by_customer":"Edit by customer","add_field":"Add field","close":"Close","save":"Save","save_and_close":"Save and close","succesfully_saved":"Succesfully saved","projects":"Projects","general":"General","general_sidebar":"GENERAL","settings":"Settings","default_arrival_time_hotel":"Default arrival time","default_arrival_time_workplace":"Default work start time","default_departure_time_hotel":"Default departure time","default_departure_time_workplace":"Default work end time","show_qr_after_reg":"Show QR code after registration","multiple_tokens":"Multiple tokens in one configuration","import_settings_from_csv":"Import settings from csv","upload_file":"Upload file","download_csv_template":"Download csv import template file","add_new":"Add new","reception_management":"Reception management","register_client_hotel":"REGISTER CLIENT","register_client_workplace":"REGISTER EMPLOYEE","register_client_popup_hotel":"Register client","register_client_popup_workplace":"Register employee","clients_hotel":"Clients","clients_workplace":"Employees","history":"History","yes":"YES","no":"NO","register":"Register","tag":"Tag","registered_devices":"Registered devices","email":"Email","phone":"Phone","comment":"Comment","phone_number":"Phone number","arrival_datetime_hotel":"Arrival date/time","departure_datetime_hotel":"Departure date/time","arrival_datetime_workplace":"Work start date/time","departure_datetime_workplace":"Work end date/time","custom_session_time":"Custom session time","custom_panels_limit":"Activation panels limit","actions":"Actions","edit_client_tokens_hotel":"Edit client token parameters","edit_client_tokens_workplace":"Edit client token parameters","unlimited_duration":"Unlimited duration","limited_by_datetime":"Limited duration by Date/Time","unlimited_duration_description":"Описание функционала","use_as_login":"Use as login in i3pro for access to this configuration","used_as_login":"Used as login in i3pro for access to this configuration","access_by_email":"Access by email","check_frequency":"License check frequency (days)","def_check_frequency":"License check frequency (days) by default","activation_panels_limit":"Activation panels limit","def_activation_panels_limit":"Activation panels limit by default","activation_panels_limit_placeholder":"if empty - only general license limit","edit":"Edit","send_message":"Send message","qr_code":"QR code","no_clients_found_hotel":"No clients found","no_clients_found_workplace":"No employees found","no_history_records_found":"No history records found","email_successfuly_sended":"Email successfuly sended","push_successfuly_sended":"Successfully sent messages: {msgSuccess}, errors: {msgError}","go_to_object_adm":"Object administration","go_to_reception_adm":"Reception management","edit_client_token":"Edit client token parameters","select_configuration_hotel":"Select the configuration and room","select_configuration_workplace":"Select the configuration and workplace","arrival_date_hotel":"Arrival date","arrival_time_hotel":"Arrival time","departure_date_hotel":"Departure date","departure_time_hotel":"Departure time","arrival_date_workplace":"Work start date","arrival_time_workplace":"Work start time","departure_date_workplace":"Work end date","departure_time_workplace":"Work end time","arrival_date_mauth":"Work start date","arrival_time_mauth":"Work start time","departure_date_mauth":"Work end date","departure_time_mauth":"Work end time","session_time":"Session time","default":"Default","force_deregister_client":"Force deregister client","cancel":"Cancel","edit_registration":"Edit registration","deactivate_registration":"Deactivate registration","days":"days","access_users_rights_not_exist":"Remote right access error","send_push_message":"Send push message","push_message_for_connected_devices":"Push message for connected devices","push_message":"Push message","default_sound":"Default sound","long_sound":"Long sound","send":"Send","send_email":"Send e-mail","email_for":"E-mail for {email}","email_message":"Message","scan_it_for_start":"Scan it for start using project","print":"Print","done":"Done","delete_configuration_confirm":"Are you sure want delete configuration { confname } in { confname } tag?","delete_configuration_warning":"All binded keys and devices also will be deleted","delete_history_key_confirm":"Are you sure want to delete this key?","delete_history_key_warning":"All connected devices also will be deleted","unique_configuration_name":"Unique configuration name","connected_devices":"Connected devices","model":"Model","last_connect_datetime":"Last connect datetime","push_sent":"Push sent","send_to_email":"Send to email","login":"Login","password":"Password","navbar_title":"iRidium BYOD. Registration center","reg_center":"Registration center","login_message":"You have to be registered in special BYOD objects on the <a target='_blank' href='https://iridi.com'>iRidium mobile site</a>","license_info_mauth":"License {license} (used: {rooms}/{roomstotal} apartments)","license_info_hotel":"License {license} (used: {rooms}/{roomstotal} rooms)","license_info_workplace":"License {license} (used: {rooms}/{roomstotal} workplaces)","devices_count":"Devices: ","reset":"Reset","delete_this_field":"Delete this field?","reset_this_field":"Reset this field?","field_successfully_deleted":"Field successfully deleted!","field_successfully_reseted":"Field successfully reseted!","unlim":"unlim","deactivate_confirm":"Are you sure want to deactivate this key?","connected_devices_not_found":"Connected devices not found","logout":"Logout","trial_expired":"Trial expired","auth_errors":{"access_denied":"Access denied","generating_token_error":"Generating token error","wrong_password":"Wrong password","user_not_found":"User not found"},"jwt_errors":{"user_not_define":"User not define","select_configuration_fields_first":"Select configuration fields first","token_findall_error":"Token.findAll error","objectmodel_findall_error":"ObjectModel.findAll error","object_model_update_error":"ObjectModel.update error","configuration_findone_error":"Configuration.findOne error","configuration_update_error":"Configuration.update error","configuration_destroy_error":"Configuration.destroy error","token_findone_error":"Token.findOne error","token_create_error":"Token.create error","token_update_error":"Token.update error","token_destroy_error":"Token.destroy error","device_findall_error":"Device.findAll error","rooms_limit_reached":"License exception: Rooms limit has been reached","missing_params":"Missing params","duplicate":"Duplicate","confid_not_defined":"confId not defined","keyid_not_defined":"keyId not defined","datelifeto_must_defined":"dateLifeTo must define","datelifeto_must_bigger":"dateLifeTo have to be bigger than now or dateLifeFrom","method_not_found":"Method not found","access_denied":"Access denied","allowed_objects_not_found":"Allowed objects not found","allowed_projects_not_found":"Allowed projects not found","find_push_keys_error":"Devices not found"},"profile":{"current_password":"Current password","new_password":"New password","confirm_password":"Confirm password","change_password":"Change password","forgot_password_title":"Password recovery","forgot_password_link":"Forgot password?","name":"Name","lastname":"Last name","login":"Login","email":"E-mail","email_label":"Enter your e-mail","save":"Save","send":"Send","save_profile":"Save profile","user_info":"User information","password_reset_success":"We send to entered email the link for changing password.","password_changed_success":"Password changed succesfully","password_changed_error":"Error while changing password","profile_saved_success":"Profile saved succesfully","profile_saved_error":"Error while saving profile","errors":{"fill_this_field":"Fill this field","password_mismatch":"Password mismatch","weak_password":"Password must be at least 6 characters","wrong_old_password":"Wrong old password","user_not_found":"User not found","invalid_user_type":"Invalid user type"},"object_settings":{"sms_label":"SMS-Center","sms_login":"API Login [LOGIN]","sms_password":"API Password [PASSWORD]","sms_balance":"SMS Balance","save_sms":"Save keys","test_sms":"Test SMS","clear_sms":"Clear keys","sms_saved_success":"SMS API keys saved succesfully","sms_saved_error":"Invalid account","send_sms":"Send SMS","sms_phone":"Phone number","sms_send_success":"Test SMS send success"}}}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = {"administration":"Администрирование","reception":"Устройства","user_profile":"Профиль","administrating_objects":"Администрирование объектов","administrating_reception":"Управление устройствами","custom":"Пользовательские настройки","rooms_hotel":"Комнаты","rooms_workplace":"Рабочие места","set_fields":"Настроить поля","delete":"Удалить","fields":"Поля","additional_fields":"Дополнительные поля для конфигурации {tagname}","select_fields":"Выберите поля","add_selected":"Добавить выбранные","type":"Тип","value":"Значение","system_field":"системное","custom_field":"пользовательское","custom_time":"Время","custom_time_cb":"Пользовательское","minutes":"Минуты","object":"Объект","configuration":"Конфигурация","set_room_fields_hotel":"Установка полей для комнаты {roomname} в конфигурации {roomtag}","set_room_fields_workplace":"Установка полей для рабочего места {roomname} в конфигурации {roomtag}","name":"Имя","default_value":"Значение по умолчанию","edit_by_customer":"Редактируется клиентом","add_field":"Добавить поле","close":"Закрыть","save":"Сохранить","save_and_close":"Сохранить и закрыть","succesfully_saved":"Успешно сохранено","projects":"Проекты","general":"Общие настройки","general_sidebar":"ОБЩИЕ","settings":"Настройки","default_arrival_time_hotel":"Время прибытия по умолчанию","default_arrival_time_workplace":"Время начала работы по умолчанию","default_departure_time_hotel":"Время отъезда по умолчанию","default_departure_time_workplace":"Время завершения работы по умолчанию","show_qr_after_reg":"Показать QR код после регистрации","multiple_tokens":"Multiple tokens in one configuration","import_settings_from_csv":"Импорт настроек из csv","upload_file":"Загрузить файл","download_csv_template":"Скачать шаблон файла импорта","add_new":"Добавить","reception_management":"Reception management","register_client_hotel":"РЕГИСТРАЦИЯ КЛИЕНТА","register_client_workplace":"РЕГИСТРАЦИЯ СОТРУДНИКА","register_client_popup":"Регистрация клиента","register_client_popup_workplace":"Регистрация сотрудника","clients_hotel":"Клиенты","clients_workplace":"Сотрудники","history":"История","yes":"ДА","no":"НЕТ","register":"Регистрация","tag":"Тег","registered_devices":"Зарегистрированные устройства","email":"E-mail","phone":"Телефон","comment":"Комментарий","phone_number":"Номер телефона","arrival_datetime_hotel":"Дата/время прибытия","departure_datetime_hotel":"Дата/время отъезда","arrival_datetime_workplace":"Дата/время начала работы","departure_datetime_workplace":"Дата/время конца работы","custom_session_time":"Пользовательское время сессии","custom_panels_limit":"Одновременных активаций на код","actions":"Действия","edit_client_tokens_hotel":"Редактирование клиента","edit_client_tokens_workplace":"Редактирование сотрудника","unlimited_duration":"Неограниченное время действия","limited_by_datetime":"Ограниченное время действия","unlimited_duration_description":"Описание функционала","use_as_login":"Использовать как логин в i3 pro для доступа к конфигурации","used_as_login":"Используется как логин в i3 pro для доступа к конфигурации","access_by_email":"Доступ по email","check_frequency":"Частота проверки лицензии (дней)","def_check_frequency":"Частота проверки лицензии (дней) по умолчанию","activation_panels_limit":"Количество одновременных активаций на этот код","def_activation_panels_limit":"Количество одновременных активаций на код по умолчанию","activation_panels_limit_placeholder":"если пусто, то ограничено общим лимитом лицензии","edit":"Редактировать","send_message":"Отправить сообщение","qr_code":"QR код","no_clients_found_hotel":"Клиенты не найдены","no_clients_found_workplace":"Сотрудники не найдены","no_history_records_found":"История не найдена","email_successfuly_sended":"Письмо отправлено","push_successfuly_sended":"Push-сообщение успешно отправлено","go_to_object_adm":"К управлению объектами","go_to_reception_adm":"К управлению устройствами","edit_client_token":"Редактирование регистрации","select_configuration_hotel":"Выберите конфигурацию и комнату","select_configuration_workplace":"Выберите конфигурацию и рабочее место","arrival_date_hotel":"Дата прибытия","arrival_time_hotel":"Время прибытия","departure_date_hotel":"Дата отъезда","departure_time_hotel":"Время отъезда","arrival_date_workplace":"Дата начала работы","arrival_time_workplace":"Время начала работы","departure_date_workplace":"Дата конца работы","departure_time_workplace":"Время конца работы","session_time":"Время сессии","default":"По умолчанию","force_deregister_client":"Принудительная отмена регистрации","cancel":"Отмена","edit_registration":"Редактировать регистрацию","deactivate_registration":"Деактивировать регистрацию","days":"дней","access_users_rights_not_exist":"Ошибка доступа к удаленному праву","send_push_message":"Отправить пуш-сообщение","push_message_for_connected_devices":"Пуш-сообщение для подключенных устройств","push_message":"Пуш-сообщение","default_sound":"Звук по умолчанию","long_sound":"Долгий звук","send":"Отправить","send_email":"Отправить e-mail","email_for":"E-mail для {email}","email_message":"Текст сообщения","scan_it_for_start":"Отсканируйте, чтобы начать пользоваться проектом","print":"Печать","done":"Готово","delete_configuration_confirm":"Вы действительно хотите удалить конфигурацию {confname} в теге {conftag}?","delete_configuration_warning":"Все привязанные ключи и устройства так же будут удалены","delete_history_key_confirm":"Вы действительно хотите удалить этот ключ?","delete_history_key_warning":"Все подключенные устройства так же будут удалены","unique_configuration_name":"Уникальное название","connected_devices":"Подключенные устройства","model":"Модель","last_connect_datetime":"Последнее подключение","push_sent":"Сообщения","send_to_email":"Отправить на e-mail","login":"Вход","password":"Пароль","navbar_title":"iRidium BYOD. Центр регистрации","reg_center":"Центр регистрации","forgot_password":"Забыли пароль?","login_message":"Вы должны быть зарегистрированы в специальных объектах BYOD на <a target='_blank' href='https://iridi.com'>сайте iRidium Mobile</a>","license_info_hotel":"Лицензия {license} (Использовано комнат: {rooms}/{roomstotal})","license_info_workplace":"Лицензия {license} (Использовано рабочих мест: {rooms}/{roomstotal})","devices_count":"Устройств: ","reset":"Сброс","delete_this_field":"Удалить поле?","reset_this_field":"Сбросить поле?","field_successfully_deleted":"Поле успешно удалено!","field_successfully_reseted":"Поле успешно сброшено!","unlim":"неограниченно","deactivate_confirm":"Вы действительно хотите деактивировать этот ключ?","connected_devices_not_found":"Подключенные устройства не найдены","logout":"Выход","trial_expired":"Триальный период истек","auth_errors":{"access_denied":"Доступ запрещен","generating_token_error":"Ошибка генерации токена","wrong_password":"Неверный пароль","user_not_found":"Пользователь не найден"},"jwt_errors":{"user_not_define":"User not define","select_configuration_fields_first":"Select configuration fields first","token_findall_error":"Token.findAll error","objectmodel_findall_error":"ObjectModel.findAll error","object_model_update_error":"ObjectModel.update error","configuration_findone_error":"Configuration.findOne error","configuration_update_error":"Configuration.update error","configuration_destroy_error":"Configuration.destroy error","token_findone_error":"Token.findOne error","token_create_error":"Token.create error","token_update_error":"Token.update error","token_destroy_error":"Token.destroy error","device_findall_error":"Device.findAll error","rooms_limit_reached":"Ошибка: создано максимальное количество комнат","missing_params":"Missing params","duplicate":"Duplicate","confid_not_defined":"confId not defined","keyid_not_defined":"keyId not defined","datelifeto_must_defined":"dateLifeTo must define","datelifeto_must_bigger":"dateLifeTo have to be bigger than now or dateLifeFrom","method_not_found":"Method not found","access_denied":"Доступ запрещен","allowed_objects_not_found":"Доступ в раздел ограничен для учетной записи. Обратитесь к администратору","allowed_projects_not_found":"Доступные проекты не найдены","find_push_keys_error":"Устройства не найдены"},"profile":{"current_password":"Текущий пароль","new_password":"Новый пароль","confirm_password":"Подтверждение пароля","change_password":"Изменить пароль","forgot_password_title":"Восстановление пароля","forgot_password_link":"Забыли пароль?","name":"Имя","lastname":"Фамилия","login":"Логин","email":"E-mail","email_label":"Введите ваш e-mail","save":"Сохранить","send":"Отправить","save_profile":"Сохранить данные","user_info":"Данные пользователя","password_changed_success":"Пароль успешно изменен","password_changed_error":"Ошибка при изменении пароля","profile_saved_success":"Профиль успешно сохранен","profile_saved_error":"Ошибка при сохранении профиля","password_reset_success":"На данный e-mail отправлено письмо со ссылкой для сброса пароля","errors":{"fill_this_field":"Заполните это поле","password_mismatch":"Подтверждение не совпадает с паролем","weak_password":"Пароль должен содержать как минимум 6 символов","wrong_old_password":"Неверный текущий пароль","user_not_found":"Пользователь не найден","invalid_user_type":"Неверный тип пользователя"}}}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Home.vue": [
		148
	],
	"./administration_manager/index.vue": [
		12
	],
	"./auth/Login.vue": [
		149
	],
	"./mini_components/Changepassword.vue": [
		150
	],
	"./mini_components/FDateTime.vue": [
		4
	],
	"./mini_components/Forgotpassword.vue": [
		151
	],
	"./mini_components/Importfields.vue": [
		152
	],
	"./mini_components/Registermauth.vue": [
		153
	],
	"./mini_components/Registertoken.vue": [
		154
	],
	"./mini_components/Roomfields.vue": [
		155
	],
	"./mini_components/Tagfields.vue": [
		156
	],
	"./mini_components/Updatemauth.vue": [
		157
	],
	"./mini_components/Updatetoken.vue": [
		158
	],
	"./profile/index.vue": [
		331,
		0
	],
	"./reseption_manager/index.vue": [
		159
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 165;

/***/ }),
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__websanova_vue_auth__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__websanova_vue_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__websanova_vue_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_nprogress__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_vue__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filters__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex_store_mutation_types__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_bulma_notification__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lang__ = __webpack_require__(197);
/* unused harmony reexport router */
/* unused harmony reexport store */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








// import Cleave from 'cleave.js';









var NotificationComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_12_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var authProdBackend = 'https://iridi.com';

var backendEndpoint = window.location.hostname;
if (backendEndpoint.startsWith('localhost')) {
  backendEndpoint = backendEndpoint + ':3000';
} else {
  backendEndpoint = '' + backendEndpoint.replace('byod', 'byodbackend');
}
backendEndpoint = window.location.protocol + '//' + backendEndpoint;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$backendHost = backendEndpoint;

// Vue.directive('cleave', {
//   inserted: (el, binding, vnode) => {
//     console.log(el, binding, vnode)
//       el.cleave = new Cleave(vnode.componentInstance.$refs.input, binding.value || {})
//       console.log(el.cleave)
//       // el.cleave.setRawValue(binding.value.initValue||'')
//   },
//   update: (el) => {
//       const event = new Event('input', {bubbles: true});
//       setTimeout(function () {
//           el.value = el.cleave.properties.result
//           el.dispatchEvent(event)
//       }, 100);
//   }
// })

// $auth $http
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__websanova_vue_auth___default.a, {
  auth: {
    request: function request(req, token) {
      this.options.http._setHeaders.call(this, req, {
        Authorization: 'Bearer ' + token
      });
    },
    response: function response(res) {
      // Get Token from response body
      // console.log(res);
      if (res.data.code === 'InvalidToken') {
        this.logout({
          redirect: 'Home',
          makeRequest: false
        });

        openNotification({
          title: '',
          message: 'Session is expired',
          type: 'danger'
        });
      } else {
        return res.data.token;
      }
    }
  },
  http: __webpack_require__(168),
  router: __webpack_require__(169),
  loginData: {
    url: authProdBackend + '/customer/auth/',
    fetchUser: false
  },
  refreshData: {
    enabled: false
  },
  tokenExpired: function tokenExpired() {
    return false;
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_nprogress___default.a);
// Vue.use(VueI18n);
// Enable devtools
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.devtools = true;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */]);

var nprogress = new __WEBPACK_IMPORTED_MODULE_5_vue_nprogress___default.a({
  parent: '.nprogress-container'
});

var state = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state;

// router.beforeEach((route, redirect, next) => {
//   if (state.app.device.isMobile && state.app.navbar.opened) {
//     store.commit(TOGGLE_NAVBAR_MENU, false);
//   }
//   if (state.app.device.isMobile && state.app.sidebar.opened) {
//     store.commit(TOGGLE_SIDEBAR, false);
//   }
//   next();
// });

Object.keys(__WEBPACK_IMPORTED_MODULE_10__filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_10__filters__[key]);
});

window.Vue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"];
console.log(__WEBPACK_IMPORTED_MODULE_13__lang__["a" /* default */]);
var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'en', // установка локализации по умолчанию
  messages: __WEBPACK_IMPORTED_MODULE_13__lang__["a" /* default */] // установка сообщений локализаций
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"](_extends({
  i18n: i18n,
  router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */],
  nprogress: nprogress
}, __WEBPACK_IMPORTED_MODULE_7__App_vue___default.a));



/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sidebar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AppMain__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__AppMain___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FooterBar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__FooterBar___default.a; });









/***/ }),
/* 195 */
/***/ (function(module, exports) {



/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_json__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_json__);


/* harmony default export */ __webpack_exports__["a"] = ({
    index: __WEBPACK_IMPORTED_MODULE_0__index_json___default.a
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ru_lang__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_lang__ = __webpack_require__(196);



/* harmony default export */ __webpack_exports__["a"] = ({
  'ru': __WEBPACK_IMPORTED_MODULE_0__ru_lang__["a" /* default */],
  'en': __WEBPACK_IMPORTED_MODULE_1__en_lang__["a" /* default */]
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_json__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__index_json__);


/* harmony default export */ __webpack_exports__["a"] = ({
    index: __WEBPACK_IMPORTED_MODULE_0__index_json___default.a
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__ = __webpack_require__(20);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'is-active',
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  routes: [{
    name: 'Home',
    path: '/',
    component: __webpack_require__(148)
  }, {
    name: 'Login',
    path: '/login',
    component: __webpack_require__(149)
  }, {
    name: 'Administration',
    path: '/administration_manager',
    meta: {
      auth: true,
      icon: 'fa-cogs',
      link: 'administration_manager/index.vue'
    },
    component: __webpack_require__(12)
  }, {
    name: 'Administration2',
    path: '/administration_manager2',
    meta: {
      auth: true,
      icon: 'fa-cogs',
      link: 'administration_manager/index.vue'
    },
    component: __webpack_require__(12)
  }, {
    name: 'Reception',
    path: '/reception_manager',
    meta: {
      auth: true,
      icon: 'fa-id-card',
      link: 'reseption_manager/index.vue'
    },
    component: __webpack_require__(159)
  },
  // ...generateRoutesFromMenu(menuModule.state.items),
  {
    path: '*',
    redirect: '/'
  }]
}));

// Menu should have 2 levels.
function generateRoutesFromMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var i = 0, l = menu.length; i < l; i++) {
    var item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleNavbar", function() { return toggleNavbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleSidebar", function() { return toggleSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleDevice", function() { return toggleDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expandMenu", function() { return expandMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchEffect", function() { return switchEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(8);


var toggleNavbar = function toggleNavbar(_ref, opened) {
  var commit = _ref.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* TOGGLE_NAVBAR_MENU */], opened);
};

var toggleSidebar = function toggleSidebar(_ref2, opened) {
  var commit = _ref2.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* TOGGLE_SIDEBAR */], opened);
};

var toggleDevice = function toggleDevice(_ref3, device) {
  var commit = _ref3.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* TOGGLE_DEVICE */], device);
};

var expandMenu = function expandMenu(_ref4, menuItem) {
  var commit = _ref4.commit;

  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false;
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* EXPAND_MENU */], menuItem);
  }
};

var switchEffect = function switchEffect(_ref5, effectItem) {
  var commit = _ref5.commit;

  if (effectItem) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* SWITCH_EFFECT */], effectItem);
  }
};

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pkg", function() { return pkg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "app", function() { return app; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "device", function() { return device; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebar", function() { return sidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "navbar", function() { return navbar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "effect", function() { return effect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "menuitems", function() { return menuitems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componententry", function() { return componententry; });
var pkg = function pkg(state) {
  return state.pkg;
};
var app = function app(state) {
  return state.app;
};
var device = function device(state) {
  return state.app.device;
};
var sidebar = function sidebar(state) {
  return state.app.sidebar;
};
var navbar = function navbar(state) {
  return state.app.navbar;
};
var effect = function effect(state) {
  return state.app.effect;
};
var menuitems = function menuitems(state) {
  return state.menu.items;
};
var componententry = function componententry(state) {
  return state.menu.items.filter(function (c) {
    return c.meta && c.meta.label === 'Components';
  })[0];
};



/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_package__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_package__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_app__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_menu__ = __webpack_require__(20);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_5__modules_app__["a" /* default */],
    menu: __WEBPACK_IMPORTED_MODULE_6__modules_menu__["a" /* default */]
  },
  state: {
    pkg: __WEBPACK_IMPORTED_MODULE_2_package___default.a
  },
  mutations: {}
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(8);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var state = {
  device: {
    isMobile: false,
    isTablet: false
  },
  sidebar: {
    opened: false,
    hidden: false
  },
  navbar: {
    opened: false,
    hidden: false
  },
  effect: {
    translate3d: true
  }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* TOGGLE_DEVICE */], function (state, device) {
  state.device.isMobile = device === 'mobile';
  state.device.isTablet = device === 'tablet';
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* TOGGLE_SIDEBAR */], function (state, opened) {
  if (state.device.isMobile) {
    state.sidebar.opened = opened;
  } else {
    state.sidebar.opened = true;
  }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* TOGGLE_NAVBAR_MENU */], function (state, opened) {
  if (state.device.isMobile) {
    state.navbar.opened = opened;
  } else {
    state.navbar.opened = true;
  }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* SWITCH_EFFECT */], function (state, effectItem) {
  for (var name in effectItem) {
    state.effect[name] = effectItem[name];
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// lazy loading Components
// https://github.com/vuejs/vue-router/blob/dev/examples/lazy-loading/app.js#L8
/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__(165)("./" + name + (index ? '/index' : '') + '.vue');
  };
});

/***/ }),
/* 205 */,
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_layout___ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_solid__ = __webpack_require__(166);
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome__["a" /* default */].library.add(__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_free_solid__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3__fortawesome_fontawesome__["a" /* default */].config = {
  familyPrefix: 'fa'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["a" /* Navbar */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["b" /* Sidebar */],
    AppMain: __WEBPACK_IMPORTED_MODULE_1_components_layout___["c" /* AppMain */],
    FooterBar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["d" /* FooterBar */],
    NprogressContainer: __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default.a
  },

  beforeMount: function beforeMount() {
    var _this = this;

    var _document = document,
        body = _document.body;

    var WIDTH = 768;
    var RATIO = 3;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var isMobile = rect.width - RATIO < WIDTH;
        _this.toggleDevice(isMobile ? 'mobile' : 'other');
        _this.toggleSidebar(!isMobile);
      }
    };

    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    sidebar: 'sidebar'
  }),

  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['toggleDevice', 'toggleSidebar'])
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Levelbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Levelbar: __WEBPACK_IMPORTED_MODULE_0__Levelbar___default.a
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	data: function data() {
		return this.$store.state.pkg;
	}
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_tooltip__ = __webpack_require__(205);
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb___default.a,
    Tooltip: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_tooltip__["a" /* default */]
  },

  data: function data() {
    return {
      list: null
    };
  },
  created: function created() {
    this.getList();
  },


  computed: {
    codelink: function codelink() {
      if (this.$route.meta && this.$route.meta.link) {
        return 'https://github.com/vue-bulma/vue-admin/blob/master/client/views/' + this.$route.meta.link;
      } else {
        return null;
      }
    },
    name: function name() {
      return this.$route.name;
    }
  },

  methods: {
    getList: function getList() {
      var matched = this.$route.matched.filter(function (item) {
        return item.name;
      });
      var first = matched[0];
      if (first && (first.name !== 'Home' || first.path !== '')) {
        matched = [{ name: 'Home', path: '/' }].concat(matched);
      }
      this.list = matched;
    }
  },

  watch: {
    $route: function $route() {
      this.getList();
    }
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Tooltip from 'vue-bulma-tooltip'


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    //Tooltip
  },

  props: {
    show: Boolean
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])({
    pkginfo: 'pkg',
    sidebar: 'sidebar',
    navbar: 'navbar'
  }),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])(['toggleSidebar', 'toggleNavbar']), {
    logout: function logout() {
      this.$auth.logout({
        redirect: 'Home',
        makeRequest: false
        // params: {},
        // success: function () {},
        // error: function () {},
        // etc...
      });
    }
  }),
  mounted: function mounted() {
    var navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);
    // Check if there are any navbar burgers
    if (navbarBurgers.length > 0) {
      // Add a click event on each of them
      navbarBurgers.forEach(function ($el) {
        $el.addEventListener('click', function () {
          // Get the target from the "data-target" attribute
          var target = $el.dataset.target;
          var $target = document.getElementById(target);
          // Toggle the class on both the "navbar-burger" and the "navbar-menu"
          $el.classList.toggle('is-active');
          try {
            $target.classList.toggle('is-active');
          } catch (error) {
            console.log(error);
          }
        });
      });
    }
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		Expanding: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default.a
	},

	props: {
		show: Boolean
	},

	data: function data() {
		return {
			isReady: false
		};
	},
	mounted: function mounted() {
		var route = this.$route;
		if (route.name) {
			this.isReady = true;
			this.shouldExpandMatchItem(route);
		}
	},


	computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
		menu: 'menuitems'
	}),

	methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['expandMenu']), {
		logout: function logout() {
			this.$auth.logout({
				redirect: 'Home',
				makeRequest: false
				// params: {},
				// success: function () {},
				// error: function () {},
				// etc...
			});
		},
		isExpanded: function isExpanded(item) {
			return item.meta.expanded;
		},
		toggle: function toggle(index, item) {
			this.expandMenu({
				index: index,
				expanded: !item.meta.expanded
			});
		},
		shouldExpandMatchItem: function shouldExpandMatchItem(route) {
			var matched = route.matched;
			var lastMatched = matched[matched.length - 1];
			var parent = lastMatched.parent || lastMatched;
			var isParent = parent === lastMatched;

			if (isParent) {
				var p = this.findParentFromMenu(route);
				if (p) {
					parent = p;
				}
			}

			if ('expanded' in parent.meta && !isParent) {
				this.expandMenu({
					item: parent,
					expanded: true
				});
			}
		},
		generatePath: function generatePath(item, subItem) {
			return '' + (item.component ? item.path + '/' : '') + subItem.path;
		},
		findParentFromMenu: function findParentFromMenu(route) {
			var menu = this.menu;
			for (var i = 0, l = menu.length; i < l; i++) {
				var item = menu[i];
				var k = item.children && item.children.length;
				if (k) {
					for (var j = 0; j < k; j++) {
						if (item.children[j].name === route.name) {
							return item;
						}
					}
				}
			}
		}
	}),

	watch: {
		$route: function $route(route) {
			this.isReady = true;
			this.shouldExpandMatchItem(route);
		}
	}
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mini_components_Changepassword_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mini_components_Changepassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mini_components_Changepassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var NotificationComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Changepassword: __WEBPACK_IMPORTED_MODULE_0__mini_components_Changepassword_vue___default.a
  },

  data: function data() {
    // return this.$store.state.pkg
    return {
      changed: false,
      data: {
        name: "",
        lastname: "",
        login: "",
        options: {
          rst_tkns_chgpswrd: 0
        }
      },
      param: {},
      isloading: false,
      isChangePassword: false
    };
  },
  mounted: function mounted() {

    if (this.$auth.check()) {

      console.log("TEST");
      console.log(this.$auth);
      this.loadData();
    }
  },

  methods: {
    openNotificationWithType: function openNotificationWithType(type, title, message) {
      openNotification({
        title: title,
        message: message,
        type: type
      });
    },
    logout: function logout() {
      this.$auth.logout({
        redirect: 'Home',
        makeRequest: false
      });
    },
    loadData: function loadData() {
      var _this = this;

      this.isloading = true;
      // this.data.length = 0
      this.$http({
        url: 'https://iridi.com/customer/api_byod/?act=profile&type=load',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        params: {
          parameters: {
            param1: 1
          }
        }
      }).then(function (response) {
        _this.data = response.data;
        _this.isloading = false;
        _this.changed = false;
      }).catch(function (error) {
        console.log(error);
        _this.isloading = false;
        _this.changed = false;
      });
    },
    saveData: function saveData() {
      var _this2 = this;

      this.isloading = true;
      // this.data.length = 0
      this.$http({
        method: 'post',
        url: 'https://iridi.com/customer/api_byod/?act=save_profile',
        data: this.data
      }).then(function (response) {
        _this2.changed = false;
        _this2.data = response.data;
        _this2.isloading = false;
        _this2.openNotificationWithType('success', '', _this2.$t('index.profile.profile_saved_success'));
      }).catch(function (error) {
        console.log(error);
        _this2.isloading = false;
        _this2.changed = false;
      });
    },
    changePass: function changePass() {
      this.isChangePassword = true;
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_tabs__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mini_components_FDateTime_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mini_components_FDateTime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__mini_components_FDateTime_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mini_components_Tagfields_vue__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mini_components_Tagfields_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__mini_components_Tagfields_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mini_components_Roomfields_vue__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mini_components_Roomfields_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__mini_components_Roomfields_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mini_components_Importfields_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mini_components_Importfields_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__mini_components_Importfields_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_buefy__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_buefy__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var moment = __webpack_require__(5);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_buefy___default.a, {
  defaultIconPack: 'fas'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_buefy___default.a);
var NotificationComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a);

var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Tabs: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_tabs__["a" /* Tabs */],
    TabPane: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_tabs__["b" /* TabPane */],
    Collapse: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__["Item"],
    Notification: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a,
    FDateTime: __WEBPACK_IMPORTED_MODULE_4__mini_components_FDateTime_vue___default.a,
    Tagfields: __WEBPACK_IMPORTED_MODULE_5__mini_components_Tagfields_vue___default.a,
    Importfields: __WEBPACK_IMPORTED_MODULE_7__mini_components_Importfields_vue___default.a,
    Roomfields: __WEBPACK_IMPORTED_MODULE_6__mini_components_Roomfields_vue___default.a
  },
  data: function data() {
    return {
      file: {},
      showRightModal: false,
      data: {},
      initResponse: {},
      param: {},
      isloading: false,
      showTagFieldsData: false,
      showRoomFieldsData: false,
      uploadInProcess: false,
      tagFieldsData: {
        objectId: '',
        tagName: '',
        fields: [],
        roomData: false
      },
      roomFieldsData: {
        roomData: {}
      },
      showImportedFieldsData: false,
      importedFields: {
        objectId: '',
        objName: '',
        fields: [],
        errors: []
      }
    };
  },
  mounted: function mounted() {
    this.loadData();
    // Can set query parameter here for auth redirect or just do it silently in login redirect.
  },

  methods: {
    upload: function upload(object) {
      var _this = this;

      var ext = /(?:\.([^.]+))?$/.exec(this.file.name)[1];

      if (this.file.size > 300000) {
        this.openNotificationWithType('danger', 'Upload failed', 'file to big');
        return;
      }

      if (ext !== 'csv') {
        this.openNotificationWithType('danger', 'Upload failed', 'Wrong file format');
        return;
      }

      this.uploadInProcess = true;
      var formData = new FormData();
      formData.append('file', this.file);
      formData.append('objectId', object.id);

      // console.log(this.file);
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(this.$backendHost + '/frontend/api/object/settings/upload/csv', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        _this.uploadInProcess = false;
        _this.importedFields.objectId = object.id;
        _this.importedFields.objName = object.name;
        _this.importedFields.errors = [];
        _this.showImportedFieldsData = true;

        if (response.data.status) {
          _this.importedFields.errors = response.data.errors;
        } else {
          _this.importedFields.fields = response.data.fields;
        }
      }).catch(function (err) {
        _this.uploadInProcess = false;
        _this.openNotificationWithType('danger', '', err);
      });
    },
    handleFileUpload: function handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    showFieldsManagerFromRooms: function showFieldsManagerFromRooms(roomData) {
      this.showFieldsManager(roomData.tag, roomData.objectId, roomData);
    },
    successImportFieldsEmit: function successImportFieldsEmit(importData) {
      //this.uploadInProcess = false
      this.loadData(importData.objectId);
    },
    showFieldsManager: function showFieldsManager(tagI, objectId) {
      var _this2 = this;

      var roomData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/tagfields/get',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: {
          tagName: tagI,
          objectId: objectId
        }
      }).then(function (response) {
        if (response.data.status) {
          // this.openNotificationWithType('danger', '', response.data.error);
          _this2.openNotificationWithType('danger', '', response.data.error_code ? _this2.$t('index.jwt_errors.' + response.data.error_code) : response.data.error);
        } else {
          _this2.showTagFieldsData = true;
          _this2.tagFieldsData = {
            objectId: objectId,
            tagName: tagI,
            fields: response.data.fields,
            roomData: roomData
          };
          console.log(response.data);
        }
      }).catch(function (error) {
        _this2.openNotificationWithType('danger', '', error);
      });
    },
    showRoomFieldsManager: function showRoomFieldsManager(roomData) {
      this.showRoomFieldsData = true;
      this.roomFieldsData = {
        roomData: roomData
      };
    },
    saveSettings: function saveSettings(object) {
      var _this3 = this;

      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/object/settings/save',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: {
          timezone: moment.tz.guess(),
          objectId: object.id,
          defArrivalTime: object.defArrivalTime.getTime(),
          defDepartureTime: object.defDepartureTime.getTime(),
          showQrCode: object.showQrCode,
          multyTokensConfig: object.multyTokensConfig,
          defLimitType: 1,
          defFrequencyCheckPeriod: parseInt(object.defFrequencyCheckPeriod),
          defActivationsCount: parseInt(object.defActivationsCount)
        }
      }).then(function (response) {
        if (response.data.status) {
          // this.openNotificationWithType('danger', '', response.data.error);
          _this3.openNotificationWithType('danger', '', response.data.error_code ? _this3.$t('index.jwt_errors.' + response.data.error_code) : response.data.error);
        } else {
          _this3.loadData();
          console.log(response.data);
          _this3.openNotificationWithType('success', '', _this3.$t('index.succesfully_saved'));
        }
      }).catch(function (error) {
        _this3.openNotificationWithType('danger', '', error);
      });
    },
    showNewConfigInput: function showNewConfigInput(object, tagI, tag) {
      console.log(this.initResponse.projectsAdminData[object.id][tagI]);
      this.$set(this.initResponse.projectsAdminData[object.id][tagI], 'newConfigInputShow', true);
      this.$set(this.initResponse.projectsAdminData[object.id][tagI], 'newConfigInputText', '');
    },
    dateFormat: function dateFormat(date) {
      return moment(new Date(date)).format('DD.MM.YYYY');
    },
    timeFormat: function timeFormat(date) {
      return moment(new Date(date)).format('hh:mm:ss');
    },
    showDeleteRoom: function showDeleteRoom(confObj) {
      var _this4 = this;

      this.initResponse.projectsAdminData[confObj.objectId][confObj.tag].configurations.forEach(function (item, i) {
        if (item.id == confObj.id) {
          _this4.$set(_this4.initResponse.projectsAdminData[confObj.objectId][confObj.tag].configurations[i], 'deletePopup', true);
        }
      });
    },
    showEditConf: function showEditConf(objId, tagName, confId) {
      var _this5 = this;

      this.initResponse.projectsAdminData[objId][tagName].configurations.forEach(function (item, i) {
        if (item.id == confId) {
          _this5.$set(_this5.initResponse.projectsAdminData[objId][tagName].configurations[i], 'edit', true);
          _this5.$set(_this5.initResponse.projectsAdminData[objId][tagName].configurations[i], 'newName', item.name);
        }
      });
    },
    deleteConfig: function deleteConfig(confObj) {
      var _this6 = this;

      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/configurations/destroy',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: {
          confId: confObj.id,
          objectId: confObj.objectId
        }
      }).then(function (response) {
        if (response.data.status) {
          // this.openNotificationWithType('danger', '', response.data.error);
          _this6.openNotificationWithType('danger', '', response.data.error_code ? _this6.$t('index.jwt_errors.' + response.data.error_code) : response.data.error);
        } else {

          _this6.$http({
            method: 'post',
            url: 'https://iridi.com/customer/api_byod/?act=delete_config',
            data: { configId: confObj.id }
          }).then(function (bitixResponse) {
            if (bitixResponse.data.status != 'success') {
              _this6.openNotificationWithType('danger', '', _this6.$t('index.' + bitixResponse.data.code));
            }
          }).catch(function (error) {
            console.log(error);
          });

          _this6.loadData();
        }
      }).catch(function (error) {
        _this6.openNotificationWithType('danger', '', error);
      });
    },
    editConfig: function editConfig(confObj, newName) {
      var _this7 = this;

      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/configurations/edit',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: {
          confId: confObj.id,
          objectId: confObj.objectId,
          values: {
            tag: confObj.tag,
            name: newName
          }
        }
      }).then(function (response) {
        if (response.data.status) {
          // this.openNotificationWithType('danger', '', response.data.error);
          _this7.openNotificationWithType('danger', '', response.data.error_code ? _this7.$t('index.jwt_errors.' + response.data.error_code) : response.data.error);
        } else {
          _this7.loadData();
        }
      }).catch(function (error) {
        _this7.openNotificationWithType('danger', '', error);
      });
    },
    addNewConfig: function addNewConfig(objectId, tagName) {
      var _this8 = this;

      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/configurations/add',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: {
          objectId: objectId,
          tag: tagName,
          name: this.initResponse.projectsAdminData[objectId][tagName].newConfigInputText
        }
      }).then(function (response) {
        if (response.data.status) {
          // this.openNotificationWithType('danger', '', response.data.error);
          _this8.openNotificationWithType('danger', '', response.data.error_code ? _this8.$t('index.jwt_errors.' + response.data.error_code) : response.data.error);
        } else {
          _this8.loadData();
        }
      }).catch(function (error) {
        _this8.openNotificationWithType('danger', '', error);
      });
    },
    openNotificationWithType: function openNotificationWithType(type, title, message) {
      openNotification({
        title: title,
        message: message,
        type: type
      });
    },
    getRightClass: function getRightClass(id) {
      return id === null ? 'blend' : '';
    },
    toggleFormInvite: function toggleFormInvite(obj) {
      obj.newRightForm = !obj.newRightForm;
      if (obj.objType === 3) {
        obj.Macros = 0;
        obj.Routines = 0;
        obj.Schedules = 0;
      }
    },
    loadData: function loadData(objectId) {
      var _this9 = this;

      this.isloading = true;

      if (this.initResponse && this.initResponse.objects) {
        this.initResponse.objects.forEach(function (o) {
          return o.sms.collapse = false;
        });
      }

      this.data.length = 0;
      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/init/admin',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: {
          objectId: objectId
        }
      }).then(function (response) {
        if (response.data.error) {
          // this.openNotificationWithType('danger', '', response.data.error);
          _this9.openNotificationWithType('danger', '', response.data.error_code ? _this9.$t('index.jwt_errors.' + response.data.error_code) : response.data.error);
        } else {
          response.data.objects.map(function (o) {
            o.defArrivalTime = new Date(o.defArrivalTime);
            o.defDepartureTime = new Date(o.defDepartureTime);
            o.sms = { login: '', password: '', phone: '', open: false, collapse: false, balance: null };
            return o;
          });
          _this9.$set(_this9, 'initResponse', response.data);
        }
        _this9.isloading = false;
      }).catch(function (error) {
        _this9.isloading = false;
        _this9.openNotificationWithType('danger', '', error.error || error);
      });
    },
    loadSMS: function loadSMS(object) {
      var _this10 = this;

      this.isloading = true;
      this.$http({
        method: 'get',
        url: this.$backendHost + '/frontend/api/object/sms?objectId=' + object.id
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.fields != null) {
          object.sms.balance = data.fields.balance;
          object.sms.provider = data.fields.provider;
          object.sms.credentials = data.fields.credentials;
        }
        _this10.isloading = false;
      }).catch(function () {
        _this10.isloading = true;
      });
    },
    saveSMS: function saveSMS(object) {
      var _this11 = this;

      this.isloading = true;
      this.$http({
        method: 'put',
        url: this.$backendHost + '/frontend/api/object/sms',
        data: {
          objectId: object.id,
          sms: object.sms
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.fields != null && data.fields.balance) {
          object.sms.login = data.fields.login;
          object.sms.password = data.fields.password;
          object.sms.balance = data.fields.balance;
          _this11.openNotificationWithType('success', '', _this11.$t('index.object_settings.sms_saved_success'));
        } else {
          _this11.openNotificationWithType('danger', '', _this11.$t('index.object_settings.sms_saved_error'));
        }
        _this11.isloading = false;
      }).catch(function () {
        _this11.isloading = true;
      });
    },
    deleteSMS: function deleteSMS(object) {
      var _this12 = this;

      this.isloading = true;
      this.$http({
        method: 'delete',
        url: this.$backendHost + '/frontend/api/object/sms',
        data: {
          objectId: object.id
        }
      }).then(function (_ref3) {
        var data = _ref3.data;

        if (data.fields != null) {
          object.sms.credentials = {};
          object.sms.balance = '';
        }
        _this12.isloading = false;
        _this12.openNotificationWithType('success', '', _this12.$t('index.object_settings.sms_saved_success'));
      }).catch(function () {
        _this12.isloading = true;
      });
    },
    testSMS: function testSMS(object) {
      object.sms.open = true;
    },
    changeProvider: function changeProvider(object) {
      object.sms.credentials = {};
      object.sms.balance = '';
      this.$forceUpdate();
    },
    sendSMS: function sendSMS(object) {
      var _this13 = this;

      this.isloading = true;
      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/object/sms',
        data: {
          objectId: object.id,
          sms: {
            phone: object.sms.phone
          }
        }
      }).then(function (_ref4) {
        var data = _ref4.data;

        if (data.fields != null) {
          object.sms.balance = data.fields.balance;
        }
        _this13.isloading = false;
        object.sms.open = false;
        object.sms.phone = '';
        _this13.openNotificationWithType('success', '', _this13.$t('index.object_settings.sms_send_success'));
      }).catch(function () {
        _this13.isloading = true;
      });
    }
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mini_components_Forgotpassword_vue__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mini_components_Forgotpassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__mini_components_Forgotpassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var NotificationComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
	var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
		title: '',
		message: '',
		type: '',
		direction: '',
		duration: 4500,
		container: '.notifications'
	};

	return new NotificationComponent({
		el: document.createElement('div'),
		propsData: propsData
	});
};

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		Notification: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a,
		Forgotpassword: __WEBPACK_IMPORTED_MODULE_0__mini_components_Forgotpassword_vue___default.a
	},
	data: function data() {
		return {
			data: {
				body: {
					username: null,
					password: null,
					byod: 1,
					devbyod: 1
				},
				rememberMe: false

			},
			error: null,
			isloading: false,
			isForgotPassword: false
		};
	},
	mounted: function mounted() {
		if (this.$auth.redirect()) {
			console.log('Redirect from: ' + this.$auth.redirect().from.name);
		}
		// Can set query parameter here for auth redirect or just do it silently in login redirect.
	},

	methods: {
		openNotificationWithType: function openNotificationWithType(type, title, message) {
			openNotification({
				title: title,
				message: message,
				type: type
			});
		},
		login: function login() {
			var redirect = this.$auth.redirect();
			this.$auth.login({
				headers: {
					'Content-Type': 'application/json'
				},
				data: this.data.body,
				rememberMe: this.data.rememberMe,
				redirect: { name: redirect ? redirect.from.name : 'Home' },
				success: function success(res) {
					// axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$auth.token()
					console.log(res);
				},
				error: function error(err) {
					if (err.response) {
						// The request was made, but the server responded with a status code
						// that falls out of the range of 2xx
						// console.log(err.response.status)
						// console.log(err.response.data)
						// console.log(err.response.headers)
						this.error = err.response.data;
						// this.openNotificationWithType('danger', '', this.error.msg)
						this.openNotificationWithType('danger', '', this.$t('index.auth_errors.' + this.error.lang_msg));
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Error', err.message);
					}
					console.log(err.config);
				}
			});
		},
		changePass: function changePass() {
			this.isForgotPassword = true;
		}
	}

});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import FDateTime from './FDateTime.vue';


var NotificationComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

/* harmony default export */ __webpack_exports__["default"] = ({
  // props: ['roomData'],
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a
  },
  data: function data() {
    return {
      data: {
        messages: {
          pass: '',
          newpass: '',
          confirmpass: ''
        }
      },
      initResponse: {},
      param: {},
      isloading: false,
      form: {
        uid: 1662,
        uuid: 'b6111f61-6051-4c28-8420-bea7947a2774',
        pass: null,
        newpass: null,
        confirmpass: null
      }

    };
  },

  methods: {
    openNotificationWithType: function openNotificationWithType(type, title, message) {
      openNotification({
        title: title,
        message: message,
        type: type
      });
    },
    saveData: function saveData() {
      var _this = this;

      this.isloading = true;
      // this.data.length = 0
      this.$http({
        method: 'post',
        url: 'https://iridi.com/customer/api_byod/?act=change_password',
        data: this.form
      }).then(function (response) {
        _this.changed = false;
        _this.data = response.data;
        _this.isloading = false;
        if (response.data.status === 'success') {
          _this.openNotificationWithType('success', '', _this.$t('index.profile.password_reset_success'));
          _this.$parent.close();
        }
      }).catch(function (error) {
        console.log(error);
        _this.isloading = false;
        _this.changed = false;
      });
    },
    loadData: function loadData(objectId) {
      var _this2 = this;

      console.log('loadData', objectId);
      this.isloading = true;
      this.data.length = 0;
      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/init/admin',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: {
          objectId: objectId
        }
      }).then(function (response) {
        if (response.data.error) {
          console.log('ERRORWS');
          _this2.openNotificationWithType('danger', '', response.data.error);
        } else {
          response.data.objects.map(function (o) {
            o.defArrivalTime = new Date(o.defArrivalTime);
            o.defDepartureTime = new Date(o.defDepartureTime);
            console.log(o);
            return o;
          });
          _this2.$set(_this2, 'initResponse', response.data);
        }
        _this2.isloading = false;
      }).catch(function (error) {
        _this2.isloading = false;
        _this2.openNotificationWithType('danger', '', error.error || error);
      });
    }
  },
  computed: {},
  mounted: function mounted() {
    // this.loadData();
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = __webpack_require__(0);
/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		value: ''
	},
	computed: {
		dateFormat: function dateFormat() {
			return moment(this.value).format('DD.MM.YYYY');
		},
		timeFormat: function timeFormat() {
			return moment(this.value).format('HH:mm');
		}
	},
	mounted: function mounted() {
		// console.log('sdfsdf')
	}
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var NotificationComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a
  },
  data: function data() {
    return {
      data: {
        messages: {
          email: ''
        }
      },
      initResponse: {},
      param: {},
      isloading: false,
      form: {
        email: null
      }

    };
  },

  methods: {
    openNotificationWithType: function openNotificationWithType(type, title, message) {
      openNotification({
        title: title,
        message: message,
        type: type
      });
    },
    saveData: function saveData() {
      var _this = this;

      this.isloading = true;
      // this.data.length = 0
      this.$http({
        method: 'post',
        url: 'https://iridi.com/customer/auth/forgot_password.php',
        data: this.form
      }).then(function (response) {
        _this.changed = false;
        _this.data = response.data;
        _this.isloading = false;
        if (response.data.status === 'success') {
          _this.openNotificationWithType('success', '', _this.$t('index.profile.password_reset_success'));
          _this.$parent.close();
        }
      }).catch(function (error) {
        console.log(error);
        _this.isloading = false;
        _this.changed = false;
      });
    }
  },
  computed: {},
  mounted: function mounted() {}
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['objectId', 'fields', 'errors', 'objName'],
  data: function data() {
    return {
      importType: 1,
      isConfirm: false,
      loading: false,
      resultFields: this.fields,
      importErrors: []
    };
  },

  methods: {
    headRooms: function headRooms(fields) {
      return fields[0].map(function (f) {
        return {
          label: f.name,
          field: f.name
        };
      });
    },
    bodyRooms: function bodyRooms(fields) {
      return fields.map(function (f) {
        return f.reduce(function (p, c) {
          p[c.name] = c.value;
          return p;
        }, {});
      });
    },
    importFileds: function importFileds() {
      var _this = this;

      this.loading = true;
      this.isConfirm = false;
      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/object/settings/import',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: {
          objectId: this.objectId,
          fields: this.fields,
          importType: parseInt(this.importType)
        }
      }).then(function (response) {
        _this.loading = false;

        if (response.data.status) {
          _this.importErrors = response.data.errors;
          // this.$toast.open({
          //   message: response.data.error,
          //   position: 'is-bottom-right',
          //   type: 'is-danger',
          //   container: 'div.modal-card'
          // });
        } else {
          _this.$parent.close();
          _this.$emit('import_fields', {
            objectId: _this.objectId,
            fields: _this.fields
          });
        }
      }).catch(function (error) {
        _this.loading = false;
        _this.importErrors = response.data.errors;
        _this.$toast.open({
          message: error,
          position: 'is-bottom-right',
          type: 'is-danger',
          container: 'div.modal-card'
        });
      });
    }
  },
  computed: {}
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__FDateTime_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_input_facade__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_input_facade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_input_facade__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var today = new Date();
var moment = __webpack_require__(5);

// import Cleave from 'vue-cleave-component';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FDateTime: __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue___default.a,
    InputFacade: __WEBPACK_IMPORTED_MODULE_1_vue_input_facade__["InputFacade"]
    // Cleave
  },
  directives: { facade: __WEBPACK_IMPORTED_MODULE_1_vue_input_facade__["facade"] },
  filters: { facade: __WEBPACK_IMPORTED_MODULE_1_vue_input_facade__["filter"] },
  props: ['objIndx', 'objData'],
  data: function data() {
    return {
      obj: null,
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1),
      fields: [],
      isloading: false,
      phoneFormat: ''
    };
  },

  computed: {
    validate: function validate() {
      if (!this.obj) return false;
      if (!this.obj.newKeyValues.configurationId) {
        return false;
      }

      if (this.obj.newKeyValues.limitType == 2) {
        var frequency = parseInt(this.obj.newKeyValues.frequencyCheckPeriod);
        if (Number.isNaN(frequency) || frequency <= 0 || frequency > 30) {
          return false;
        }
      }

      if (this.phoneFormat.length < 11) {
        return false;
      }

      return true;
    }
  },
  beforeMount: function beforeMount() {
    this.obj = this.objData;
    this.obj.newKeyValues.limitType = 2;
    this.obj.newKeyValues.frequencyCheckPeriod = 30;
    this.obj.newKeyValues.phone = '+7 (';
  },

  methods: {
    onInput: function onInput(event) {
      // if (event.target.unmaskedValue.length <= 2) {
      //   event.target.unmaskedValue = ''
      // }
      this.phoneFormat = event.target.unmaskedValue;
    },
    setCustomValue: function setCustomValue(event, curField, indexField) {
      this.$set(this.fields[indexField], 'defVal', curField.devValue === event);
    },
    selectRoom: function selectRoom(confId) {
      var _this = this;

      var _obj$configurations$f = this.obj.configurations.filter(function (c) {
        return c.id === confId;
      }),
          _obj$configurations$f2 = _slicedToArray(_obj$configurations$f, 1),
          roomData = _obj$configurations$f2[0];
      // console.log(event);


      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/roomfields/get',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: roomData
      }).then(function (response) {
        if (response.data.status) {
          console.error(response.data.error);
        } else {
          _this.fields = response.data.fields.map(function (f) {
            f.devValue = f.value;
            f.defVal = true;
            return f;
          }).filter(function (f) {
            return f.type === 1;
          });
        }
      }).catch(function (error) {
        console.error(error);
      });
    },
    onchangeDateLifeFrom: function onchangeDateLifeFrom(data, object, objIndex) {
      if (object.defArrivalTime && data.getHours() === 0 && data.getMinutes() === 0) {
        var defArrivalTime = new Date(object.defArrivalTime);
        data.setHours(defArrivalTime.getHours(), defArrivalTime.getMinutes(), 0);
        this.$set(this.initResponse.objects[objIndex].newKeyValues, 'dateLifeFrom', data);
      }
    },
    onchangeDateLifeTo: function onchangeDateLifeTo(data, object, objIndex) {
      if (object.defDepartureTime && data.getHours() === 0 && data.getMinutes() === 0) {
        var defDepartureTime = new Date(object.defDepartureTime);
        data.setHours(defDepartureTime.getHours(), defDepartureTime.getMinutes(), 0);
        this.$set(this.initResponse.objects[objIndex].newKeyValues, 'dateLifeTo', data);
      }
    },
    getFreeConfigurations: function getFreeConfigurations(object) {
      // collecting busy configs
      if (object.multyTokensConfig) {
        return object.configurations;
      }

      var lockedConfigs = object.tokens.reduce(function (prev, cur) {
        if (cur.active) {
          prev.push(cur.Configuration.id);
        }
        return prev;
      }, []);
      // exclude busy configs from aviable list
      return object.configurations.filter(function (conf) {
        return lockedConfigs.indexOf(conf.id) == -1;
      });
    },
    addNewKey: function addNewKey(objIndex, objectData) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _data, response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.isloading = true;
                _context.next = 4;
                return _this2.$http({
                  method: 'post',
                  url: _this2.$backendHost + '/frontend/api/keys/add',
                  transformResponse: [function (data) {
                    return JSON.parse(data);
                  }],
                  data: (_data = {
                    timezone: moment.tz.guess(),
                    comment: objectData.newKeyValues.comment || '',
                    clientName: objectData.newKeyValues.clientName || ''
                  }, _defineProperty(_data, 'comment', objectData.newKeyValues.comment || ''), _defineProperty(_data, 'phone', _this2.phoneFormat), _defineProperty(_data, 'configurationId', objectData.newKeyValues.configurationId), _defineProperty(_data, 'objectId', objectData.newKeyValues.objectId), _defineProperty(_data, 'limit', 0), _defineProperty(_data, 'dateLifeFrom', objectData.newKeyValues.dateLifeFrom.getTime()), _defineProperty(_data, 'sessionTime', !objectData.newKeyValues.sessionTimeOption ? null : objectData.newKeyValues.sessionTimeValue), _defineProperty(_data, 'limitType', objectData.newKeyValues.limitType || 1), _defineProperty(_data, 'frequencyCheckPeriod', objectData.newKeyValues.frequencyCheckPeriod || null), _defineProperty(_data, 'activationsCount', objectData.newKeyValues.activationsCount || null), _defineProperty(_data, 'fields', _this2.fields), _data)
                });

              case 4:
                response = _context.sent;

                if (!response.data.status) {
                  _context.next = 9;
                  break;
                }

                _this2.$toast.open({
                  message: response.data.error,
                  position: 'is-bottom-right',
                  type: 'is-error',
                  container: 'div.modal-card'
                });
                _this2.isloading = false;
                return _context.abrupt('return');

              case 9:

                _this2.$emit('init_response_push', {
                  objIndex: objIndex,
                  tokenData: response.data.tokenData
                });

                // this.$emit('init_load_data');

                _this2.$parent.close();

                if (objectData.showQrCode) {
                  // show qr imidiately
                  _this2.$emit('show_qr', {
                    objIndex: objIndex,
                    tokenData: response.data.tokenData
                  });
                }
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](0);

                _this2.$toast.open({
                  message: _context.t0,
                  position: 'is-bottom-right',
                  type: 'is-error',
                  container: 'div.modal-card'
                });

              case 17:
                _this2.isloading = false;

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 14]]);
      }))();
    }
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__FDateTime_vue__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var today = new Date();
var moment = __webpack_require__(5);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FDateTime: __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue___default.a
  },
  props: ['objIndx', 'objData'],
  data: function data() {
    return {
      obj: this.objData,
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1),
      fields: [],
      isloading: false
    };
  },

  computed: {
    validate: function validate() {
      if (!this.obj.newKeyValues.configurationId) {
        return false;
      }

      if (this.obj.newKeyValues.limitType == 2) {
        var frequency = parseInt(this.obj.newKeyValues.frequencyCheckPeriod);
        if (Number.isNaN(frequency) || frequency <= 0 || frequency > 7) {
          return false;
        }
      }

      if (this.obj.newKeyValues.limitType == 1) {
        if (this.obj.newKeyValues.sessionTimeOption) {
          var sess = parseInt(this.obj.newKeyValues.sessionTimeValue);

          if (Number.isNaN(sess) || sess <= 0 || sess > 43200) {
            return false;
          }
        }
      }
      return true;
    }
  },
  methods: {
    setCustomValue: function setCustomValue(event, curField, indexField) {
      this.$set(this.fields[indexField], 'defVal', curField.devValue === event);
    },
    selectRoom: function selectRoom(confId) {
      var _this = this;

      var _obj$configurations$f = this.obj.configurations.filter(function (c) {
        return c.id === confId;
      }),
          _obj$configurations$f2 = _slicedToArray(_obj$configurations$f, 1),
          roomData = _obj$configurations$f2[0];
      // console.log(event);


      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/roomfields/get',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: roomData
      }).then(function (response) {
        if (response.data.status) {
          console.error(response.data.error);
        } else {
          _this.fields = response.data.fields.map(function (f) {
            f.devValue = f.value;
            f.defVal = true;
            return f;
          }).filter(function (f) {
            return f.type === 1;
          });
        }
      }).catch(function (error) {
        console.error(error);
      });
    },
    onchangeDateLifeFrom: function onchangeDateLifeFrom(data, object, objIndex) {
      if (object.defArrivalTime && data.getHours() === 0 && data.getMinutes() === 0) {
        var defArrivalTime = new Date(object.defArrivalTime);
        data.setHours(defArrivalTime.getHours(), defArrivalTime.getMinutes(), 0);
        this.$set(this.initResponse.objects[objIndex].newKeyValues, 'dateLifeFrom', data);
      }
    },
    onchangeDateLifeTo: function onchangeDateLifeTo(data, object, objIndex) {
      if (object.defDepartureTime && data.getHours() === 0 && data.getMinutes() === 0) {
        var defDepartureTime = new Date(object.defDepartureTime);
        data.setHours(defDepartureTime.getHours(), defDepartureTime.getMinutes(), 0);
        this.$set(this.initResponse.objects[objIndex].newKeyValues, 'dateLifeTo', data);
      }
    },
    getFreeConfigurations: function getFreeConfigurations(object) {
      // collecting busy configs
      if (object.multyTokensConfig) {
        return object.configurations;
      }

      var lockedConfigs = object.tokens.reduce(function (prev, cur) {
        if (cur.active) {
          prev.push(cur.Configuration.id);
        }
        return prev;
      }, []);
      // exclude busy configs from aviable list
      return object.configurations.filter(function (conf) {
        return lockedConfigs.indexOf(conf.id) == -1;
      });
    },
    syncToBitrix: function syncToBitrix(token, tokenData) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, responseBitrix, responseEdit;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                data = _this2.obj.newKeyValues;

                _this2.obj.configurations.forEach(function (element) {
                  if (element.id === _this2.obj.newKeyValues.configurationId) {
                    data.configuration = element;
                  }
                });
                data.token = tokenData.key;

                _context.next = 6;
                return _this2.$http({
                  method: 'post',
                  url: 'https://iridi.com/customer/api_byod/?act=create_right',
                  data: data
                });

              case 6:
                responseBitrix = _context.sent;

                if (!(responseBitrix.data.status !== 'success')) {
                  _context.next = 10;
                  break;
                }

                _this2.$toast.open({
                  message: _this2.$t('index.' + responseBitrix.data.code),
                  position: 'is-bottom-right',
                  type: 'is-error',
                  container: 'div.modal-card'
                });

                return _context.abrupt('return', false);

              case 10:
                _context.next = 12;
                return _this2.$http({
                  method: 'post',
                  url: _this2.$backendHost + '/frontend/api/keys/edit',
                  transformResponse: [function (data) {
                    return JSON.parse(data);
                  }],
                  data: {
                    timezone: moment.tz.guess(),
                    keyId: tokenData.id,
                    objectId: tokenData.objectId,
                    values: {
                      bxRightId: responseBitrix.data.bxRightId
                    }
                  }
                });

              case 12:
                responseEdit = _context.sent;


                if (responseEdit.data.status) {
                  _this2.$toast.open({
                    message: responseEdit.data.error,
                    position: 'is-bottom-right',
                    type: 'is-error',
                    container: 'div.modal-card'
                  });
                }

                tokenData.bxRightId = responseBitrix.data.bxRightId;

                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](0);

                _this2.$toast.open({
                  message: _context.t0,
                  position: 'is-bottom-right',
                  type: 'is-error',
                  container: 'div.modal-card'
                });

              case 20:
                return _context.abrupt('return', tokenData);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 17]]);
      }))();
    },
    addNewKey: function addNewKey(objIndex, objectData) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, synced;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this3.isloading = true;
                _context2.next = 4;
                return _this3.$http({
                  method: 'post',
                  url: _this3.$backendHost + '/frontend/api/keys/add',
                  transformResponse: [function (data) {
                    return JSON.parse(data);
                  }],
                  data: {
                    timezone: moment.tz.guess(),
                    comment: objectData.newKeyValues.comment || '',
                    clientName: objectData.newKeyValues.clientName || '',
                    email: objectData.newKeyValues.email,
                    configurationId: objectData.newKeyValues.configurationId,
                    objectId: objectData.newKeyValues.objectId,
                    limit: 1,
                    dateLifeTo: objectData.newKeyValues.dateLifeTo.getTime(),
                    dateLifeFrom: objectData.newKeyValues.dateLifeFrom.getTime(),
                    sessionTime: !objectData.newKeyValues.sessionTimeOption ? null : objectData.newKeyValues.sessionTimeValue,

                    limitType: objectData.newKeyValues.limitType || 1,
                    frequencyCheckPeriod: objectData.newKeyValues.frequencyCheckPeriod || null,
                    activationsCount: objectData.newKeyValues.activationsCount || null,

                    fields: _this3.fields
                  }
                });

              case 4:
                response = _context2.sent;

                if (!response.data.status) {
                  _context2.next = 9;
                  break;
                }

                _this3.$toast.open({
                  message: response.data.error,
                  position: 'is-bottom-right',
                  type: 'is-error',
                  container: 'div.modal-card'
                });
                _this3.isloading = false;
                return _context2.abrupt('return');

              case 9:
                if (!(_this3.obj.newKeyValues.proLogin && _this3.obj.newKeyValues.email)) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 12;
                return _this3.syncToBitrix(response.data.token, response.data.tokenData);

              case 12:
                synced = _context2.sent;

                if (synced) {
                  response.data.tokenData = synced;
                }

              case 14:

                _this3.$emit('init_response_push', {
                  objIndex: objIndex,
                  tokenData: response.data.tokenData
                });

                // this.$emit('init_load_data');

                _this3.$parent.close();

                if (objectData.showQrCode) {
                  // show qr imidiately
                  _this3.$emit('show_qr', {
                    objIndex: objIndex,
                    tokenData: response.data.tokenData
                  });
                }
                _context2.next = 22;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](0);

                _this3.$toast.open({
                  message: _context2.t0,
                  position: 'is-bottom-right',
                  type: 'is-error',
                  container: 'div.modal-card'
                });

              case 22:
                _this3.isloading = false;

              case 23:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 19]]);
      }))();
    }
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__FDateTime_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['roomData'],
  data: function data() {
    return {
      validateCustomFieldError: false,
      resultFields: [],
      roomFieldId: 0,
      configFields: []
    };
  },

  methods: {
    getFields: function getFields() {
      var _this = this;

      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/roomfields/get',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: this.roomData
      }).then(function (response) {
        if (response.data.status) {
          console.error(response.data.error);
          _this.$snackbar.open({
            message: response.data.error,
            type: 'is-warning',
            position: 'is-bottom-right',
            actionText: 'Add fields',
            indefinite: true,
            container: 'div.modal-card',
            onAction: function onAction() {
              _this.$emit('create_config_fields', _this.roomData);
              _this.$parent.close();
            }
          });
        } else {
          _this.resultFields = response.data.fields;
          _this.configFields = response.data.configFields;
          _this.roomFieldId = response.data.roomFieldId;
          console.log(response.data);
        }
      }).catch(function (error) {
        console.error(error);
      });
    },
    setCustomValue: function setCustomValue(event, curField, indexField) {
      var defVal = false;
      this.configFields.filter(function (f) {
        return f.name == curField.name;
      }).map(function (f) {
        defVal = f.value == event;
      });
      this.resultFields[indexField].defVal = defVal;
    },
    isEditable: function isEditable(name) {
      //console.log(name);
      switch (name) {
        case 'Configuration':
          return true;

        default:
          return false;
      }
    },
    deleteField: function deleteField(row) {
      this.resultFields.splice(this.resultFields.findIndex(function (item) {
        return item.name === row.name;
      }), 1);
    },
    saveFileds: function saveFileds() {
      var _this2 = this;

      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/roomfields/save',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: {
          id: this.roomData.id,
          objectId: this.roomData.objectId,
          fields: this.resultFields,
          roomFieldId: this.roomFieldId
        }
      }).then(function (response) {
        if (response.data.status) {
          _this2.openNotificationWithType('danger', '', response.data.error);
        } else {
          if (response.data.fields) {
            _this2.getFields();
            _this2.$toast.open({
              message: _this2.$t('index.succesfully_saved'),
              position: 'is-bottom-right',
              type: 'is-success',
              container: 'div.modal-card'
            });
          }
        }
      }).catch(function (error) {
        _this2.openNotificationWithType('danger', '', error);
      });
    },
    resetField: function resetField(field) {
      var _this3 = this;

      var deleteField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.$dialog.confirm({
        type: deleteField ? 'is-danger' : 'is-warning',
        message: deleteField ? this.$t('index.delete_this_field') : this.$t('index.reset_this_field'),
        onConfirm: function onConfirm() {
          _this3.$http({
            method: 'post',
            url: _this3.$backendHost + '/frontend/api/roomfields/reset',
            transformResponse: [function (data) {
              return JSON.parse(data);
            }],
            data: {
              roomData: _this3.roomData,
              field: field,
              roomFieldId: _this3.roomFieldId,
              deleteField: deleteField
            }
          }).then(function (response) {
            if (response.data.status) {
              // console.error(response.data.error);
              _this3.$snackbar.open({
                message: response.data.error,
                type: 'is-danger',
                position: 'is-bottom-right',
                actionText: 'Delete it',
                indefinite: true,
                container: 'div.modal-card',
                onAction: function onAction() {
                  // this.$parent.close();
                  _this3.resetField(field, true);
                }
              });
            } else {
              if (response.data.fields) {
                _this3.getFields();
                _this3.$toast.open({
                  message: deleteField ? _this3.$t('index.field_successfully_deleted') : _this3.$t('index.field_successfully_reseted'),
                  position: 'is-bottom-right',
                  type: 'is-success',
                  container: 'div.modal-card'
                });
              }
            }
          }).catch(function (error) {
            console.error(error);
          });
        }
      });
    }
  },
  computed: {},
  mounted: function mounted() {
    this.getFields();
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__FDateTime_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var today = new Date();
var moment = __webpack_require__(5);
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['objectId', 'tagName', 'fields', 'roomData'],
  components: {
    FDateTime: __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue___default.a
  },
  data: function data() {
    return {
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1),
      validateCustomFieldError: false,
      resultFields: this.fields,
      checkedAvailableFields: [],
      columnsAvailableFields: [{
        field: 'name',
        label: 'Name'
      }, {
        field: 'type',
        label: 'Type'
      }],
      availableFieldsBase: [{
        name: 'Configuration',
        defVal: true,
        type: 0
      }, {
        name: 'ArrivalDateTime',
        defVal: true,
        type: 0
      }, {
        name: 'DepartureDateTime',
        defVal: true,
        type: 0
      }, {
        name: 'SessionTime',
        defVal: true,
        type: 0
      }, {
        name: 'Email',
        defVal: true,
        type: 0
      }, {
        name: 'Custom',
        defVal: true,
        type: 1
      }],
      isShowAvailableFields: false,
      erroredFiedls: {}
    };
  },

  methods: {
    isEditable: function isEditable(name) {
      console.log(name);
      switch (name) {
        case 'Configuration':
          return true;

        default:
          return false;
      }
    },
    validateCustomType: function validateCustomType(event, id) {
      var re = /^[a-zA-Z0-9_-]*$/i;
      var duplicate = false;
      var errored = !re.test(String(event).toLowerCase());

      if (!errored) {
        duplicate = this.resultFields.filter(function (f) {
          return f.name === event;
        }).length > 1;
      }

      this.$set(this.erroredFiedls, id, errored || duplicate);
      this.validateCustomFieldError = false;
      for (var key in this.erroredFiedls) {
        if (this.erroredFiedls.hasOwnProperty(key)) {
          if (this.erroredFiedls[key]) {
            this.validateCustomFieldError = true;
          }
        }
      }
    },
    deleteField: function deleteField(row) {
      this.resultFields.splice(this.resultFields.findIndex(function (item) {
        return item.name === row.name;
      }), 1);
    },
    existField: function existField(field) {
      if (field.type === 1) return false;
      return this.resultFields.filter(function (f) {
        return f.name == field.name;
      }).length;
    },
    saveFileds: function saveFileds() {
      var _this = this;

      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/tagfields/save',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: {
          tagName: this.tagName,
          objectId: this.objectId,
          fields: this.resultFields
        }
      }).then(function (response) {
        if (response.data.status) {
          _this.openNotificationWithType('danger', '', response.data.error);
        } else {
          _this.$parent.close();
          if (_this.roomData) {
            _this.$emit('create_room_fields', _this.roomData);
          }
          // console.log(response.data);
        }
      }).catch(function (error) {
        _this.openNotificationWithType('danger', '', error);
      });
    },
    addFiled: function addFiled() {
      var _this2 = this;

      this.checkedAvailableFields.forEach(function (af) {
        if (!_this2.existField(af)) {
          var defValue = '';
          var canEdit = true;
          var departureDate = new Date();
          departureDate.setDate(departureDate.getDate() + 7);

          switch (af.name) {
            case 'Configuration':
              defValue = _this2.tagName;
              canEdit = false;
              break;
            case 'Email':
            case 'ArrivalDateTime':
            case 'DepartureDateTime':
            case 'SessionTime':
              break;

            default:
              defValue = 'default value';
              break;
          }

          _this2.resultFields.push({
            name: af.type === 1 ? 'Custom_' + Math.floor(Date.now()) : af.name,
            type: af.type,
            value: defValue,
            edit: canEdit,
            defVal: true
          });
        }
      });

      this.isShowAvailableFields = false;
      this.checkedAvailableFields = [];
    },
    showAvailableFields: function showAvailableFields() {
      if (this.availableFields.length === 1) {
        this.resultFields.push({
          name: 'Custom_' + Math.floor(Date.now()),
          type: 1,
          value: 'default value',
          edit: true,
          defVal: true
        });
      } else {
        this.isShowAvailableFields = true;
      }
    }
  },
  computed: {
    availableFields: function availableFields() {
      var _this3 = this;

      return this.availableFieldsBase.filter(function (f) {
        return _this3.resultFields.reduce(function (p, c) {
          if (c.type !== 1) {
            p.push(c.name);
          }
          return p;
        }, []).indexOf(f.name) < 0;
      });
    }
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__FDateTime_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_input_facade__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_input_facade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_input_facade__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var today = new Date();
var moment = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FDateTime: __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue___default.a,
    InputFacade: __WEBPACK_IMPORTED_MODULE_1_vue_input_facade__["InputFacade"]
  },
  directives: { facade: __WEBPACK_IMPORTED_MODULE_1_vue_input_facade__["facade"] },
  filters: { facade: __WEBPACK_IMPORTED_MODULE_1_vue_input_facade__["filter"] },
  props: ['objIndx', 'objData', 'tokenIndex', 'tokenVal'],
  data: function data() {
    return {
      obj: this.objData,
      localTokenVal: this.tokenVal,
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1),
      fields: [],
      roomFields: [],
      isLoading: false,
      isloadingUpdate: false,
      phoneFormat: '',
      cleaveMask: {
        phone: {
          prefix: '+',
          delimiters: [' (', ') ', ' '],
          blocks: [2, 3, 3, 4],
          numericOnly: true,
          rawValueTrimPrefix: true
        }
      }
    };
  },

  computed: {
    validate: function validate() {
      if (!this.localTokenVal.editKeyValues.configurationId) {
        return false;
      }

      if (this.localTokenVal.editKeyValues.limitType == 2) {
        var frequency = parseInt(this.localTokenVal.editKeyValues.frequencyCheckPeriod);
        if (Number.isNaN(frequency) || frequency <= 0 || frequency > 30) {
          return false;
        }
      }

      if (this.localTokenVal.editKeyValues.limitType == 1) {
        if (this.localTokenVal.editKeyValues.sessionTimeOption) {
          var sess = parseInt(this.localTokenVal.editKeyValues.sessionTimeValue);

          if (Number.isNaN(sess) || sess <= 0 || sess > 43200) {
            return false;
          }
        }
      }
      return true;
    }
  },
  methods: {
    onInput: function onInput(event) {
      this.phoneFormat = event.target.unmaskedValue;
      console.log(event);
    },
    setCustomValue: function setCustomValue(event, curField, indexField) {
      this.$set(this.fields[indexField], 'defVal', this.roomFields[indexField].value === event);
    },
    selectRoom: function selectRoom(confId) {
      var _this = this;

      this.isLoading = true;
      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/tokensfields/get',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: {
          configurationId: this.localTokenVal.editKeyValues.configurationId,
          objectId: this.localTokenVal.objectId,
          tokenId: this.localTokenVal.id
        }
      }).then(function (response) {
        _this.isLoading = false;
        if (response.data.status) {
          console.error(response.data.error);
        } else {
          if (response.data.roomFields) {
            _this.roomFields = response.data.roomFields.filter(function (f) {
              return f.type === 1;
            });
          }
          if (response.data.fields) {
            _this.fields = response.data.fields.filter(function (f) {
              return f.type === 1;
            }).map(function (f, i) {
              f.defVal = response.data.fields[i].value === _this.roomFields[i].value;
              return f;
            });
          }
        }
      }).catch(function (error) {
        _this.isLoading = false;
        console.error(error);
      });
    },
    editKey: function editKey() {
      var _this2 = this;

      var deactivate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.isloadingUpdate = true;
                _context.prev = 1;
                _context.next = 4;
                return _this2.$http({
                  method: 'post',
                  url: _this2.$backendHost + '/frontend/api/keys/edit',
                  transformResponse: [function (data) {
                    return JSON.parse(data);
                  }],
                  data: {
                    timezone: moment.tz.guess(),
                    keyId: _this2.localTokenVal.id,
                    objectId: _this2.localTokenVal.objectId,
                    values: {
                      // deactivated: this.localTokenVal.editKeyValues.deactivated,
                      deactivated: deactivate,
                      comment: _this2.localTokenVal.editKeyValues.comment || '',
                      clientName: _this2.localTokenVal.editKeyValues.clientName,
                      email: _this2.localTokenVal.editKeyValues.email,
                      // phone: this.localTokenVal.editKeyValues.phone,
                      phone: _this2.phoneFormat,
                      limit: 1,
                      dateLifeFrom: _this2.localTokenVal.editKeyValues.dateLifeFrom.getTime(),
                      configurationId: _this2.localTokenVal.editKeyValues.configurationId,
                      sessionTime: !_this2.localTokenVal.editKeyValues.sessionTimeOption ? null : _this2.localTokenVal.editKeyValues.sessionTimeValue,

                      limitType: _this2.localTokenVal.editKeyValues.limitType,
                      frequencyCheckPeriod: parseInt(_this2.localTokenVal.editKeyValues.frequencyCheckPeriod) || null,
                      activationsCount: parseInt(_this2.localTokenVal.editKeyValues.activationsCount) || null,

                      fields: _this2.fields
                    }
                  }
                });

              case 4:
                response = _context.sent;

                if (!response.data.status) {
                  _context.next = 9;
                  break;
                }

                _this2.$toast.open({
                  message: response.data.error,
                  position: 'is-bottom-right',
                  type: 'is-error',
                  container: 'div.modal-card'
                });
                _this2.isloadingUpdate = false;
                return _context.abrupt('return');

              case 9:

                _this2.$emit('init_response_update', {
                  objIndex: _this2.objIndx,
                  tokIndex: _this2.tokenIndex,
                  tokenData: response.data.tokenData
                });

                _this2.$parent.close();
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](1);

                _this2.$toast.open({
                  message: _context.t0,
                  position: 'is-bottom-right',
                  type: 'is-error',
                  container: 'div.modal-card'
                });

              case 16:
                _this2.isloadingUpdate = false;

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 13]]);
      }))();
    }
  },
  mounted: function mounted() {
    this.$refs.legacyInput.$el.children[0].value = this.tokenVal.editKeyValues.phone;
    this.$refs.legacyInput.$el.children[0].dispatchEvent(new Event('input'));
    this.selectRoom(this.tokenVal.configurationId);
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__FDateTime_vue__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var today = new Date();
var moment = __webpack_require__(5);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    FDateTime: __WEBPACK_IMPORTED_MODULE_0__FDateTime_vue___default.a
  },
  props: ['objIndx', 'objData', 'tokenIndex', 'tokenVal'],
  data: function data() {
    return {
      obj: this.objData,
      localTokenVal: this.tokenVal,
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1),
      fields: [],
      roomFields: [],
      isLoading: false,
      isloadingUpdate: false
    };
  },

  computed: {
    validate: function validate() {
      if (!this.localTokenVal.editKeyValues.configurationId) {
        return false;
      }

      if (this.localTokenVal.editKeyValues.limitType == 2) {
        var frequency = parseInt(this.localTokenVal.editKeyValues.frequencyCheckPeriod);
        if (Number.isNaN(frequency) || frequency <= 0 || frequency > 7) {
          return false;
        }
      }

      if (this.localTokenVal.editKeyValues.limitType == 1) {
        if (this.localTokenVal.editKeyValues.sessionTimeOption) {
          var sess = parseInt(this.localTokenVal.editKeyValues.sessionTimeValue);

          if (Number.isNaN(sess) || sess <= 0 || sess > 43200) {
            return false;
          }
        }
      }
      return true;
    }
  },
  methods: {
    setCustomValue: function setCustomValue(event, curField, indexField) {
      this.$set(this.fields[indexField], 'defVal', this.roomFields[indexField].value === event);
    },
    selectRoom: function selectRoom(confId) {
      var _this = this;

      this.isLoading = true;
      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/tokensfields/get',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: {
          configurationId: this.localTokenVal.editKeyValues.configurationId,
          objectId: this.localTokenVal.objectId,
          tokenId: this.localTokenVal.id
        }
      }).then(function (response) {
        _this.isLoading = false;
        if (response.data.status) {
          console.error(response.data.error);
        } else {
          if (response.data.roomFields) {
            _this.roomFields = response.data.roomFields.filter(function (f) {
              return f.type === 1;
            });
          }
          if (response.data.fields) {
            _this.fields = response.data.fields.filter(function (f) {
              return f.type === 1;
            }).map(function (f, i) {
              f.defVal = response.data.fields[i].value === _this.roomFields[i].value;
              return f;
            });
          }
        }
      }).catch(function (error) {
        _this.isLoading = false;
        console.error(error);
      });
    },
    editKey: function editKey() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, data, responseBitrix;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.isloadingUpdate = true;
                _context.prev = 1;
                _context.next = 4;
                return _this2.$http({
                  method: 'post',
                  url: _this2.$backendHost + '/frontend/api/keys/edit',
                  transformResponse: [function (data) {
                    return JSON.parse(data);
                  }],
                  data: {
                    timezone: moment.tz.guess(),
                    keyId: _this2.localTokenVal.id,
                    objectId: _this2.localTokenVal.objectId,
                    values: {
                      deactivated: _this2.localTokenVal.editKeyValues.deactivated,
                      comment: _this2.localTokenVal.editKeyValues.comment,
                      clientName: _this2.localTokenVal.editKeyValues.clientName,
                      email: _this2.localTokenVal.editKeyValues.email,
                      limit: 1,
                      dateLifeFrom: _this2.localTokenVal.editKeyValues.dateLifeFrom.getTime(),
                      dateLifeTo: _this2.localTokenVal.editKeyValues.dateLifeTo.getTime(),
                      configurationId: _this2.localTokenVal.editKeyValues.configurationId,
                      sessionTime: !_this2.localTokenVal.editKeyValues.sessionTimeOption ? null : _this2.localTokenVal.editKeyValues.sessionTimeValue,

                      limitType: _this2.localTokenVal.editKeyValues.limitType,
                      frequencyCheckPeriod: parseInt(_this2.localTokenVal.editKeyValues.frequencyCheckPeriod) || null,
                      activationsCount: parseInt(_this2.localTokenVal.editKeyValues.activationsCount) || null,

                      fields: _this2.fields
                    }
                  }
                });

              case 4:
                response = _context.sent;

                if (!response.data.status) {
                  _context.next = 9;
                  break;
                }

                _this2.$toast.open({
                  message: response.data.error,
                  position: 'is-bottom-right',
                  type: 'is-error',
                  container: 'div.modal-card'
                });
                _this2.isloadingUpdate = false;
                return _context.abrupt('return');

              case 9:
                if (!_this2.tokenVal.bxRightId) {
                  _context.next = 22;
                  break;
                }

                data = _this2.localTokenVal.editKeyValues;


                _this2.obj.configurations.forEach(function (element) {
                  if (element.id === _this2.localTokenVal.editKeyValues.configurationId) {
                    data.configuration = element;
                  }
                });
                data.bxRightId = _this2.tokenVal.bxRightId;
                data.objectId = _this2.tokenVal.objectId;

                _context.next = 16;
                return _this2.$http({
                  method: 'post',
                  url: 'https://iridi.com/customer/api_byod/?act=edit_right',
                  data: data
                });

              case 16:
                responseBitrix = _context.sent;

                if (!(responseBitrix.data.status !== 'success')) {
                  _context.next = 22;
                  break;
                }

                _this2.$toast.open({
                  message: _this2.$t('index.' + responseBitrix.data.code),
                  position: 'is-bottom-right',
                  type: 'is-error',
                  container: 'div.modal-card'
                });

                if (_this2.localTokenVal.editKeyValues.deactivated) {
                  _context.next = 22;
                  break;
                }

                _this2.isloadingUpdate = false;
                return _context.abrupt('return');

              case 22:

                _this2.$emit('init_response_update', {
                  objIndex: _this2.objIndx,
                  tokIndex: _this2.tokenIndex,
                  tokenData: response.data.tokenData
                });

                _this2.$parent.close();
                _context.next = 29;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context['catch'](1);

                _this2.$toast.open({
                  message: _context.t0,
                  position: 'is-bottom-right',
                  type: 'is-error',
                  container: 'div.modal-card'
                });

              case 29:
                _this2.isloadingUpdate = false;

              case 30:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 26]]);
      }))();
    }
  },
  mounted: function mounted() {
    this.selectRoom(this.tokenVal.configurationId);
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_tabs__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mini_components_FDateTime_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mini_components_FDateTime_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__mini_components_FDateTime_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mini_components_Registertoken_vue__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mini_components_Registertoken_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__mini_components_Registertoken_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mini_components_Updatetoken_vue__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mini_components_Updatetoken_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__mini_components_Updatetoken_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mini_components_Registermauth_vue__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mini_components_Registermauth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__mini_components_Registermauth_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mini_components_Updatemauth_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mini_components_Updatemauth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__mini_components_Updatemauth_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_buefy__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_qrcode_component__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_qrcode_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_qrcode_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_input_facade__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_input_facade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_input_facade__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var moment = __webpack_require__(5);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_buefy___default.a, {
  defaultIconPack: 'fas'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('qr-code', __WEBPACK_IMPORTED_MODULE_10_vue_qrcode_component___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_buefy___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a);

var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Tabs: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_tabs__["a" /* Tabs */],
    TabPane: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_tabs__["b" /* TabPane */],
    Collapse: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_collapse__["Item"],
    Notification: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a,
    FDateTime: __WEBPACK_IMPORTED_MODULE_4__mini_components_FDateTime_vue___default.a,
    Registertoken: __WEBPACK_IMPORTED_MODULE_5__mini_components_Registertoken_vue___default.a,
    Updatetoken: __WEBPACK_IMPORTED_MODULE_6__mini_components_Updatetoken_vue___default.a,
    Registermauth: __WEBPACK_IMPORTED_MODULE_7__mini_components_Registermauth_vue___default.a,
    Updatemauth: __WEBPACK_IMPORTED_MODULE_8__mini_components_Updatemauth_vue___default.a,
    InputFacade: __WEBPACK_IMPORTED_MODULE_11_vue_input_facade__["InputFacade"]
  },
  directives: { facade: __WEBPACK_IMPORTED_MODULE_11_vue_input_facade__["facade"] },
  filters: { facade: __WEBPACK_IMPORTED_MODULE_11_vue_input_facade__["filter"] },
  data: function data() {
    var today = new Date();

    return {
      showRightModal: false,
      popupIsShowing: false,
      data: {},
      initResponse: {},
      param: {},
      isloading: false,
      showNewConfigInput: false,
      newConfigName: '',
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1),

      I3PRO_APPSTORE: 'https://itunes.apple.com/us/app/i3-pro/id1039770224?l=ru&ls=1&mt=8',
      I3PRO_APPSTORE_CH: 'https://itunes.apple.com/cn/app/iridi-i3-pro/id1420050730?l=ru&ls=1&mt=8',
      I3PRO_GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=com.iridium.i3pro_v100',
      I3PRO_ANDROID_APK: 'https://iridi.com/redirects/?go=i3_pro_Android',
      addNewKeyData: {
        objIndx: 0,
        objData: {}
      },
      editKeyData: {
        objIndx: 0,
        objData: {},
        tokenIndex: 0,
        tokenVal: {}
      },
      addKeyShowModal: false,
      editKeyShowModal: false,

      addKeyShowModalMauth: false,
      editKeyShowModalMauth: false
    };
  },
  mounted: function mounted() {
    this.loadData();
    // Can set query parameter here for auth redirect or just do it silently in login redirect.
  },

  methods: {
    emitInitResponsePush: function emitInitResponsePush(payload) {
      this.initResponse.objects[payload.objIndex].tokens.push(payload.tokenData);
      // this.loadData()
    },
    emitInitResponseUpdate: function emitInitResponseUpdate(payload) {
      this.$set(this.initResponse.objects[payload.objIndex].tokens, payload.tokIndex, payload.tokenData);
      // this.loadData()
    },
    emitShowQR: function emitShowQR(payload) {
      console.log('emitShowQR', payload);
      this.showQR(payload.objIndex, this.initResponse.objects[payload.objIndex].tokens.length - 1, payload.tokenData);
    },
    emitLoadData: function emitLoadData() {
      this.loadData();
    },
    hidePopup: function hidePopup(prop) {
      this.popupIsShowing = false;
    },
    activeTokens: function activeTokens(tokens) {
      return tokens.filter(function (t) {
        return t.active;
      }).length > 0;
    },
    inactiveTokens: function inactiveTokens(tokens) {
      return tokens.filter(function (t) {
        return !t.active;
      }).length > 0;
    },
    showDeleteKey: function showDeleteKey(objIndex, tokIndex, tokenObj) {
      this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'deleteKey', true);
      this.popupIsShowing = true;
    },
    showAddNewKey: function showAddNewKey(objIndex, objectData) {
      var authType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      if (authType == 'mauth') {
        this.$set(this.initResponse.objects[objIndex], 'addKeyShow', true);
        this.addKeyShowModalMauth = true;
      } else {
        this.$set(this.initResponse.objects[objIndex], 'addKeyShow', true);
        this.addKeyShowModal = true;
      }

      // this.$set(this.initResponse.objects[objIndex], 'addKeyShow', true);
      // this.addKeyShowModal = true;

      //this.popupIsShowing = true;

      var dateLifeFrom = new Date();
      var dateLifeTo = new Date();
      dateLifeTo.setDate(dateLifeTo.getDate() + 1);

      var dayToday = new Date();

      if (objectData.defDepartureTime) {
        var defDepartureTime = new Date(objectData.defDepartureTime);
        dateLifeTo.setHours(defDepartureTime.getHours(), defDepartureTime.getMinutes(), 0);
      }

      if (objectData.defArrivalTime) {
        var defArrivalTime = new Date(objectData.defArrivalTime);
        dateLifeFrom.setHours(defArrivalTime.getHours(), defArrivalTime.getMinutes(), 0);
      }

      this.$set(this.initResponse.objects[objIndex], 'newKeyValues', {
        configurationId: '',
        objectId: objectData.objectId,
        comment: '',
        email: '',
        limit: 1,
        dateLifeTo: dateLifeTo,
        dateLifeFrom: dateLifeFrom,
        sessionTimeOption: false,
        sessionTimeValue: '',
        clientName: '',
        limitType: objectData.defLimitType || 1,
        frequencyCheckPeriod: objectData.defFrequencyCheckPeriod || 7,
        activationsCount: objectData.defActivationsCount || 2
      });

      this.addNewKeyData = {
        objIndx: objIndex,
        objData: this.initResponse.objects[objIndex]
      };
    },
    showEditKey: function showEditKey(objIndex, tokIndex, tokenObj) {
      var authType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

      if (authType == 'mauth') {
        this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'editKeyShow', true);
        this.editKeyShowModalMauth = true;
      } else {
        this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'editKeyShow', true);
        this.editKeyShowModal = true;
      }

      // this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'editKeyShow', true);
      // this.editKeyShowModal = true;
      //this.popupIsShowing = true;
      this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'editKeyValues', {
        deactivated: false,
        comment: tokenObj.comment,
        clientName: tokenObj.clientName || '',
        email: tokenObj.email,
        phone: tokenObj.phone,
        dateLifeFrom: new Date(tokenObj.dateLifeFrom),
        dateLifeTo: new Date(tokenObj.dateLifeTo),
        configurationId: tokenObj.configurationId,
        sessionTimeOption: tokenObj.sessionTime ? true : false,
        sessionTimeValue: tokenObj.sessionTime,

        limitType: tokenObj.limitType,
        proLogin: tokenObj.bxRightId ? true : false,
        frequencyCheckPeriod: tokenObj.frequencyCheckPeriod,
        activationsCount: tokenObj.activationsCount
      });

      this.editKeyData = {
        objIndx: objIndex,
        objData: this.initResponse.objects[objIndex],
        tokenIndex: tokIndex,
        tokenVal: this.initResponse.objects[objIndex].tokens[tokIndex]
      };
    },
    showPushDialog: function showPushDialog(objIndex, tokIndex, tokenObj) {
      this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'messageKeyShow', true);
      this.popupIsShowing = true;
      this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'sendingKeyValues', {
        sound_type: 0,
        js_data: '',
        title: ''
      });
    },
    showDevicesDialog: function showDevicesDialog(objIndex, objectData, tokIndex, tokenObj) {
      var _this = this;

      this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'devicesKeyShow', true);
      this.popupIsShowing = true;
      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/token/get',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: {
          timezone: moment.tz.guess(),
          keyId: tokenObj.id,
          objectId: objectData.objectId
        }
      }).then(function (response) {
        if (response.data.status) {
          // this.openNotificationWithType('danger', '', response.data.error);
          _this.openNotificationWithType('danger', '', response.data.error_code ? _this.$t('index.jwt_errors.' + response.data.error_code) : response.data.error);
        } else {
          _this.$set(_this.initResponse.objects[objIndex].tokens[tokIndex], 'devices', response.data.tokenRes.devices);
        }
      }).catch(function (error) {
        _this.openNotificationWithType('danger', '', error);
      });
    },
    showQR: function showQR(objIndex, tokIndex, tokenObj) {
      this.$set(this.initResponse.objects[objIndex].tokens[tokIndex], 'showQRPopup', true);
      this.popupIsShowing = true;
    },
    generateQR: function generateQR(key, tokenVal) {
      var dataPayload = '[config=' + tokenVal.Configuration.name + '|name=' + tokenVal.clientName + ']';

      var appLink = encodeURIComponent('byod/?key=' + key + '&data=');
      return 'https://iridi.com/qr_run/?link=' + appLink;
    },
    generateQRForApp: function generateQRForApp(key, tokenVal) {
      var dataPayload = '[config=' + tokenVal.Configuration.name + '|name=' + tokenVal.clientName + ']';
      return 'i3pro://byod/?key=' + key + '&data=' + dataPayload;
    },
    deleteKey: function deleteKey(objIndex, objectData, tokIndex, tokenObj) {
      var _this2 = this;

      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/keys/destroy',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: {
          timezone: moment.tz.guess(),
          keyId: tokenObj.id,
          objectId: objectData.objectId
        }
      }).then(function (response) {
        if (response.data.status) {
          // this.openNotificationWithType('danger', '', response.data.error);
          _this2.openNotificationWithType('danger', '', response.data.error_code ? _this2.$t('index.jwt_errors.' + response.data.error_code) : response.data.error);
        } else {
          if (tokenObj.bxRightId) {
            _this2.$http({
              method: 'post',
              url: 'https://iridi.com/customer/api_byod/?act=delete_right',
              data: { bxRightId: tokenObj.bxRightId }
            }).then(function (bitixResponse) {
              if (bitixResponse.data.status != 'success') {
                _this2.openNotificationWithType('danger', '', _this2.$t('index.' + bitixResponse.data.code));
              }
            }).catch(function (error) {
              console.log(error);
            });
          }

          _this2.hidePopup();
          if (response.data.isDestroyed) {
            _this2.initResponse.objects[objIndex].tokens.splice(tokIndex, 1);
          }
          // this.loadData()
        }
      }).catch(function (error) {
        _this2.openNotificationWithType('danger', '', error);
      });
    },
    send: function send(type, bjIndex, objectData, tokIndex, tokenObj) {
      var _this3 = this;

      var payload = {};
      switch (type) {
        case 'push':
          payload = {
            timezone: moment.tz.guess(),
            keyId: tokenObj.id,
            objectId: objectData.objectId,
            sendData: tokenObj.sendingKeyValues
          };
          tokenObj.sendingKeyValues.sound_type = parseInt(tokenObj.sendingKeyValues.sound_type);
          break;

        case 'email':
          payload = {
            timezone: moment.tz.guess(),
            keyId: tokenObj.id,
            objectId: objectData.objectId,
            sendData: tokenObj.sendingKeyValues
          };
          break;

        case 'emailqr':
          payload = {
            timezone: moment.tz.guess(),
            keyId: tokenObj.id,
            objectId: objectData.objectId,
            sendData: tokenObj.sendingKeyValues,
            qr: true
          };
          break;
      }

      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/token/send/' + type,
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: payload
      }).then(function (response) {
        if (response.data.status) {
          // this.openNotificationWithType('danger', '', response.data.error);
          _this3.openNotificationWithType('danger', '', response.data.error_code ? _this3.$t('index.jwt_errors.' + response.data.error_code) : response.data.error);
        } else {
          switch (type) {
            case 'email':
            case 'emailqr':
              _this3.openNotificationWithType('success', '', _this3.$t('index.email_successfuly_sended'));
              break;
            case 'push':
              var messageType = response.data.successCount ? 'success' : 'danger';
              _this3.openNotificationWithType(messageType, '', _this3.$t('index.push_successfuly_sended', { msgSuccess: response.data.successCount, msgError: response.data.failureCount }));
              break;
          }
        }
      }).catch(function (error) {
        _this3.openNotificationWithType('danger', '', error);
      });
    },
    addNewKey: function addNewKey(objIndex, objectData) {
      var _this4 = this;

      this.$http({
        method: 'post',
        url: this.$backendHost + '/frontend/api/keys/add',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }],
        data: {
          timezone: moment.tz.guess(),
          comment: objectData.newKeyValues.comment,
          clientName: objectData.newKeyValues.clientName,
          email: objectData.newKeyValues.email,
          configurationId: objectData.newKeyValues.configurationId,
          objectId: objectData.newKeyValues.objectId,
          limit: 1,
          dateLifeTo: objectData.newKeyValues.dateLifeTo.getTime(),
          dateLifeFrom: objectData.newKeyValues.dateLifeFrom.getTime(),
          sessionTime: !objectData.newKeyValues.sessionTimeOption ? null : objectData.newKeyValues.sessionTimeValue
        }
      }).then(function (response) {
        if (response.data.status) {
          // this.openNotificationWithType('danger', '', response.data.error);
          _this4.openNotificationWithType('danger', '', response.data.error_code ? _this4.$t('index.jwt_errors.' + response.data.error_code) : response.data.error);
        } else {
          _this4.initResponse.objects[objIndex].tokens.push(response.data.tokenData);
          _this4.$set(_this4.initResponse.objects[objIndex], 'addKeyShow', false);
          if (objectData.showQrCode) {
            //show qr imidiately

            _this4.showQR(objIndex, _this4.initResponse.objects[objIndex].tokens.length - 1, response.data.tokenData);
          } else {
            _this4.hidePopup();
          }
        }
      }).catch(function (error) {
        _this4.openNotificationWithType('danger', '', error);
      });
    },
    openNotificationWithType: function openNotificationWithType(type, title, message) {
      openNotification({
        title: title,
        message: message,
        type: type
      });
    },
    getRightClass: function getRightClass(id) {
      return id === null ? 'blend' : '';
    },
    toggleFormInvite: function toggleFormInvite(obj) {
      obj.newRightForm = !obj.newRightForm;
      if (obj.objType === 3) {
        obj.Macros = 0;
        obj.Routines = 0;
        obj.Schedules = 0;
      }
    },
    loadData: function loadData() {
      var _this5 = this;

      this.isloading = true;
      this.data.length = 0;
      this.$http({
        url: this.$backendHost + '/frontend/api/init/reseption',
        transformResponse: [function (data) {
          return JSON.parse(data);
        }]
      }).then(function (response) {
        if (response.data.error) {
          // this.openNotificationWithType('danger', '', response.data.error);
          _this5.openNotificationWithType('danger', '', response.data.error_code ? _this5.$t('index.jwt_errors.' + response.data.error_code) : response.data.error);
        } else {
          _this5.$set(_this5, 'initResponse', response.data);
        }

        _this5.isloading = false;
      }).catch(function (error) {
        _this5.isloading = false;
        _this5.openNotificationWithType('danger', '', error);
      });
    }
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    separator: String
  },

  mounted: function mounted() {
    if (this.separator) {
      this.$el.style.setProperty('--separator', '"' + this.separator + '"');
    }
  },


  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      return item.meta && item.meta.label || item.name;
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isFullwidth: Boolean,
    accordion: Boolean
  },

  computed: {
    $collapseItems: function $collapseItems() {
      return this.$children.filter(function (child) {
        return child._isCollapseItem;
      });
    }
  },

  methods: {
    openByIndex: function openByIndex(index) {
      if (this.accordion) {
        this.$collapseItems.forEach(function (item, i) {
          if (i !== index) {
            item.isActived = false;
          }
        });
      }
    }
  }

});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animejs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    selected: Boolean,
    title: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      isActived: this.selected
    };
  },
  created: function created() {
    this._isCollapseItem = true;
  },
  mounted: function mounted() {
    this.$on('open', this.$parent.openByIndex);
    if (this.isActived) {
      this.$emit('open', this.index);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.anime && this.targets) {
      __WEBPACK_IMPORTED_MODULE_0_animejs___default.a.remove(this.targets);
    }
    this.$off('open', this.$parent.openByIndex);
  },


  computed: {
    index: function index() {
      return this.$parent.$collapseItems.indexOf(this);
    }
  },

  methods: {
    toggle: function toggle() {
      if (this.isActived = !this.isActived) {
        this.$emit('open', this.index);
      }
    },
    getAnime: function getAnime(targets) {
      if (this.anime) return this.anime;
      return this.anime = __WEBPACK_IMPORTED_MODULE_0_animejs___default()({ targets: targets });
    },
    cancel: function cancel() {
      this.anime.pause();
    },
    before: function before(targets) {
      if (!this.targets) this.targets = targets;
      targets.removeAttribute('style');
    },
    enter: function enter(targets, done) {
      var height = targets.scrollHeight;
      targets.style.height = 0;
      targets.style.opacity = 0;
      this.getAnime(targets).play({
        targets: targets,
        duration: 377,
        easing: 'easeOutExpo',
        opacity: [0, 1],
        height: height,
        complete: function complete() {
          targets.removeAttribute('style');
          done();
        }
      });
    },
    leave: function leave(targets, complete) {
      this.getAnime(targets).play({
        targets: targets,
        duration: 377,
        easing: 'easeOutExpo',
        opacity: [1, 0],
        height: 0,
        complete: complete
      });
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.classList.remove('collapse');
      el.style.display = 'block';
      el.classList.add('collapsing');
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function afterEnter(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'in');
    },
    beforeLeave: function beforeLeave(el) {
      el.classList.add('collapsing');
      el.classList.remove('collapse', 'in');
      el.style.height = 0;
    },
    afterLeave: function afterLeave(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
      el.style.display = 'none';
    }
  }

});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    type: String,
    title: String,
    message: String,
    direction: {
      type: String,
      default: 'Right'
    },
    duration: {
      type: Number,
      default: 4500
    },
    container: {
      type: String,
      default: '.notifications'
    }
  },

  data: function data() {
    return {
      $_parent_: null,
      show: true
    };
  },
  created: function created() {
    var $parent = this.$parent;
    if (!$parent) {
      var parent = document.querySelector(this.container);
      if (!parent) {
        // Lazy creating `div.notifications` container.
        var className = this.container.replace('.', '');
        var Notifications = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
          name: 'Notifications',
          render: function render(h) {
            return h('div', {
              'class': _defineProperty({}, '' + className, true)
            });
          }
        });
        $parent = new Notifications().$mount();
        document.body.appendChild($parent.$el);
      } else {
        $parent = parent.__vue__;
      }
      // Hacked.
      this.$_parent_ = $parent;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$_parent_) {
      this.$_parent_.$el.appendChild(this.$el);
      this.$parent = this.$_parent_;
      delete this.$_parent_;
    }
    if (this.duration > 0) {
      this.timer = setTimeout(function () {
        return _this.close();
      }, this.duration);
    }
  },
  destroyed: function destroyed() {
    this.$el.remove();
  },


  computed: {
    transition: function transition() {
      return 'bounce-' + this.direction;
    },
    enterClass: function enterClass() {
      return 'bounceIn' + this.direction;
    },
    leaveClass: function leaveClass() {
      return 'bounceOut' + this.direction;
    }
  },

  methods: {
    closedByUser: function closedByUser() {
      this.$emit('closed-by-user');
      clearTimeout(this.timer);
      this.show = false;
    },
    close: function close() {
      this.$emit('closed-automatically');
      clearTimeout(this.timer);
      this.show = false;
    },
    afterLeave: function afterLeave() {
      this.$destroy();
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    alignment: {
      type: String,
      default: ''
    }
  },

  computed: {
    classObject: function classObject() {
      var alignment = this.alignment;

      return _defineProperty({
        'tab-list': true,
        'is-flex': true
      }, 'is-' + alignment, alignment);
    }
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var TS = {
  'fade': {
    enterClass: 'fadeIn',
    leaveClass: 'fadeOut'
  },
  'fade-horizontal-rtl': {
    enterClass: 'fadeInRight',
    leaveClass: 'fadeOutLeft'
  },
  'fade-horizontal-ltr': {
    enterClass: 'fadeInLeft',
    leaveClass: 'fadeOutRight'
  },
  'slide-horizontal-rtl': {
    enterClass: 'slideInRight',
    leaveClass: 'slideOutLeft'
  },
  'slide-horizontal-ltr': {
    enterClass: 'slideInLeft',
    leaveClass: 'slideOutRight'
  },
  'fade-vertical-dtu': {
    enterClass: 'fadeInUp',
    leaveClass: 'fadeOutUp'
  },
  'fade-vertical-utd': {
    enterClass: 'fadeInDown',
    leaveClass: 'fadeOutDown'
  },
  'slide-vertical-dtu': {
    enterClass: 'slideInUp',
    leaveClass: 'slideOutUp'
  },
  'slide-vertical-utd': {
    enterClass: 'slideInDown',
    leaveClass: 'slideOutDown'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    icon: String,
    selected: Boolean,
    disabled: Boolean,
    label: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: 'out-in'
    }
  },

  data: function data() {
    return {
      realSelected: this.selected,
      transition: TS['fade']
    };
  },
  created: function created() {
    this.$parent.tabPanes.push(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.tabPanes.splice(this.index, 1);
  },


  computed: {
    classObject: function classObject() {
      var realSelected = this.realSelected;

      return {
        'tab-pane': true,
        'animated': true,
        'is-active': realSelected,
        'is-deactive': !realSelected
      };
    },
    layout: function layout() {
      return this.$parent.layout;
    },
    direction: function direction() {
      if (this.layout === 'top' || this.layout === 'bottom') {
        return 'horizontal';
      } else if (this.layout === 'left' || this.layout === 'right') {
        return 'vertical';
      }
      return '';
    },
    animation: function animation() {
      return this.$parent.animation;
    },
    onlyFade: function onlyFade() {
      return this.$parent.onlyFade;
    },
    gte: function gte() {
      if (this.direction === 'vertical') {
        return 'utd';
      } else if (this.direction === 'horizontal') {
        return 'ltr';
      }
      return '';
    },
    lt: function lt() {
      if (this.direction === 'vertical') {
        return 'dtu';
      } else if (this.direction === 'horizontal') {
        return 'rtl';
      }
      return '';
    },
    hidden: function hidden() {
      return this.realSelected ? 'false' : 'true';
    },
    index: function index() {
      return this.$parent.tabPanes.indexOf(this);
    }
  },

  watch: {
    '$parent.realSelectedIndex': function $parentRealSelectedIndex(index, prevIndex) {
      if (!this.onlyFade) {
        var transition = void 0;
        if (prevIndex === -1 || prevIndex > index) {
          transition = '' + this.animation + (this.layout ? '-' + this.direction : '') + (this.gte ? '-' + this.gte : '');
        } else {
          transition = '' + this.animation + (this.layout ? '-' + this.direction : '') + (this.lt ? '-' + this.lt : '');
        }
        this.transition = TS[transition] || TS['fade'];
      }
      this.realSelected = this.index === index;
    }
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabList__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TabList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TabList: __WEBPACK_IMPORTED_MODULE_0__TabList___default.a
  },

  props: {
    isFullwidth: Boolean,
    layout: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'bottom', 'left', 'right'].indexOf(val) > -1;
      }
    },
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    alignment: {
      type: String,
      default: ''
    },
    selectedIndex: {
      type: Number,
      default: -1
    },
    animation: {
      type: String,
      default: 'fade'
    },
    onlyFade: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      realSelectedIndex: this.selectedIndex,
      tabPanes: []
    };
  },
  mounted: function mounted() {
    this.update();
    if (this.realSelectedIndex === -1) {
      this.select(0);
    }
  },


  methods: {
    update: function update() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.tabPanes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tabPane = _step.value;

          if (!tabPane.disabled && tabPane.realSelected) {
            this.select(tabPane.index);
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    isActived: function isActived(index) {
      return index === this.realSelectedIndex;
    },
    select: function select(index) {
      this.$emit('tab-selected', index);
      this.realSelectedIndex = index;
    }
  },
  watch: {
    selectedIndex: function selectedIndex(newIndex) {
      this.select(newIndex);
    }
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nprogress-container'
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js__);
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({

    props: {
        text: { type: String, required: true },
        size: { type: Number, required: false, default: 256 },
        color: { type: String, required: false, default: '#000' },
        bgColor: { type: String, required: false, default: '#FFF' },
        errorLevel: {
            type: String,
            validator: function validator(value) {
                return value === 'L' || value === 'M' || value === 'Q' || value === 'H';
            },
            required: false,
            default: 'H'
        }
    },

    watch: {
        text: function text() {
            this.clear();
            this.makeCode(this.text);
        }
    },

    data: function data() {
        return {
            qrCode: {}
        };
    },
    mounted: function mounted() {
        this.qrCode = new __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default.a(this.$el, {
            text: this.text,
            width: this.size,
            height: this.size,
            colorDark: this.color,
            colorLight: this.bgColor,
            correctLevel: __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default.a.CorrectLevel[this.errorLevel]
        });
    },


    methods: {
        clear: function clear() {
            this.qrCode.clear();
        },
        makeCode: function makeCode(text) {
            this.qrCode.makeCode(text);
        }
    }
});

/***/ }),
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */,
/* 268 */,
/* 269 */
/***/ (function(module, exports) {

module.exports = {"version":"2017c","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|01213454545454545454545454545454545454545454545454543|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Etc/GMT+0|GMT|0|0|","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Sao_Tome","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT+0|Etc/GMT","Etc/GMT+0|Etc/GMT-0","Etc/GMT+0|Etc/GMT0","Etc/GMT+0|Etc/Greenwich","Etc/GMT+0|GMT","Etc/GMT+0|GMT+0","Etc/GMT+0|GMT-0","Etc/GMT+0|GMT0","Etc/GMT+0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 270 */,
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 24,
	"./af.js": 24,
	"./ar": 31,
	"./ar-dz": 25,
	"./ar-dz.js": 25,
	"./ar-kw": 26,
	"./ar-kw.js": 26,
	"./ar-ly": 27,
	"./ar-ly.js": 27,
	"./ar-ma": 28,
	"./ar-ma.js": 28,
	"./ar-sa": 29,
	"./ar-sa.js": 29,
	"./ar-tn": 30,
	"./ar-tn.js": 30,
	"./ar.js": 31,
	"./az": 32,
	"./az.js": 32,
	"./be": 33,
	"./be.js": 33,
	"./bg": 34,
	"./bg.js": 34,
	"./bm": 35,
	"./bm.js": 35,
	"./bn": 36,
	"./bn.js": 36,
	"./bo": 37,
	"./bo.js": 37,
	"./br": 38,
	"./br.js": 38,
	"./bs": 39,
	"./bs.js": 39,
	"./ca": 40,
	"./ca.js": 40,
	"./cs": 41,
	"./cs.js": 41,
	"./cv": 42,
	"./cv.js": 42,
	"./cy": 43,
	"./cy.js": 43,
	"./da": 44,
	"./da.js": 44,
	"./de": 47,
	"./de-at": 45,
	"./de-at.js": 45,
	"./de-ch": 46,
	"./de-ch.js": 46,
	"./de.js": 47,
	"./dv": 48,
	"./dv.js": 48,
	"./el": 49,
	"./el.js": 49,
	"./en-au": 50,
	"./en-au.js": 50,
	"./en-ca": 51,
	"./en-ca.js": 51,
	"./en-gb": 52,
	"./en-gb.js": 52,
	"./en-ie": 53,
	"./en-ie.js": 53,
	"./en-il": 54,
	"./en-il.js": 54,
	"./en-nz": 55,
	"./en-nz.js": 55,
	"./eo": 56,
	"./eo.js": 56,
	"./es": 59,
	"./es-do": 57,
	"./es-do.js": 57,
	"./es-us": 58,
	"./es-us.js": 58,
	"./es.js": 59,
	"./et": 60,
	"./et.js": 60,
	"./eu": 61,
	"./eu.js": 61,
	"./fa": 62,
	"./fa.js": 62,
	"./fi": 63,
	"./fi.js": 63,
	"./fo": 64,
	"./fo.js": 64,
	"./fr": 67,
	"./fr-ca": 65,
	"./fr-ca.js": 65,
	"./fr-ch": 66,
	"./fr-ch.js": 66,
	"./fr.js": 67,
	"./fy": 68,
	"./fy.js": 68,
	"./gd": 69,
	"./gd.js": 69,
	"./gl": 70,
	"./gl.js": 70,
	"./gom-latn": 71,
	"./gom-latn.js": 71,
	"./gu": 72,
	"./gu.js": 72,
	"./he": 73,
	"./he.js": 73,
	"./hi": 74,
	"./hi.js": 74,
	"./hr": 75,
	"./hr.js": 75,
	"./hu": 76,
	"./hu.js": 76,
	"./hy-am": 77,
	"./hy-am.js": 77,
	"./id": 78,
	"./id.js": 78,
	"./is": 79,
	"./is.js": 79,
	"./it": 80,
	"./it.js": 80,
	"./ja": 81,
	"./ja.js": 81,
	"./jv": 82,
	"./jv.js": 82,
	"./ka": 83,
	"./ka.js": 83,
	"./kk": 84,
	"./kk.js": 84,
	"./km": 85,
	"./km.js": 85,
	"./kn": 86,
	"./kn.js": 86,
	"./ko": 87,
	"./ko.js": 87,
	"./ky": 88,
	"./ky.js": 88,
	"./lb": 89,
	"./lb.js": 89,
	"./lo": 90,
	"./lo.js": 90,
	"./lt": 91,
	"./lt.js": 91,
	"./lv": 92,
	"./lv.js": 92,
	"./me": 93,
	"./me.js": 93,
	"./mi": 94,
	"./mi.js": 94,
	"./mk": 95,
	"./mk.js": 95,
	"./ml": 96,
	"./ml.js": 96,
	"./mn": 97,
	"./mn.js": 97,
	"./mr": 98,
	"./mr.js": 98,
	"./ms": 100,
	"./ms-my": 99,
	"./ms-my.js": 99,
	"./ms.js": 100,
	"./mt": 101,
	"./mt.js": 101,
	"./my": 102,
	"./my.js": 102,
	"./nb": 103,
	"./nb.js": 103,
	"./ne": 104,
	"./ne.js": 104,
	"./nl": 106,
	"./nl-be": 105,
	"./nl-be.js": 105,
	"./nl.js": 106,
	"./nn": 107,
	"./nn.js": 107,
	"./pa-in": 108,
	"./pa-in.js": 108,
	"./pl": 109,
	"./pl.js": 109,
	"./pt": 111,
	"./pt-br": 110,
	"./pt-br.js": 110,
	"./pt.js": 111,
	"./ro": 112,
	"./ro.js": 112,
	"./ru": 113,
	"./ru.js": 113,
	"./sd": 114,
	"./sd.js": 114,
	"./se": 115,
	"./se.js": 115,
	"./si": 116,
	"./si.js": 116,
	"./sk": 117,
	"./sk.js": 117,
	"./sl": 118,
	"./sl.js": 118,
	"./sq": 119,
	"./sq.js": 119,
	"./sr": 121,
	"./sr-cyrl": 120,
	"./sr-cyrl.js": 120,
	"./sr.js": 121,
	"./ss": 122,
	"./ss.js": 122,
	"./sv": 123,
	"./sv.js": 123,
	"./sw": 124,
	"./sw.js": 124,
	"./ta": 125,
	"./ta.js": 125,
	"./te": 126,
	"./te.js": 126,
	"./tet": 127,
	"./tet.js": 127,
	"./tg": 128,
	"./tg.js": 128,
	"./th": 129,
	"./th.js": 129,
	"./tl-ph": 130,
	"./tl-ph.js": 130,
	"./tlh": 131,
	"./tlh.js": 131,
	"./tr": 132,
	"./tr.js": 132,
	"./tzl": 133,
	"./tzl.js": 133,
	"./tzm": 135,
	"./tzm-latn": 134,
	"./tzm-latn.js": 134,
	"./tzm.js": 135,
	"./ug-cn": 136,
	"./ug-cn.js": 136,
	"./uk": 137,
	"./uk.js": 137,
	"./ur": 138,
	"./ur.js": 138,
	"./uz": 140,
	"./uz-latn": 139,
	"./uz-latn.js": 139,
	"./uz.js": 140,
	"./vi": 141,
	"./vi.js": 141,
	"./x-pseudo": 142,
	"./x-pseudo.js": 142,
	"./yo": 143,
	"./yo.js": 143,
	"./zh-cn": 144,
	"./zh-cn.js": 144,
	"./zh-hk": 145,
	"./zh-hk.js": 145,
	"./zh-tw": 146,
	"./zh-tw.js": 146
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 271;

/***/ }),
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAiCAQAAACpKXISAAACP0lEQVR42tWXAUScYRjHPyC7TSqMiuDiEkPYBavutu0OHWLFqbHYJLUOJs7IGSEqswZCBtkQwSDIABJAAEKhaXfr+744xHW/fXs2j3vhxt6+O/s98Ph9Xn/yds/zOr8gQoopnjWgpkgRcX7DBEUaSZGJIJZhKjSaCsMO+8A5SdoaVEnOgX2HMrDk1IUoeZZJGm6AQlADhkuyTJ6oUxeWgLIDwLxTB8a5QmBT3SJVAKosqtvkhDW28Bh36sA8wF+DacVDYVRcH9dqrukTN8ox7dINcUGrfXCaWjbELRhuQdwGBT1zSNo+OEEtq+JmDDcjbpUVPXNEwj64hVONqDIorouyujJd4gYpEpNumlNa7IIF4pwBcEVO3RiXAFwypi6Hzx4HnBG3u1wKETJk6TZcB0+D6jBcN1kyRFTYBNtjEUw3r8hz33AxXgcVM9w9crzg7g0Fk9GrtK5uDpePQbnMqXtLFQCPRzcQzB1+gPJEXC8e/dL149ErXRKU79y2D05Ry/s/Rz/p98/Iad5Ry2P74IfUsi5ulh39vsNsOMG3+AbKA3E9+MSli+PTE8qfWlaFEgAV3qibxOdLUD6T4VwugTayvKTXcJ08D6rT9t8pBP7Pn0wdEgfs4RtDwuVrUG4oQ0LH4rR0MYo6Fj1GpBvBC2kskuBI+xVdBHbV7Ya1CKQ51L6gq8+2uu2wVp9WLhiSrp1jXfZcotJFcUNY9nS99dhijRNjvS3xIajSv6+3TVrom/aEadqjrWnP1KY9zH8CnrGWYaByfPEAAAAASUVORK5CYII="

/***/ }),
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(257)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(316),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(248)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(304),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(251)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(308),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(295),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(252)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(311),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(250)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(306),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(262)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(320),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(255)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(314),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(263)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(321),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(241)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(299),
  /* scopeId */
  "data-v-16231e34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(309),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(254)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(313),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(253)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(312),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(307),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-card ",
    staticStyle: {
      "width": "auto",
      "min-width": "320px"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('index.profile.change_password')))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('b-field', {
    attrs: {
      "label": _vm.$t('index.profile.current_password'),
      "type": {
        'is-danger': _vm.data.messages.pass
      },
      "message": ( _obj = {}, _obj[_vm.$t(("index.profile.errors." + (this.data.messages.pass)))] = _vm.data.messages.pass, _obj )
    }
  }, [_c('b-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.form.pass),
      callback: function($$v) {
        _vm.$set(_vm.form, "pass", $$v)
      },
      expression: "form.pass"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": _vm.$t('index.profile.new_password'),
      "type": {
        'is-danger': _vm.data.messages.newpass
      },
      "message": ( _obj$1 = {}, _obj$1[_vm.$t(("index.profile.errors." + (this.data.messages.newpass)))] = _vm.data.messages.newpass, _obj$1 )
    }
  }, [_c('b-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.form.newpass),
      callback: function($$v) {
        _vm.$set(_vm.form, "newpass", $$v)
      },
      expression: "form.newpass"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": _vm.$t('index.profile.confirm_password'),
      "type": {
        'is-danger': _vm.data.messages.confirmpass
      },
      "message": ( _obj$2 = {}, _obj$2[_vm.$t(("index.profile.errors." + (this.data.messages.confirmpass)))] = _vm.data.messages.confirmpass, _obj$2 )
    }
  }, [_c('b-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.form.confirmpass),
      callback: function($$v) {
        _vm.$set(_vm.form, "confirmpass", $$v)
      },
      expression: "form.confirmpass"
    }
  })], 1)], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.close')))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half has-text-right"
  }, [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v(_vm._s(_vm.$t('index.save')))])])])])
  var _obj;
  var _obj$1;
  var _obj$2;
},staticRenderFns: []}

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-card ",
    staticStyle: {
      "width": "auto",
      "min-width": "320px"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('index.profile.forgot_password_title')))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('b-field', {
    attrs: {
      "label": _vm.$t('index.profile.email_label'),
      "type": {
        'is-danger': _vm.data.messages.email
      },
      "message": ( _obj = {}, _obj[_vm.$t(("index.profile.errors." + (this.data.messages.email)))] = _vm.data.messages.email, _obj )
    }
  }, [_c('b-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1)], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.close')))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half has-text-right"
  }, [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v(_vm._s(_vm.$t('index.profile.send')))])])])])
  var _obj;
},staticRenderFns: []}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('b-loading', {
    attrs: {
      "active": _vm.isloadingUpdate,
      "can-cancel": false
    },
    on: {
      "update:active": function($event) {
        _vm.isloadingUpdate = $event
      }
    }
  }), _vm._v(" "), _c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('index.edit_client_tokens_' + _vm.obj.licenseInfo.byod_type)) + " Mobile auth")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {}, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('b-field', {
    attrs: {
      "label": '* ' + _vm.$t('index.select_configuration_' + _vm.obj.licenseInfo.byod_type)
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select the configuration and room",
      "required": "",
      "expanded": ""
    },
    on: {
      "input": _vm.selectRoom
    },
    model: {
      value: (_vm.localTokenVal.editKeyValues.configurationId),
      callback: function($$v) {
        _vm.$set(_vm.localTokenVal.editKeyValues, "configurationId", $$v)
      },
      expression: "localTokenVal.editKeyValues.configurationId"
    }
  }, _vm._l((_vm.obj.configurations), function(conf) {
    return _c('option', {
      key: conf.id,
      domProps: {
        "value": conf.id
      }
    }, [_vm._v(_vm._s(conf.name))])
  }))], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.phone')))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-field', [_c('b-input', {
    directives: [{
      name: "facade",
      rawName: "v-facade",
      value: ('+# (###) ### - ## - ##'),
      expression: "'+# (###) ### - ## - ##'"
    }],
    ref: "legacyInput",
    attrs: {
      "masked": false,
      "type": "text",
      "icon": "phone",
      "placeholder": _vm.$t('index.phone_number')
    },
    nativeOn: {
      "input": function($event) {
        return _vm.onInput($event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.comment')))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "type": "textarea",
      "maxlength": "255"
    },
    model: {
      value: (_vm.localTokenVal.editKeyValues.comment),
      callback: function($$v) {
        _vm.$set(_vm.localTokenVal.editKeyValues, "comment", $$v)
      },
      expression: "localTokenVal.editKeyValues.comment"
    }
  })], 1)], 1)])])]), _vm._v(" "), (_vm.fields.length) ? _c('div', {
    staticClass: "columns is-multiline",
    staticStyle: {
      "max-width": "480px"
    }
  }, [_c('b-loading', {
    attrs: {
      "is-full-page": false,
      "active": _vm.isLoading,
      "can-cancel": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _vm._l((_vm.fields), function(customField, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (customField.edit),
        expression: "customField.edit"
      }],
      key: i,
      staticClass: "column is-half"
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', {
      staticClass: "label"
    }, [_vm._v(_vm._s(customField.name))]), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, [_c('b-field', [_c('b-input', {
      attrs: {
        "type": "text"
      },
      on: {
        "input": function($event) {
          _vm.setCustomValue($event, customField, i)
        }
      },
      model: {
        value: (customField.value),
        callback: function($$v) {
          _vm.$set(customField, "value", $$v)
        },
        expression: "customField.value"
      }
    })], 1)], 1)])])
  })], 2) : _vm._e()])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-one-third"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.cancel')))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds has-text-right"
  }, [_c('button', {
    staticClass: "button is-danger",
    attrs: {
      "disabled": !_vm.validate
    },
    on: {
      "click": function($event) {
        _vm.editKey(true)
      }
    }
  }, [_vm._v("Удалить")]), _vm._v(" "), _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": !_vm.validate
    },
    on: {
      "click": function($event) {
        _vm.editKey(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.edit_registration')))])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterEnter": _vm.afterEnter,
      "beforeLeave": _vm.beforeLeave,
      "afterLeave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "title has-text-centered is-size-1 has-text-weight-light"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('index.administrating_objects')) + "\n    "), _c('span', {
    staticClass: "has-text-info icon is-large",
    class: {
      'fa-spin': _vm.isloading
    },
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.loadData
    }
  }, [_c('i', {
    staticClass: "fas fa-sync"
  })])]), _vm._v(" "), _c('b-loading', {
    attrs: {
      "is-full-page": true,
      "active": _vm.isloading,
      "can-cancel": false
    },
    on: {
      "update:active": function($event) {
        _vm.isloading = $event
      }
    }
  }), _vm._v(" "), (_vm.initResponse.canAdminGlobal) ? _c('div', {
    staticClass: "columns is-multiline"
  }, _vm._l((_vm.initResponse.objects), function(object, index) {
    return (object.canAdmin) ? _c('div', {
      key: index,
      staticClass: "column is-10 is-offset-1 is-narrow",
      attrs: {
        "selected": index === 0
      }
    }, [_c('article', {
      staticClass: "tile is-child box"
    }, [_c('p', {
      staticClass: "is-size-2 has-text-weight-light"
    }, [_c('span', [_vm._v(_vm._s(object.name))])]), _vm._v(" "), (object.tariffData.maxConfigs != 999999) ? [_c('p', {
      staticClass: "is-size-4 has-text-weight-light"
    }, [_vm._v("\n            " + _vm._s(_vm.$t('index.license_info_' + object.byod_type, {
      license: object.tariffData.name,
      rooms: object.tariffData.inUseConfigs,
      roomstotal: object.tariffData.maxConfigs
    })) + "\n          ")])] : [_c('p', {
      staticClass: "is-size-4 has-text-weight-light"
    }, [_vm._v("License " + _vm._s(object.tariffData.name) + " (unlimited rooms)")])], _vm._v(" "), _c('br'), _vm._v(" "), _c('collapse', {
      attrs: {
        "accordion": "",
        "is-fullwidth": ""
      }
    }, _vm._l((_vm.initResponse.projectsAdminData[object.id]), function(tag, tagI) {
      return _c('collapse-item', {
        key: tagI,
        staticClass: "tab-head-custom",
        attrs: {
          "title": tagI
        }
      }, [_c('tabs', {
        attrs: {
          "type": "tabs is-medium "
        }
      }, [_c('tab-pane', {
        attrs: {
          "label": _vm.$t('index.rooms_' + object.byod_type)
        }
      }, [_c('div', {
        staticClass: "wrap_table"
      }, [_c('table', {
        staticClass: "table is-striped is-fullwidth is-narrow"
      }, [_vm._l((tag.configurations), function(confPropVal, confPropKey) {
        return _c('tr', {
          key: confPropKey
        }, [_c('td', [(!confPropVal.edit) ? _c('span', [_vm._v("\n                          " + _vm._s(confPropVal.name) + "\n                        ")]) : _vm._e(), _vm._v(" "), (confPropVal.edit) ? _c('div', {
          staticClass: "field"
        }, [_c('p', {
          staticClass: "control"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (confPropVal.newName),
            expression: "confPropVal.newName"
          }],
          staticClass: "input is-primary",
          staticStyle: {
            "width": "90%"
          },
          attrs: {
            "type": "text",
            "placeholder": _vm.$t('index.unique_configuration_name')
          },
          domProps: {
            "value": (confPropVal.newName)
          },
          on: {
            "keypress": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              _vm.editConfig(confPropVal, confPropVal.newName)
            },
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(confPropVal, "newName", $event.target.value)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "pointer edit-icon",
          on: {
            "click": function($event) {
              _vm.editConfig(confPropVal, confPropVal.newName)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-lg fa-check"
        })]), _vm._v(" "), _c('span', {
          staticClass: "pointer edit-icon",
          on: {
            "click": function($event) {
              confPropVal.edit = false
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-lg fa-times-circle"
        })])])]) : _vm._e(), _vm._v(" "), (!confPropVal.edit) ? _c('span', {
          staticClass: "pointer icon",
          on: {
            "click": function($event) {
              _vm.showEditConf(object.id, tagI, confPropVal.id)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-pencil-alt"
        })]) : _vm._e()]), _vm._v(" "), _c('td', [_c('FDateTime', {
          attrs: {
            "value": confPropVal.updatedAt
          }
        })], 1), _vm._v(" "), _c('td', {}, [_c('a', {
          staticClass: "button is-outlined is-small",
          on: {
            "click": function($event) {
              _vm.showRoomFieldsManager(confPropVal)
            }
          }
        }, [_c('span', {
          staticClass: "icon is-small"
        }, [_c('i', {
          staticClass: "fa fa-th-list"
        })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.set_fields')))])]), _vm._v(" "), _c('a', {
          staticClass: "button is-outlined is-small",
          on: {
            "click": function($event) {
              _vm.showDeleteRoom(confPropVal)
            }
          }
        }, [_c('span', {
          staticClass: "icon is-small"
        }, [_c('i', {
          staticClass: "fa fa-times"
        })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.delete')))])]), _vm._v(" "), _c('div', {
          class: ['modal deleteConfigModal', confPropVal.deletePopup ? 'is-active' : ''],
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('div', {
          staticClass: "modal-background"
        }), _vm._v(" "), _c('div', {
          staticClass: "modal-content"
        }, [_vm._v("\n                            " + _vm._s(_vm.$t('index.delete_configuration_confirm', {
          confname: confPropVal.name,
          conftag: confPropVal.tag
        })) + "\n                            "), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "tag is-danger"
        }, [_vm._v(_vm._s(_vm.$t('index.delete_configuration_warning')))])]), _vm._v(" "), _c('button', {
          staticClass: "button is-text",
          on: {
            "click": function($event) {
              confPropVal.deletePopup = false
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('index.cancel')))]), _vm._v(" "), _c('button', {
          staticClass: "button is-danger",
          on: {
            "click": function($event) {
              _vm.deleteConfig(confPropVal)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('index.yes')))])])])])
      }), _vm._v(" "), _c('tr', [(tag.newConfigInputShow) ? _c('td', [_c('div', {
        staticClass: "field"
      }, [_c('div', {
        staticClass: "control"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (tag.newConfigInputText),
          expression: "tag.newConfigInputText"
        }],
        staticClass: "input is-primary",
        attrs: {
          "type": "text",
          "placeholder": _vm.$t('index.unique_configuration_name')
        },
        domProps: {
          "value": (tag.newConfigInputText)
        },
        on: {
          "keypress": function($event) {
            if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            _vm.addNewConfig(object.id, tagI)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(tag, "newConfigInputText", $event.target.value)
          }
        }
      })])])]) : _vm._e(), _vm._v(" "), (tag.newConfigInputShow) ? _c('td', [_c('span', {
        staticClass: "pointer",
        on: {
          "click": function($event) {
            _vm.addNewConfig(object.id, tagI)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-lg fa-check"
      })]), _vm._v(" "), _c('span', {
        staticClass: "pointer",
        on: {
          "click": function($event) {
            tag.newConfigInputShow = false
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-lg fa-times-circle"
      })])]) : _vm._e()])], 2)]), _vm._v(" "), (!tag.newConfigInputShow) ? _c('a', {
        staticClass: "button is-info is-small",
        on: {
          "click": function($event) {
            _vm.showNewConfigInput(object, tagI, tag)
          }
        }
      }, [_c('span', {
        staticClass: "icon is-small"
      }, [_c('i', {
        staticClass: "fa fa-plus"
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.add_new')))])]) : _vm._e()]), _vm._v(" "), _c('tab-pane', {
        attrs: {
          "label": _vm.$t('index.projects')
        }
      }, [_c('div', {
        staticClass: "wrap_table"
      }, [_c('table', {
        staticClass: "table is-striped is-fullwidth"
      }, _vm._l((tag.projects), function(tagPropVal, tagPropKey) {
        return _c('tr', {
          key: tagPropKey
        }, [_c('td', [_vm._v(_vm._s(tagPropVal.name))]), _vm._v(" "), _c('td', [_c('FDateTime', {
          attrs: {
            "value": tagPropVal.updatedAt
          }
        })], 1)])
      }))])])], 1), _vm._v(" "), _c('section', {
        staticClass: "has-text-right"
      }, [_c('button', {
        staticClass: "button is-default",
        on: {
          "click": function($event) {
            _vm.showFieldsManager(tagI, object.id)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.fields')))])])], 1)
    })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [(object.byod_type !== 'mauth') ? _c('b-collapse', {
      staticClass: "object-collapse",
      attrs: {
        "open": false
      }
    }, [_c('button', {
      staticClass: "button",
      attrs: {
        "slot": "trigger"
      },
      slot: "trigger"
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-cog"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.settings')))])]), _vm._v(" "), _c('div', {
      staticClass: "notification"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.default_arrival_time_' + object.byod_type)
      }
    }, [_c('b-timepicker', {
      attrs: {
        "hour-format": "24",
        "placeholder": "Type or select a time...",
        "icon": "clock",
        "readonly": false
      },
      model: {
        value: (object.defArrivalTime),
        callback: function($$v) {
          _vm.$set(object, "defArrivalTime", $$v)
        },
        expression: "object.defArrivalTime"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.default_departure_time_' + object.byod_type)
      }
    }, [_c('b-timepicker', {
      attrs: {
        "hour-format": "24",
        "placeholder": "Type or select a time...",
        "icon": "clock",
        "readonly": false
      },
      model: {
        value: (object.defDepartureTime),
        callback: function($$v) {
          _vm.$set(object, "defDepartureTime", $$v)
        },
        expression: "object.defDepartureTime"
      }
    })], 1)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-switch', {
      attrs: {
        "type": "is-success"
      },
      model: {
        value: (object.showQrCode),
        callback: function($$v) {
          _vm.$set(object, "showQrCode", $$v)
        },
        expression: "object.showQrCode"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.$t('index.show_qr_after_reg')) + "\n                      ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('b-switch', {
      attrs: {
        "type": "is-success"
      },
      model: {
        value: (object.multyTokensConfig),
        callback: function($$v) {
          _vm.$set(object, "multyTokensConfig", $$v)
        },
        expression: "object.multyTokensConfig"
      }
    }, [_vm._v(" Multiple tokens in one configuration ")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.def_check_frequency')
      }
    }, [_c('b-input', {
      attrs: {
        "type": "number",
        "min": "1",
        "max": "7",
        "icon": "clock",
        "placeholder": _vm.$t('index.days')
      },
      model: {
        value: (object.defFrequencyCheckPeriod),
        callback: function($$v) {
          _vm.$set(object, "defFrequencyCheckPeriod", $$v)
        },
        expression: "object.defFrequencyCheckPeriod"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.def_activation_panels_limit')
      }
    }, [_c('b-input', {
      attrs: {
        "placeholder": _vm.$t('index.activation_panels_limit_placeholder'),
        "type": "number",
        "min": "1",
        "icon": "clock"
      },
      model: {
        value: (object.defActivationsCount),
        callback: function($$v) {
          _vm.$set(object, "defActivationsCount", $$v)
        },
        expression: "object.defActivationsCount"
      }
    })], 1)], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-loading', {
      attrs: {
        "is-full-page": false,
        "active": _vm.uploadInProcess,
        "can-cancel": false
      },
      on: {
        "update:active": function($event) {
          _vm.uploadInProcess = $event
        }
      }
    }), _vm._v(" "), _c('b-field', {
      attrs: {
        "label": _vm.$t('index.import_settings_from_csv')
      }
    }, [_c('b-field', [_c('b-upload', {
      attrs: {
        "accept": ".csv",
        "loading": _vm.uploadInProcess
      },
      model: {
        value: (_vm.file),
        callback: function($$v) {
          _vm.file = $$v
        },
        expression: "file"
      }
    }, [_c('a', {
      staticClass: "button is-info is-right"
    }, [_c('b-icon', {
      attrs: {
        "icon": "upload"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.upload_file')))])], 1)]), _vm._v(" "), (_vm.file.name) ? _c('span', {
      staticClass: "file-name"
    }, [_vm._v("\n                        " + _vm._s(_vm.file.name) + "\n                      ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "buttons has-addons"
    }, [(_vm.file.name) ? _c('button', {
      staticClass: "button",
      on: {
        "click": function($event) {
          _vm.upload(object)
        }
      }
    }, [_vm._v("upload")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "button is-text",
      attrs: {
        "target": "_blank",
        "download": "",
        "href": "https://s3.amazonaws.com/licensetext/import_template.csv"
      }
    }, [_vm._v(_vm._s(_vm.$t('index.download_csv_template')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "buttons is-right"
    }, [_c('button', {
      staticClass: "button is-success",
      on: {
        "click": function($event) {
          _vm.saveSettings(object)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.save')))])])])], 1)])]) : _vm._e(), _vm._v(" "), (object.byod_type == 'mauth') ? _c('b-collapse', {
      staticClass: "object-collapse",
      attrs: {
        "open": object.sms.collapse
      },
      on: {
        "update:open": function($event) {
          _vm.$set(object.sms, "collapse", $event)
        },
        "open": function($event) {
          _vm.loadSMS(object)
        }
      }
    }, [_c('button', {
      staticClass: "button",
      attrs: {
        "slot": "trigger"
      },
      slot: "trigger"
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-phone"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.object_settings.sms_label')))])]), _vm._v(" "), _c('div', {
      staticClass: "notification"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": "СМС-провайдер"
      }
    }, [_c('div', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (object.sms.provider),
        expression: "object.sms.provider"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(object.sms, "provider", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.changeProvider(object)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "smsgorod"
      }
    }, [_vm._v("smsgorod.ru")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "smsc"
      }
    }, [_vm._v("smsc.ru")])])])])], 1)]), _vm._v(" "), (object.sms.provider == 'smsc') ? _c('section', {
      key: "smsc"
    }, [_c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.object_settings.sms_login'),
        "type": {
          'is-danger': !object.sms.credentials.login || !object.sms.balance
        },
        "message": ( _obj = {}, _obj[_vm.$t('index.profile.errors.fill_this_field')] = !object.sms.credentials.login, _obj )
      }
    }, [_c('b-input', {
      attrs: {
        "type": "text"
      },
      model: {
        value: (object.sms.credentials.login),
        callback: function($$v) {
          _vm.$set(object.sms.credentials, "login", $$v)
        },
        expression: "object.sms.credentials.login"
      }
    })], 1)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.object_settings.sms_password'),
        "type": {
          'is-danger': !object.sms.credentials.password || !object.sms.balance
        },
        "message": ( _obj$1 = {}, _obj$1[_vm.$t('index.profile.errors.fill_this_field')] = !object.sms.credentials.password, _obj$1 )
      }
    }, [_c('b-input', {
      attrs: {
        "type": "password",
        "password-reveal": ""
      },
      model: {
        value: (object.sms.credentials.password),
        callback: function($$v) {
          _vm.$set(object.sms.credentials, "password", $$v)
        },
        expression: "object.sms.credentials.password"
      }
    })], 1)], 1)]), _vm._v(" "), (object.sms.balance) ? _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.object_settings.sms_balance')
      }
    }, [_c('b-input', {
      attrs: {
        "type": "text",
        "readonly": "",
        "disabled": "",
        "value": ((object.sms.balance) + " ₽")
      }
    })], 1)], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (object.sms.provider == 'smsgorod') ? _c('section', {
      key: "smsgorod"
    }, [_c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": "API Key",
        "type": {
          'is-danger': !object.sms.credentials.apiKey || !object.sms.balance
        },
        "message": ( _obj$2 = {}, _obj$2[_vm.$t('index.profile.errors.fill_this_field')] = !object.sms.credentials.apiKey, _obj$2 )
      }
    }, [_c('b-input', {
      attrs: {
        "type": "text"
      },
      model: {
        value: (object.sms.credentials.apiKey),
        callback: function($$v) {
          _vm.$set(object.sms.credentials, "apiKey", $$v)
        },
        expression: "object.sms.credentials.apiKey"
      }
    })], 1)], 1)]), _vm._v(" "), (object.sms.balance) ? _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.object_settings.sms_balance')
      }
    }, [_c('b-input', {
      attrs: {
        "type": "text",
        "readonly": "",
        "disabled": "",
        "value": ((object.sms.balance) + " ₽")
      }
    })], 1)], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "buttons is-right"
    }, [(object.sms.balance) ? _c('button', {
      staticClass: "button is-primary",
      on: {
        "click": function($event) {
          _vm.testSMS(object)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-comment"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.object_settings.test_sms')))])]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "button is-success",
      on: {
        "click": function($event) {
          _vm.saveSMS(object)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-check"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.object_settings.save_sms')))])]), _vm._v(" "), (object.sms.balance) ? _c('button', {
      staticClass: "button is-danger",
      on: {
        "click": function($event) {
          _vm.deleteSMS(object)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-ban"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.object_settings.clear_sms')))])]) : _vm._e()]), _vm._v(" "), (object && object.sms && object.sms.open) ? _c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.object_settings.sms_phone'),
        "type": {
          'is-danger': !object.sms.phone
        },
        "message": ( _obj$3 = {}, _obj$3[_vm.$t('index.profile.errors.fill_this_field')] = !object.sms.phone, _obj$3 )
      }
    }, [_c('b-input', {
      attrs: {
        "type": "text"
      },
      model: {
        value: (object.sms.phone),
        callback: function($$v) {
          _vm.$set(object.sms, "phone", $$v)
        },
        expression: "object.sms.phone"
      }
    })], 1), _vm._v(" "), _c('button', {
      staticClass: "button is-warning",
      on: {
        "click": function($event) {
          _vm.sendSMS(object)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.object_settings.send_sms')))])])], 1)]) : _vm._e()])])]) : _vm._e()], 1)])], 2)]) : _vm._e()
    var _obj;
    var _obj$1;
    var _obj$2;
    var _obj$3;
  })) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.showTagFieldsData,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.showTagFieldsData = $event
      }
    }
  }, [_c('tagfields', _vm._b({
    on: {
      "create_room_fields": _vm.showRoomFieldsManager
    }
  }, 'tagfields', _vm.tagFieldsData, false))], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.showRoomFieldsData
    },
    on: {
      "update:active": function($event) {
        _vm.showRoomFieldsData = $event
      }
    }
  }, [_c('roomfields', _vm._b({
    on: {
      "create_config_fields": _vm.showFieldsManagerFromRooms
    }
  }, 'roomfields', _vm.roomFieldsData, false))], 1), _vm._v(" "), _c('b-modal', {
    staticClass: "config-csv-modal",
    attrs: {
      "active": _vm.showImportedFieldsData,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.showImportedFieldsData = $event
      }
    }
  }, [_c('importfields', _vm._b({
    on: {
      "import_fields": _vm.successImportFieldsEmit
    }
  }, 'importfields', _vm.importedFields, false))], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('h1', {
    staticClass: "is-title is-bold"
  }, [_vm._v(_vm._s(_vm.$t('index.login')))]), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered is-centered"
  }, [_c('div', {
    staticClass: "column is-one-third-tablet is-one-quarter-desktop"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.email')))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.username),
      expression: "data.body.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "email@example.org"
    },
    domProps: {
      "value": (_vm.data.body.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.password')))]), _vm._v(" "), _c('p', {
    staticClass: "control has-text-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.password),
      expression: "data.body.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('index.password')
    },
    domProps: {
      "value": (_vm.data.body.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.changePass
    }
  }, [_vm._v(_vm._s(_vm.$t('index.profile.forgot_password_link')))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('index.login_message'))
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control has-text-centered"
  }, [_c('button', {
    staticClass: "button  is-medium is-primary ",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('index.login')))])])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isForgotPassword,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isForgotPassword = $event
      }
    }
  }, [_c('forgotpassword')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "title has-text-centered is-size-1 has-text-weight-light"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('index.administrating_reception')) + "\n\n    "), _c('span', {
    staticClass: "has-text-info icon is-large",
    class: {
      'fa-spin': _vm.isloading
    },
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.loadData
    }
  }, [_c('i', {
    staticClass: "fas fa-sync"
  })])]), _vm._v(" "), (_vm.initResponse.objects) ? [_c('div', {
    class: ['wrap', _vm.popupIsShowing ? 'collapseback' : '']
  }, _vm._l((_vm.initResponse.objects), function(object, index) {
    return _c('div', {
      key: index,
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "column is-12"
    }, [_c('article', {
      staticClass: "tile is-child box"
    }, [_c('p', {
      staticClass: "title has-text-weight-light is-pulled-right"
    }, [_vm._v("\n              " + _vm._s(object.name) + " [" + _vm._s(_vm.$t('index.devices_count')) + " " + _vm._s(object.licenseInfo.panels == 'unlim' ? _vm.$t('index.unlim') : object.licenseInfo.panels) + "]\n            ")]), _vm._v(" "), (object.licenseInfo.expired && object.licenseInfo.expired < Date.now()) ? _c('span', {
      staticClass: "tag is-danger has-text-weight-light is-pulled-right",
      staticStyle: {
        "margin-right": "10px",
        "margin-top": "8px"
      }
    }, [_vm._v(_vm._s(_vm.$t('index.trial_expired')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('a', {
      staticClass: "button is-outlined is-info is-medium",
      on: {
        "click": function($event) {
          _vm.showAddNewKey(index, object)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('index.register_client_' + object.licenseInfo.byod_type)))])]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('a', {
      staticClass: "button is-outlined is-info is-medium",
      on: {
        "click": function($event) {
          _vm.showAddNewKey(index, object, 'mauth')
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('index.register_client_' + object.licenseInfo.byod_type)))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-tabs', {
      staticClass: "block",
      attrs: {
        "size": "is-medium"
      }
    }, [_c('b-tab-item', {
      attrs: {
        "label": _vm.$t('index.clients_' + object.licenseInfo.byod_type),
        "icon": "user-circle"
      }
    }, [(_vm.activeTokens(object.tokens)) ? [_c('div', {
      staticClass: "wrap_table"
    }, [_c('table', {
      staticClass: "table is-striped is-fullwidth"
    }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('index.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('index.tag')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('index.registered_devices')))]), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.email')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.phone')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('th', {
      attrs: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(_vm.$t('index.comment')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.arrival_datetime_' + object.licenseInfo.byod_type)))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.departure_datetime_' + object.licenseInfo.byod_type)))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.check_frequency')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.access_by_email')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.custom_session_time')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.custom_panels_limit')))]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('index.actions')))])]), _vm._v(" "), _vm._l((object.tokens), function(tokenPropVal, tokenPropKey) {
      return (tokenPropVal.active) ? _c('tr', {
        key: tokenPropKey
      }, [_c('td', [_vm._v(_vm._s(tokenPropVal.Configuration.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tokenPropVal.Configuration.tag))]), _vm._v(" "), _c('td', [(tokenPropVal.devices) ? _c('a', {
        staticClass: "button is-outlined is-primary is-small",
        on: {
          "click": function($event) {
            _vm.showDevicesDialog(index, object, tokenPropKey, tokenPropVal)
          }
        }
      }, [_vm._v("\n                            " + _vm._s(tokenPropVal.devices.length) + "  \n                            "), _c('i', {
        staticClass: "fas fa-mobile-alt"
      })]) : _vm._e()]), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [_vm._v(_vm._s(tokenPropVal.email))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('td', [_vm._v(_vm._s(_vm._f("facade")(tokenPropVal.phone, '+# (###) ### - ## - ##')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('td', {
        staticStyle: {
          "white-space": "pre-wrap"
        },
        attrs: {
          "width": "20%"
        }
      }, [_c('div', [_vm._v(_vm._s(tokenPropVal.comment))])]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [(tokenPropVal.limitType == 1) ? _c('FDateTime', {
        attrs: {
          "value": tokenPropVal.dateLifeFrom
        }
      }) : _vm._e(), _vm._v(" "), (tokenPropVal.limitType == 2) ? _c('span', [_vm._v("-")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [(tokenPropVal.limitType == 1) ? _c('FDateTime', {
        attrs: {
          "value": tokenPropVal.dateLifeTo
        }
      }) : _vm._e(), _vm._v(" "), (tokenPropVal.limitType == 2) ? _c('span', [_vm._v("-")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [_vm._v(_vm._s(tokenPropVal.limitType == 2 ? tokenPropVal.frequencyCheckPeriod : '-'))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [_vm._v(_vm._s(tokenPropVal.bxRightId ? _vm.$t('index.yes') : '-'))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [(tokenPropVal.limitType == 1 && tokenPropVal.sessionTime) ? _c('span', [_vm._v(" " + _vm._s(tokenPropVal.sessionTime) + " " + _vm._s(_vm.$t('index.minutes')) + " ")]) : _c('span', [_vm._v(" - ")])]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [(tokenPropVal.activationsCount) ? _c('span', [_vm._v("\n                            " + _vm._s(tokenPropVal.activationsCount) + "\n                          ")]) : _c('span', [_vm._v(" - ")])]) : _vm._e(), _vm._v(" "), _c('td', [(object.licenseInfo.byod_type != 'mauth') ? _c('a', {
        staticClass: "button table-btn is-primary is-small",
        on: {
          "click": function($event) {
            _vm.showEditKey(index, tokenPropKey, tokenPropVal)
          }
        }
      }, [_c('span', {
        staticClass: "icon is-small"
      }, [_c('i', {
        staticClass: "fas fa-edit"
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.edit')))])]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('a', {
        staticClass: "button table-btn is-primary is-small",
        on: {
          "click": function($event) {
            _vm.showEditKey(index, tokenPropKey, tokenPropVal, 'mauth')
          }
        }
      }, [_c('span', {
        staticClass: "icon is-small"
      }, [_c('i', {
        staticClass: "fas fa-edit"
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.edit')))])]) : _vm._e(), _vm._v(" "), _c('a', {
        staticClass: "button table-btn is-info is-small",
        on: {
          "click": function($event) {
            _vm.showPushDialog(index, tokenPropKey, tokenPropVal)
          }
        }
      }, [_c('span', {
        staticClass: "icon is-small"
      }, [_c('i', {
        staticClass: "fas fa-comment"
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.send_message')))])]), _vm._v(" "), _c('a', {
        staticClass: "button table-btn is-link is-small",
        on: {
          "click": function($event) {
            _vm.showQR(index, tokenPropKey, tokenPropVal)
          }
        }
      }, [_c('span', {
        staticClass: "icon is-small"
      }, [_c('i', {
        staticClass: "fas fa-qrcode"
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.qr_code')))])])]), _vm._v(" "), _c('div', {
        class: ['modal customStyleModal', tokenPropVal.deleteKey ? 'is-active' : ''],
        staticStyle: {
          "text-align": "left"
        }
      }, [_c('div', {
        staticClass: "modal-background",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.deleteKey = false))
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "modal-content"
      }, [_c('div', {
        staticClass: "box has-text-centered"
      }, [_c('h3', {
        staticClass: "is-size-4"
      }, [_vm._v(_vm._s(_vm.$t('index.deactivate_confirm')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "notification"
      }, [_c('ul', [_c('li', [_vm._v("\n                                    " + _vm._s(_vm.$t('index.object')) + ":\n                                    "), _c('b', [_vm._v(_vm._s(object.name))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    " + _vm._s(_vm.$t('index.configuration')) + ":\n                                    "), _c('b', [_vm._v(_vm._s(tokenPropVal.Configuration.name))])]), _vm._v(" "), _c('li', [_c('br'), _vm._v(_vm._s('index.arrival_datetime_' + object.licenseInfo.byod_type) + ":\n                                    "), _c('FDateTime', {
        attrs: {
          "value": tokenPropVal.dateLifeFrom
        }
      })], 1), _vm._v(" "), _c('li', [_c('br'), _vm._v(_vm._s('index.departure_datetime_' + object.licenseInfo.byod_type) + ":\n                                    "), _c('FDateTime', {
        attrs: {
          "value": tokenPropVal.dateLifeTo
        }
      })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
        staticClass: "button is-text",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.deleteKey = false))
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.cancel')))]), _vm._v(" "), _c('button', {
        staticClass: "button is-danger",
        on: {
          "click": function($event) {
            _vm.deleteKey(index, object, tokenPropKey, tokenPropVal)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.yes')))])])])]), _vm._v(" "), (tokenPropVal.sendingKeyValues) ? _c('div', {
        class: ['modal customStyleModal', tokenPropVal.messageKeyShow ? 'is-active' : ''],
        staticStyle: {
          "text-align": "left"
        }
      }, [_c('div', {
        staticClass: "modal-background",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.messageKeyShow = false))
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "modal-content"
      }, [_c('div', {
        staticClass: "box has-text-centered"
      }, [_c('b-tabs', [_c('b-tab-item', {
        attrs: {
          "label": _vm.$t('index.send_push_message'),
          "icon": "comment-alt"
        }
      }, [_c('h3', {
        staticClass: "is-size-4"
      }, [_vm._v(_vm._s(_vm.$t('index.push_message_for_connected_devices')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "field"
      }, [_c('b-field', [_c('b-input', {
        attrs: {
          "type": "textarea",
          "placeholder": _vm.$t('index.push_message')
        },
        model: {
          value: (tokenPropVal.sendingKeyValues.title),
          callback: function($$v) {
            _vm.$set(tokenPropVal.sendingKeyValues, "title", $$v)
          },
          expression: "tokenPropVal.sendingKeyValues.title"
        }
      })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
        staticClass: "button is-text",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.messageKeyShow = false))
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.close')))]), _vm._v(" "), _c('button', {
        staticClass: "button is-primary",
        attrs: {
          "disabled": !tokenPropVal.sendingKeyValues.title
        },
        on: {
          "click": function($event) {
            _vm.send('push', index, object, tokenPropKey, tokenPropVal)
          }
        }
      }, [_vm._v("\n                                    " + _vm._s(_vm.$t('index.send')) + "\n                                  ")])]), _vm._v(" "), (tokenPropVal.email) ? _c('b-tab-item', {
        attrs: {
          "label": _vm.$t('index.send_email'),
          "icon": "envelope"
        }
      }, [_c('h3', {
        staticClass: "is-size-4"
      }, [_vm._v(_vm._s(_vm.$t('index.email_for', {
        email: tokenPropVal.email
      })))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "field"
      }, [_c('b-field', [_c('b-input', {
        attrs: {
          "type": "textarea",
          "placeholder": _vm.$t('index.email_message')
        },
        model: {
          value: (tokenPropVal.sendingKeyValues.title),
          callback: function($$v) {
            _vm.$set(tokenPropVal.sendingKeyValues, "title", $$v)
          },
          expression: "tokenPropVal.sendingKeyValues.title"
        }
      })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
        staticClass: "button is-text",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.messageKeyShow = false))
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.close')))]), _vm._v(" "), _c('button', {
        staticClass: "button is-info",
        attrs: {
          "disabled": !tokenPropVal.sendingKeyValues.title
        },
        on: {
          "click": function($event) {
            _vm.send('email', index, object, tokenPropKey, tokenPropVal)
          }
        }
      }, [_vm._v("\n                                    " + _vm._s(_vm.$t('index.send')) + "\n                                  ")])]) : _vm._e()], 1)], 1)])]) : _vm._e(), _vm._v(" "), (tokenPropVal.showQRPopup) ? _c('div', {
        class: ['modal customStyleModal', tokenPropVal.showQRPopup ? 'is-active' : ''],
        staticStyle: {
          "text-align": "left"
        }
      }, [_c('div', {
        staticClass: "modal-background",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.showQRPopup = false))
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "modal-content"
      }, [_c('div', {
        staticClass: "box has-text-centered"
      }, [_c('h3', {
        staticClass: "is-size-4"
      }, [_vm._v(_vm._s(_vm.$t('index.scan_it_for_start')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "columns is-mobile is-centered"
      }, [_c('div', {
        staticClass: "column is-half"
      }, [_c('qr-code', {
        attrs: {
          "size": 300,
          "text": _vm.generateQR(tokenPropVal.key, tokenPropVal)
        }
      })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "columns"
      }, [_c('div', {
        staticClass: "column"
      }, [
        [_c('b-field', {
          attrs: {
            "label": _vm.$t('index.arrival_datetime_' + object.licenseInfo.byod_type)
          }
        }, [_c('FDateTime', {
          attrs: {
            "value": tokenPropVal.dateLifeFrom
          }
        })], 1)]
      ], 2), _vm._v(" "), (tokenPropVal.dateLifeTo) ? _c('div', {
        staticClass: "column"
      }, [
        [_c('b-field', {
          attrs: {
            "label": _vm.$t('index.departure_datetime_' + object.licenseInfo.byod_type)
          }
        }, [_c('FDateTime', {
          attrs: {
            "value": tokenPropVal.dateLifeTo
          }
        })], 1)]
      ], 2) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
        staticClass: "button is-info",
        attrs: {
          "href": "javascript:window.print()"
        }
      }, [_vm._v(_vm._s(_vm.$t('index.print')))]), _vm._v(" "), (tokenPropVal.email) ? _c('button', {
        staticClass: "button is-primary",
        on: {
          "click": function($event) {
            _vm.send('emailqr', index, object, tokenPropKey, tokenPropVal)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.send_to_email')))]) : _vm._e(), _vm._v(" "), _c('button', {
        staticClass: "button is-default",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.showQRPopup = false))
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.done')))])])])]) : _vm._e(), _vm._v(" "), (tokenPropVal.devicesKeyShow) ? _c('div', {
        class: ['modal customStyleModal', tokenPropVal.devicesKeyShow ? 'is-active' : ''],
        staticStyle: {
          "text-align": "left"
        }
      }, [_c('div', {
        staticClass: "modal-background",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.devicesKeyShow = false))
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "modal-content"
      }, [_c('div', {
        staticClass: "box has-text-centered"
      }, [_c('h3', {
        staticClass: "is-size-4"
      }, [_vm._v(_vm._s(_vm.$t('index.connected_devices')))]), _vm._v(" "), _c('br'), _vm._v(" "), (tokenPropVal.devices) ? _c('table', {
        staticClass: "table is-striped is-fullwidth",
        staticStyle: {
          "min-width": "100px"
        }
      }, [_c('th', [_vm._v(_vm._s(_vm.$t('index.model')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('index.last_connect_datetime')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('index.push_sent')))]), _vm._v(" "), _vm._l((tokenPropVal.devices), function(device, dindx) {
        return _c('tr', {
          key: dindx
        }, [_c('td', [_vm._v(_vm._s(device.model))]), _vm._v(" "), _c('td', [_c('FDateTime', {
          attrs: {
            "value": device.lastConnect
          }
        })], 1), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(device.pushCount) + "\n                                  ")])])
      })], 2) : _c('i', [_vm._v(_vm._s(_vm.$t('index.connected_devices_not_found')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
        staticClass: "button is-text",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.devicesKeyShow = false))
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.close')))])])])]) : _vm._e()]) : _vm._e()
    })], 2)])] : [_c('i', [_vm._v(_vm._s(_vm.$t('index.no_clients_found_' + object.licenseInfo.byod_type)))])]], 2), _vm._v(" "), _c('b-tab-item', {
      attrs: {
        "label": _vm.$t('index.history'),
        "icon": "history"
      }
    }, [(_vm.inactiveTokens(object.tokens)) ? [_c('div', {
      staticClass: "wrap_table"
    }, [_c('table', {
      staticClass: "table is-striped is-fullwidth"
    }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('index.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('index.tag')))]), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.email')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.phone')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('th', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(_vm.$t('index.comment')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.arrival_datetime_' + object.licenseInfo.byod_type)))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.departure_datetime_' + object.licenseInfo.byod_type)))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.check_frequency')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.access_by_email')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('th', [_vm._v(_vm._s(_vm.$t('index.custom_panels_limit')))]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('index.actions')))])]), _vm._v(" "), _vm._l((object.tokens), function(tokenPropVal, tokenPropKey) {
      return (!tokenPropVal.active) ? _c('tr', {
        key: tokenPropKey
      }, [_c('td', [_vm._v(_vm._s(tokenPropVal.Configuration.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tokenPropVal.Configuration.tag))]), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [_vm._v(_vm._s(tokenPropVal.email))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('td', [_vm._v(_vm._s(_vm._f("facade")(tokenPropVal.phone, '+# (###) ### - ## - ##')))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type == 'mauth') ? _c('td', {
        staticStyle: {
          "white-space": "pre-wrap"
        },
        attrs: {
          "width": "15%"
        }
      }, [_vm._v(_vm._s(tokenPropVal.comment))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [(tokenPropVal.limitType == 1) ? _c('FDateTime', {
        attrs: {
          "value": tokenPropVal.dateLifeFrom
        }
      }) : _vm._e(), _vm._v(" "), (tokenPropVal.limitType == 2) ? _c('span', [_vm._v("-")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [(tokenPropVal.limitType == 1) ? _c('FDateTime', {
        attrs: {
          "value": tokenPropVal.dateLifeTo
        }
      }) : _vm._e(), _vm._v(" "), (tokenPropVal.limitType == 2) ? _c('span', [_vm._v("-")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [_vm._v(_vm._s(tokenPropVal.limitType == 2 ? tokenPropVal.frequencyCheckPeriod : '-'))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [_vm._v(_vm._s(tokenPropVal.bxRightId ? _vm.$t('index.yes') : '-'))]) : _vm._e(), _vm._v(" "), (object.licenseInfo.byod_type != 'mauth') ? _c('td', [(tokenPropVal.activationsCount) ? _c('span', [_vm._v("\n                            " + _vm._s(tokenPropVal.activationsCount) + "\n                          ")]) : _c('span', [_vm._v(" - ")])]) : _vm._e(), _vm._v(" "), _c('td', [_c('a', {
        staticClass: "button is-outlined is-small",
        on: {
          "click": function($event) {
            _vm.showDeleteKey(index, tokenPropKey, tokenPropVal)
          }
        }
      }, [_c('span', {
        staticClass: "icon is-small"
      }, [_c('i', {
        staticClass: "fas fa-times"
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('index.delete')))])])]), _vm._v(" "), _c('div', {
        class: ['modal customStyleModal', tokenPropVal.deleteKey ? 'is-active' : ''],
        staticStyle: {
          "text-align": "left"
        }
      }, [_c('div', {
        staticClass: "modal-background"
      }), _vm._v(" "), _c('div', {
        staticClass: "modal-content"
      }, [_c('div', {
        staticClass: "box has-text-centered"
      }, [_c('h3', {
        staticClass: "is-size-4"
      }, [_vm._v(_vm._s(_vm.$t('index.delete_history_key_confirm')))]), _vm._v(" "), _c('span', {
        staticClass: "tag is-danger"
      }, [_vm._v(_vm._s(_vm.$t('index.delete_history_key_warning')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
        staticClass: "notification"
      }, [_c('ul', [_c('li', [_vm._v("\n                                    " + _vm._s(_vm.$t('index.object')) + ":\n                                    "), _c('b', [_vm._v(_vm._s(object.name))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    " + _vm._s(_vm.$t('index.configuration')) + ":\n                                    "), _c('b', [_vm._v(_vm._s(tokenPropVal.Configuration.name))])]), _vm._v(" "), _c('li', [_c('br'), _vm._v(_vm._s(_vm.$t('index.arrival_datetime_' + object.licenseInfo.byod_type)) + ":\n                                    "), _c('FDateTime', {
        attrs: {
          "value": tokenPropVal.dateLifeFrom
        }
      })], 1), _vm._v(" "), (tokenPropVal.dateLifeTo) ? _c('li', [_c('br'), _vm._v(_vm._s(_vm.$t('index.departure_datetime_' + object.licenseInfo.byod_type)) + ":\n                                    "), _c('FDateTime', {
        attrs: {
          "value": tokenPropVal.dateLifeTo
        }
      })], 1) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
        staticClass: "button is-text",
        on: {
          "click": function($event) {
            _vm.hidePopup((tokenPropVal.deleteKey = false))
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.cancel')))]), _vm._v(" "), _c('button', {
        staticClass: "button is-danger",
        on: {
          "click": function($event) {
            _vm.deleteKey(index, object, tokenPropKey, tokenPropVal)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('index.yes')))])])])])]) : _vm._e()
    })], 2)])] : [_c('i', [_vm._v(_vm._s(_vm.$t('index.no_history_records_found')))])]], 2)], 1)], 1)])])
  })), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.addKeyShowModal,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.addKeyShowModal = $event
      }
    }
  }, [_c('registertoken', _vm._b({
    on: {
      "init_response_push": _vm.emitInitResponsePush,
      "init_load_data": _vm.emitLoadData,
      "show_qr": _vm.emitShowQR
    }
  }, 'registertoken', _vm.addNewKeyData, false))], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.editKeyShowModal,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.editKeyShowModal = $event
      }
    }
  }, [_c('updatetoken', _vm._b({
    on: {
      "init_response_update": _vm.emitInitResponseUpdate
    }
  }, 'updatetoken', _vm.editKeyData, false))], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.addKeyShowModalMauth,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.addKeyShowModalMauth = $event
      }
    }
  }, [_c('registermauth', _vm._b({
    on: {
      "init_response_push": _vm.emitInitResponsePush,
      "init_load_data": _vm.emitLoadData,
      "show_qr": _vm.emitShowQR
    }
  }, 'registermauth', _vm.addNewKeyData, false))], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.editKeyShowModalMauth,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.editKeyShowModalMauth = $event
      }
    }
  }, [_c('updatemauth', _vm._b({
    on: {
      "init_response_update": _vm.emitInitResponseUpdate
    }
  }, 'updatemauth', _vm.editKeyData, false))], 1)] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('index.set_room_fields_hotel', {
    roomname: _vm.roomData.name,
    roomtag: _vm.roomData.tag
  })))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body roomfieldsbody"
  }, [_c('b-table', {
    attrs: {
      "data": _vm.resultFields,
      "loading": !_vm.resultFields.length,
      "striped": true,
      "narrowed": false,
      "mobile-cards": true,
      "paginated": false,
      "per-page": 10,
      "pagination-simple": true,
      "default-sort": "['type', 'desc']"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "name",
            "label": _vm.$t('index.name'),
            "width": "210"
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.name))])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": _vm.$t('index.value'),
            "field": "value",
            "width": "200"
          }
        }, [_c('b-field', [(props.row.value || props.row.type === 1) ? _c('b-input', {
          attrs: {
            "disabled": _vm.isEditable(props.row.name),
            "expanded": ""
          },
          on: {
            "input": function($event) {
              _vm.setCustomValue($event, props.row, props.index)
            }
          },
          model: {
            value: (props.row.value),
            callback: function($$v) {
              _vm.$set(props.row, "value", $$v)
            },
            expression: "props.row.value"
          }
        }) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": _vm.$t('index.edit_by_customer'),
            "field": "edit",
            "width": "40",
            "centered": ""
          }
        }, [_c('b-checkbox', {
          attrs: {
            "type": "is-info",
            "disabled": props.row.type !== 1
          },
          model: {
            value: (props.row.edit),
            callback: function($$v) {
              _vm.$set(props.row, "edit", $$v)
            },
            expression: "props.row.edit"
          }
        })], 1), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "tools",
            "label": "",
            "width": "40",
            "centered": ""
          }
        }, [(!_vm.isEditable(props.row.name) && !props.row.defVal) ? _c('button', {
          staticClass: "button is-default",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.resetField(props.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('index.reset')))]) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.close')))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half has-text-right"
  }, [(!_vm.validateCustomFieldError) ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.saveFileds
    }
  }, [_vm._v(_vm._s(_vm.$t('index.save')))]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main",
    class: _vm.$auth.check() ? "active-margin-with-menu" : ""
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content"
  }, [_c('levelbar'), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.obj != null) ? _c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('b-loading', {
    attrs: {
      "active": _vm.isloading,
      "can-cancel": false
    },
    on: {
      "update:active": function($event) {
        _vm.isloading = $event
      }
    }
  }), _vm._v(" "), _c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('index.register_client_popup_' + _vm.obj.licenseInfo.byod_type)) + " Mobile Auth")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {}, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('b-field', {
    attrs: {
      "label": '* ' + _vm.$t('index.select_configuration_' + _vm.obj.licenseInfo.byod_type),
      "type": _vm.obj.newKeyValues.configurationId ? 'default' : 'is-danger'
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select the configuration and room",
      "required": "",
      "expanded": ""
    },
    on: {
      "input": _vm.selectRoom
    },
    model: {
      value: (_vm.obj.newKeyValues.configurationId),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "configurationId", $$v)
      },
      expression: "obj.newKeyValues.configurationId"
    }
  }, _vm._l((_vm.getFreeConfigurations(_vm.obj)), function(conf) {
    return _c('option', {
      key: conf.id,
      domProps: {
        "value": conf.id
      }
    }, [_vm._v(_vm._s(conf.tag) + ": " + _vm._s(conf.name))])
  }))], 1)], 1)]), _vm._v(" "), (_vm.obj.newKeyValues.limitType == 1) ? _c('div', {
    staticClass: "limit_type_1"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.arrival_date_' + _vm.obj.licenseInfo.byod_type)
      }
    }, [_c('b-datepicker', {
      attrs: {
        "min-date": _vm.minDate,
        "placeholder": "Click to select...",
        "icon": "calendar-alt"
      },
      on: {
        "input": function($event) {
          _vm.onchangeDateLifeFrom($event, _vm.obj, _vm.objIndx)
        }
      },
      model: {
        value: (_vm.obj.newKeyValues.dateLifeFrom),
        callback: function($$v) {
          _vm.$set(_vm.obj.newKeyValues, "dateLifeFrom", $$v)
        },
        expression: "obj.newKeyValues.dateLifeFrom"
      }
    })], 1)]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.arrival_time_' + _vm.obj.licenseInfo.byod_type)
      }
    }, [_c('b-timepicker', {
      attrs: {
        "hour-format": "24",
        "placeholder": "Type or select a date...",
        "icon": "clock",
        "readonly": false
      },
      model: {
        value: (_vm.obj.newKeyValues.dateLifeFrom),
        callback: function($$v) {
          _vm.$set(_vm.obj.newKeyValues, "dateLifeFrom", $$v)
        },
        expression: "obj.newKeyValues.dateLifeFrom"
      }
    })], 1)]
  ], 2)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.departure_date_' + _vm.obj.licenseInfo.byod_type)
      }
    }, [_c('b-datepicker', {
      attrs: {
        "min-date": _vm.minDate,
        "placeholder": "Click to select...",
        "icon": "calendar-alt"
      },
      on: {
        "input": function($event) {
          _vm.onchangeDateLifeTo($event, _vm.obj, _vm.objIndx)
        }
      },
      model: {
        value: (_vm.obj.newKeyValues.dateLifeTo),
        callback: function($$v) {
          _vm.$set(_vm.obj.newKeyValues, "dateLifeTo", $$v)
        },
        expression: "obj.newKeyValues.dateLifeTo"
      }
    })], 1)]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.departure_time_' + _vm.obj.licenseInfo.byod_type)
      }
    }, [_c('b-timepicker', {
      attrs: {
        "hour-format": "24",
        "placeholder": "Type or select a date...",
        "icon": "clock",
        "readonly": false
      },
      model: {
        value: (_vm.obj.newKeyValues.dateLifeTo),
        callback: function($$v) {
          _vm.$set(_vm.obj.newKeyValues, "dateLifeTo", $$v)
        },
        expression: "obj.newKeyValues.dateLifeTo"
      }
    })], 1)]
  ], 2)]), _vm._v(" "), _c('div', {
    staticClass: "columns session_block"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.session_time')))]), _vm._v(" "), _c('b-checkbox', {
    model: {
      value: (_vm.obj.newKeyValues.sessionTimeOption),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "sessionTimeOption", $$v)
      },
      expression: "obj.newKeyValues.sessionTimeOption"
    }
  }, [_vm._v(_vm._s(_vm.$t('index.custom_time_cb')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('b-tooltip', {
    attrs: {
      "label": "Default and max value 30days (43200 minutes)",
      "multilined": ""
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(!_vm.obj.newKeyValues.sessionTimeOption ? _vm.$t('index.default') : _vm.$t('index.custom_time')))])]), _vm._v(" "), (!_vm.obj.newKeyValues.sessionTimeOption) ? _c('div', [_c('b', [_vm._v("30 " + _vm._s(_vm.$t('index.days')))])]) : _c('div', [_c('b-field', [_c('b-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "43200",
      "icon": "clock",
      "placeholder": _vm.$t('index.minutes')
    },
    model: {
      value: (_vm.obj.newKeyValues.sessionTimeValue),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "sessionTimeValue", $$v)
      },
      expression: "obj.newKeyValues.sessionTimeValue"
    }
  })], 1)], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.phone_number')))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-field', [_c('b-input', {
    directives: [{
      name: "facade",
      rawName: "v-facade",
      value: ('+# (###) ### - ## - ##'),
      expression: "'+# (###) ### - ## - ##'"
    }],
    attrs: {
      "masked": false,
      "type": "text",
      "icon": "phone",
      "placeholder": "+_ (___) ___−__−__"
    },
    nativeOn: {
      "input": function($event) {
        return _vm.onInput($event)
      }
    },
    model: {
      value: (_vm.obj.newKeyValues.phone),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "phone", $$v)
      },
      expression: "obj.newKeyValues.phone"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.comment')))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "type": "textarea",
      "maxlength": "255"
    },
    model: {
      value: (_vm.obj.newKeyValues.comment),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "comment", $$v)
      },
      expression: "obj.newKeyValues.comment"
    }
  })], 1)], 1)])])]), _vm._v(" "), (_vm.fields.length) ? _c('div', {
    staticClass: "columns is-multiline",
    staticStyle: {
      "max-width": "480px"
    }
  }, _vm._l((_vm.fields), function(customField, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (customField.edit),
        expression: "customField.edit"
      }],
      key: i,
      staticClass: "column is-half"
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', {
      staticClass: "label"
    }, [_vm._v(_vm._s(customField.name))]), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, [_c('b-field', [_c('b-input', {
      attrs: {
        "type": "text"
      },
      on: {
        "input": function($event) {
          _vm.setCustomValue($event, customField, i)
        }
      },
      model: {
        value: (customField.value),
        callback: function($$v) {
          _vm.$set(customField, "value", $$v)
        },
        expression: "customField.value"
      }
    })], 1)], 1)])])
  })) : _vm._e()])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.cancel')))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half has-text-right"
  }, [_c('button', {
    staticClass: "button is-success",
    attrs: {
      "disabled": !_vm.validate
    },
    on: {
      "click": function($event) {
        _vm.addNewKey(_vm.objIndx, _vm.obj)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.register')))])])])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar animated",
    class: {
      slideInLeft: _vm.show, slideOutLeft: !_vm.show
    }
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.$t('index.general_sidebar')) + "\n\t")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.menu), function(item, index) {
    return _c('li', {
      key: index
    }, [(item.path) ? _c('router-link', {
      attrs: {
        "to": item.path,
        "exact": true,
        "aria-expanded": _vm.isExpanded(item) ? 'true' : 'false'
      },
      nativeOn: {
        "click": function($event) {
          _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n\t\t\t\t" + _vm._s(item.meta.label || _vm.$t(item.name)) + "\n\t\t\t\t"), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : _c('a', {
      attrs: {
        "aria-expanded": _vm.isExpanded(item)
      },
      on: {
        "click": function($event) {
          _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n\t\t\t\t" + _vm._s(item.meta.label || _vm.$t(item.name)) + "\n\t\t\t\t"), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]), _vm._v(" "), (item.children && item.children.length) ? _c('expanding', [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExpanded(item)),
        expression: "isExpanded(item)"
      }]
    }, _vm._l((item.children), function(subItem, subkey) {
      return (subItem.path) ? _c('li', {
        key: subkey
      }, [_c('router-link', {
        attrs: {
          "to": _vm.generatePath(item, subItem)
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(subItem.meta && subItem.meta.label || subItem.name) + "\n\t\t\t\t\t\t")])], 1) : _vm._e()
    }))]) : _vm._e()], 1)
  })), _vm._v(" "), _c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n\t\t-----\n\t")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [(!_vm.$auth.check()) ? _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")]) : _vm._e(), _vm._v(" "), (_vm.$auth.check()) ? _c('a', {
    staticClass: "nav-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(_vm._s(_vm.$t('index.logout')) + "\n\t\t\t\t"), _vm._m(0)]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-sign-out-alt"
  })])
}]}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  })])])
}]}

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.animation,
      "mode": "out-in",
      "appear": "",
      "appear-active-class": _vm.transition.enterClass,
      "enter-active-class": _vm.transition.enterClass,
      "leave-active-class": _vm.transition.leaveClass
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realSelected),
      expression: "realSelected"
    }],
    class: _vm.classObject,
    attrs: {
      "role": "tabpanel",
      "aria-labelledby": _vm.label,
      "aria-hidden": _vm.hidden
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    class: _vm.classObject,
    attrs: {
      "role": "tablist"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "navbar is-transparent"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    staticClass: "navbar-item",
    attrs: {
      "href": "/#"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(277)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "vue"
  }, [_vm._v(_vm._s(_vm.$t('index.navbar_title')))])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger burger animated is-hidden-tablet",
    on: {
      "click": function($event) {
        _vm.toggleSidebar(!_vm.sidebar.opened)
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-end is-hidden-touch"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "select is-small"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$i18n.locale),
      expression: "$i18n.locale"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$i18n, "locale", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ru"
    }
  }, [_vm._v("Русский")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v("English")])])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nprogress-container"
  })
},staticRenderFns: []}

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ( _obj = {
      'vue-bulma-tabs': true
    }, _obj[("is-layout-" + _vm.layout)] = true, _obj )
  }, [_c('div', {
    class: ( _obj$1 = {
      tabs: true, 'is-fullwidth': _vm.isFullwidth
    }, _obj$1[("is-" + _vm.size)] = _vm.size, _obj$1[("is-" + _vm.alignment)] = _vm.alignment, _obj$1[("is-" + _vm.type)] = _vm.type, _obj$1 )
  }, [_vm._t("left-tab-list"), _vm._v(" "), _c('tab-list', _vm._l((_vm.tabPanes), function(tab, index) {
    return _c('li', {
      class: {
        'is-active': _vm.isActived(index), 'is-disabled': tab.disabled, 'is-flex': true
      },
      attrs: {
        "role": "tab",
        "aria-selected": _vm.isActived(index) ? 'true' : 'false',
        "aria-expanded": _vm.isActived(index) ? 'true' : 'false',
        "aria-disabled": tab.disabled ? 'true' : 'false',
        "selected": _vm.isActived(index),
        "disabled": tab.disabled
      },
      on: {
        "click": function($event) {
          _vm.select(index)
        }
      }
    }, [_c('a', {
      staticClass: "is-unselectable"
    }, [(tab.icon) ? _c('span', {
      class: ['icon', {
        'is-small': _vm.size !== 'large'
      }]
    }, [_c('i', {
      class: tab.icon
    })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(tab.label))])])])
  })), _vm._v(" "), _vm._t("right-tab-list")], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content is-flex"
  }, [_vm._t("default")], 2)])
  var _obj;
  var _obj$1;
},staticRenderFns: []}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapse is-fullwidth"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('b-loading', {
    attrs: {
      "active": _vm.isloading,
      "can-cancel": false
    },
    on: {
      "update:active": function($event) {
        _vm.isloading = $event
      }
    }
  }), _vm._v(" "), _c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('index.register_client_popup_' + _vm.obj.licenseInfo.byod_type)))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {}, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('b-field', {
    attrs: {
      "label": '* ' + _vm.$t('index.select_configuration_' + _vm.obj.licenseInfo.byod_type),
      "type": _vm.obj.newKeyValues.configurationId ? 'default' : 'is-danger'
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select the configuration and room",
      "required": "",
      "expanded": ""
    },
    on: {
      "input": _vm.selectRoom
    },
    model: {
      value: (_vm.obj.newKeyValues.configurationId),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "configurationId", $$v)
      },
      expression: "obj.newKeyValues.configurationId"
    }
  }, _vm._l((_vm.getFreeConfigurations(_vm.obj)), function(conf) {
    return _c('option', {
      key: conf.id,
      domProps: {
        "value": conf.id
      }
    }, [_vm._v(_vm._s(conf.tag) + ": " + _vm._s(conf.name))])
  }))], 1)], 1)]), _vm._v(" "), _c('div', [_c('b-field', [_c('b-radio', {
    attrs: {
      "native-value": "1",
      "type": "is-danger"
    },
    model: {
      value: (_vm.obj.newKeyValues.limitType),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "limitType", $$v)
      },
      expression: "obj.newKeyValues.limitType"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('index.limited_by_datetime')) + "\n            ")])], 1), _vm._v(" "), _c('b-field', [_c('b-radio', {
    attrs: {
      "native-value": "2",
      "type": "is-info"
    },
    model: {
      value: (_vm.obj.newKeyValues.limitType),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "limitType", $$v)
      },
      expression: "obj.newKeyValues.limitType"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('index.unlimited_duration')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.obj.newKeyValues.limitType == 2) ? _c('div', {
    staticClass: "limit_type_2"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.check_frequency')
      }
    }, [_c('b-input', {
      attrs: {
        "type": "number",
        "min": "1",
        "max": "7",
        "icon": "clock",
        "placeholder": _vm.$t('index.days')
      },
      model: {
        value: (_vm.obj.newKeyValues.frequencyCheckPeriod),
        callback: function($$v) {
          _vm.$set(_vm.obj.newKeyValues, "frequencyCheckPeriod", $$v)
        },
        expression: "obj.newKeyValues.frequencyCheckPeriod"
      }
    })], 1)]
  ], 2)])]) : _vm._e(), _vm._v(" "), (_vm.obj.newKeyValues.limitType == 1) ? _c('div', {
    staticClass: "limit_type_1"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.arrival_date_' + _vm.obj.licenseInfo.byod_type)
      }
    }, [_c('b-datepicker', {
      attrs: {
        "min-date": _vm.minDate,
        "placeholder": "Click to select...",
        "icon": "calendar-alt"
      },
      on: {
        "input": function($event) {
          _vm.onchangeDateLifeFrom($event, _vm.obj, _vm.objIndx)
        }
      },
      model: {
        value: (_vm.obj.newKeyValues.dateLifeFrom),
        callback: function($$v) {
          _vm.$set(_vm.obj.newKeyValues, "dateLifeFrom", $$v)
        },
        expression: "obj.newKeyValues.dateLifeFrom"
      }
    })], 1)]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.arrival_time_' + _vm.obj.licenseInfo.byod_type)
      }
    }, [_c('b-timepicker', {
      attrs: {
        "hour-format": "24",
        "placeholder": "Type or select a date...",
        "icon": "clock",
        "readonly": false
      },
      model: {
        value: (_vm.obj.newKeyValues.dateLifeFrom),
        callback: function($$v) {
          _vm.$set(_vm.obj.newKeyValues, "dateLifeFrom", $$v)
        },
        expression: "obj.newKeyValues.dateLifeFrom"
      }
    })], 1)]
  ], 2)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.departure_date_' + _vm.obj.licenseInfo.byod_type)
      }
    }, [_c('b-datepicker', {
      attrs: {
        "min-date": _vm.minDate,
        "placeholder": "Click to select...",
        "icon": "calendar-alt"
      },
      on: {
        "input": function($event) {
          _vm.onchangeDateLifeTo($event, _vm.obj, _vm.objIndx)
        }
      },
      model: {
        value: (_vm.obj.newKeyValues.dateLifeTo),
        callback: function($$v) {
          _vm.$set(_vm.obj.newKeyValues, "dateLifeTo", $$v)
        },
        expression: "obj.newKeyValues.dateLifeTo"
      }
    })], 1)]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.departure_time_' + _vm.obj.licenseInfo.byod_type)
      }
    }, [_c('b-timepicker', {
      attrs: {
        "hour-format": "24",
        "placeholder": "Type or select a date...",
        "icon": "clock",
        "readonly": false
      },
      model: {
        value: (_vm.obj.newKeyValues.dateLifeTo),
        callback: function($$v) {
          _vm.$set(_vm.obj.newKeyValues, "dateLifeTo", $$v)
        },
        expression: "obj.newKeyValues.dateLifeTo"
      }
    })], 1)]
  ], 2)]), _vm._v(" "), _c('div', {
    staticClass: "columns session_block"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.session_time')))]), _vm._v(" "), _c('b-checkbox', {
    model: {
      value: (_vm.obj.newKeyValues.sessionTimeOption),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "sessionTimeOption", $$v)
      },
      expression: "obj.newKeyValues.sessionTimeOption"
    }
  }, [_vm._v(_vm._s(_vm.$t('index.custom_time_cb')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('b-tooltip', {
    attrs: {
      "label": "Default and max value 30days (43200 minutes)",
      "multilined": ""
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(!_vm.obj.newKeyValues.sessionTimeOption ? _vm.$t('index.default') : _vm.$t('index.custom_time')))])]), _vm._v(" "), (!_vm.obj.newKeyValues.sessionTimeOption) ? _c('div', [_c('b', [_vm._v("30 " + _vm._s(_vm.$t('index.days')))])]) : _c('div', [_c('b-field', [_c('b-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "43200",
      "icon": "clock",
      "placeholder": _vm.$t('index.minutes')
    },
    model: {
      value: (_vm.obj.newKeyValues.sessionTimeValue),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "sessionTimeValue", $$v)
      },
      expression: "obj.newKeyValues.sessionTimeValue"
    }
  })], 1)], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.email')))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "type": "email",
      "icon": "envelope",
      "placeholder": _vm.$t('index.email')
    },
    model: {
      value: (_vm.obj.newKeyValues.email),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "email", $$v)
      },
      expression: "obj.newKeyValues.email"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.obj.licenseInfo.user_manage) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('b-field', [_c('b-checkbox', {
    attrs: {
      "disabled": !_vm.obj.newKeyValues.email
    },
    model: {
      value: (_vm.obj.newKeyValues.proLogin),
      callback: function($$v) {
        _vm.$set(_vm.obj.newKeyValues, "proLogin", $$v)
      },
      expression: "obj.newKeyValues.proLogin"
    }
  }, [_vm._v(_vm._s(_vm.$t('index.use_as_login')) + " ")])], 1)], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.activation_panels_limit')
      }
    }, [_c('b-input', {
      attrs: {
        "placeholder": _vm.$t('index.activation_panels_limit_placeholder'),
        "type": "number",
        "min": "1",
        "icon": "clock"
      },
      model: {
        value: (_vm.obj.newKeyValues.activationsCount),
        callback: function($$v) {
          _vm.$set(_vm.obj.newKeyValues, "activationsCount", $$v)
        },
        expression: "obj.newKeyValues.activationsCount"
      }
    })], 1)]
  ], 2)])]), _vm._v(" "), (_vm.fields.length) ? _c('div', {
    staticClass: "columns is-multiline",
    staticStyle: {
      "max-width": "480px"
    }
  }, _vm._l((_vm.fields), function(customField, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (customField.edit),
        expression: "customField.edit"
      }],
      key: i,
      staticClass: "column is-half"
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', {
      staticClass: "label"
    }, [_vm._v(_vm._s(customField.name))]), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, [_c('b-field', [_c('b-input', {
      attrs: {
        "type": "text"
      },
      on: {
        "input": function($event) {
          _vm.setCustomValue($event, customField, i)
        }
      },
      model: {
        value: (customField.value),
        callback: function($$v) {
          _vm.$set(customField, "value", $$v)
        },
        expression: "customField.value"
      }
    })], 1)], 1)])])
  })) : _vm._e()])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.cancel')))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half has-text-right"
  }, [_c('button', {
    staticClass: "button is-success",
    attrs: {
      "disabled": !_vm.validate
    },
    on: {
      "click": function($event) {
        _vm.addNewKey(_vm.objIndx, _vm.obj)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.register')))])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('navbar', {
    attrs: {
      "show": true
    }
  }), _vm._v(" "), (_vm.$auth.check()) ? _c('sidebar', {
    attrs: {
      "show": _vm.sidebar.opened && !_vm.sidebar.hidden
    }
  }) : _vm._e(), _vm._v(" "), _c('app-main')], 1)
},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Parsed data from your csv file for importing to object "), _c('b', [_vm._v(_vm._s(_vm.objName))])])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('b-loading', {
    attrs: {
      "is-full-page": false,
      "active": _vm.loading,
      "can-cancel": false
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  }), _vm._v(" "), (_vm.errors.length) ? _c('div', [_c('p', {
    staticClass: "subtitle is-4"
  }, [_vm._v("CSV parsing errors:")]), _vm._v(" "), _c('ol', {
    staticClass: "notification is-danger"
  }, _vm._l((_vm.errors), function(err, errIndx) {
    return _c('li', {
      key: errIndx
    }, [_vm._v("\n            " + _vm._s(err.description) + "\n          ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.importErrors.length) ? _c('div', [_c('p', {
    staticClass: "subtitle is-4"
  }, [_vm._v("Parsed data saving errors:")]), _vm._v(" "), _c('ol', {
    staticClass: "notification is-danger"
  }, _vm._l((_vm.importErrors), function(err, errIndx) {
    return _c('li', {
      key: errIndx
    }, [_vm._v("\n            " + _vm._s(err.description) + "\n          ")])
  })), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.errors.length) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-fifth csv-column"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n              Configurations\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.resultFields), function(conf, confIndx) {
    return _c('li', {
      key: confIndx
    }, [_c('a', {
      attrs: {
        "href": "#" + confIndx
      }
    }, [_vm._v(_vm._s(confIndx))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "column csv-column"
  }, _vm._l((_vm.resultFields), function(conf, confIndx) {
    return _c('div', {
      key: confIndx,
      staticClass: "box",
      attrs: {
        "label": confIndx
      }
    }, [_c('a', {
      attrs: {
        "name": confIndx
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "title is-3"
    }, [_vm._v(_vm._s(confIndx))]), _vm._v(" "), _c('p', {
      staticClass: "subtitle is-5 has-text-centered"
    }, [_vm._v("Configuration fields:")]), _vm._v(" "), _c('b-table', {
      attrs: {
        "data": conf.fields
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(props) {
          return [_c('b-table-column', {
            attrs: {
              "label": "Field name",
              "field": "name",
              "width": "40"
            }
          }, [_vm._v("\n                  " + _vm._s(props.row.name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
            attrs: {
              "label": "Default value",
              "field": "edit",
              "width": "40"
            }
          }, [_vm._v("\n                  " + _vm._s(props.row.value) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
            attrs: {
              "label": "Edit by customer",
              "field": "edit",
              "width": "40",
              "centered": ""
            }
          }, [(props.row.type === 1) ? _c('b-checkbox', {
            attrs: {
              "type": "is-info",
              "disabled": true
            },
            model: {
              value: (props.row.edit),
              callback: function($$v) {
                _vm.$set(props.row, "edit", $$v)
              },
              expression: "props.row.edit"
            }
          }) : _vm._e()], 1)]
        }
      }])
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "subtitle is-5 has-text-centered"
    }, [_vm._v("Room fields values:")]), _vm._v(" "), (conf.roomfieldsview.length) ? _c('b-table', {
      staticStyle: {
        "overflow": "auto",
        "background": "#fafafa"
      },
      attrs: {
        "data": _vm.bodyRooms(conf.roomfieldsview),
        "columns": _vm.headRooms(conf.roomfieldsview),
        "width": "500"
      }
    }) : _vm._e()], 1)
  }))]) : _vm._e()], 1), _vm._v(" "), (!_vm.loading) ? _c('footer', {
    staticClass: "modal-card-foot columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.close()
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half has-text-right"
  }, [(!_vm.errors.length) ? _c('button', {
    staticClass: "button is-info ",
    on: {
      "click": function($event) {
        _vm.isConfirm = true
      }
    }
  }, [_vm._v("Data is correct. Import fields")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isConfirm,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isConfirm = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('span', {
    staticClass: "modal-card-title"
  }, [_vm._v("Choose import variant\n\n        ")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('b-radio', {
    attrs: {
      "native-value": "1",
      "type": "is-info",
      "checked": ""
    },
    model: {
      value: (_vm.importType),
      callback: function($$v) {
        _vm.importType = $$v
      },
      expression: "importType"
    }
  }, [_vm._v("\n            Replace existing configuration fields, rooms, rooms fields, clients custom fields\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-radio', {
    attrs: {
      "native-value": "2",
      "type": "is-danger"
    },
    model: {
      value: (_vm.importType),
      callback: function($$v) {
        _vm.importType = $$v
      },
      expression: "importType"
    }
  }, [_vm._v("\n            Delete existing configuration fields, rooms, rooms fields, clients custom fields and save new\n          ")])], 1)]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isConfirm = false
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half has-text-right"
  }, [(!_vm.errors.length) ? _c('button', {
    staticClass: "button is-info ",
    on: {
      "click": _vm.importFileds
    }
  }, [_vm._v("Import")]) : _vm._e()])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "is-bold has-text-centered"
  }, [_vm._v("iRidium BYOD " + _vm._s(this.$store.state.pkg.Version))]), _vm._v(" "), _c('h3', {
    staticClass: "is-bold has-text-centered"
  }, [_vm._v(_vm._s(_vm.$t('index.reg_center')))]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.$auth.check()) ? _c('section', {
    staticClass: "section has-text-centered"
  }, [_c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/login"
    }
  }, [_c('button', {
    staticClass: "button is-info is-large"
  }, [_vm._v(_vm._s(_vm.$t('index.login')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.$auth.check()) ? _c('section', {
    staticClass: "section has-text-centered"
  }, [_c('a', {
    staticClass: "button is-large",
    attrs: {
      "href": "/#/administration_manager"
    }
  }, [_vm._v(_vm._s(_vm.$t('index.go_to_object_adm')))]), _vm._v(" "), _c('a', {
    staticClass: "button is-large",
    attrs: {
      "href": "/#/reception_manager"
    }
  }, [_vm._v(_vm._s(_vm.$t('index.go_to_reception_adm')))])]) : _vm._e(), _vm._v(" "), (_vm.$auth.check()) ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-full-mobile is-half-desktop is-offset-one-quarter-desktop "
  }, [_c('h2', {
    staticClass: "is-bold has-text-centered"
  }, [_vm._v(_vm._s(_vm.$t('index.profile.user_info')))]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": _vm.$t('index.profile.login'),
      "type": {
        'is-danger': !_vm.data.login
      },
      "message": ( _obj = {}, _obj[_vm.$t('index.profile.errors.fill_this_field')] = !_vm.data.login, _obj )
    }
  }, [_c('b-input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.data.login),
      callback: function($$v) {
        _vm.$set(_vm.data, "login", $$v)
      },
      expression: "data.login"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": _vm.$t('index.profile.name'),
      "type": {
        'is-danger': !_vm.data.name
      },
      "message": ( _obj$1 = {}, _obj$1[_vm.$t('index.profile.errors.fill_this_field')] = !_vm.data.name, _obj$1 )
    }
  }, [_c('b-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.data.name),
      callback: function($$v) {
        _vm.$set(_vm.data, "name", $$v)
      },
      expression: "data.name"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": _vm.$t('index.profile.lastname'),
      "type": {
        'is-danger': !_vm.data.lastname
      },
      "message": ( _obj$2 = {}, _obj$2[_vm.$t('index.profile.errors.fill_this_field')] = !_vm.data.lastname, _obj$2 )
    }
  }, [_c('b-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.data.lastname),
      callback: function($$v) {
        _vm.$set(_vm.data, "lastname", $$v)
      },
      expression: "data.lastname"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "button is-large",
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v(_vm._s(_vm.$t('index.profile.save_profile')))]), _vm._v(" "), _c('a', {
    staticClass: "button is-large",
    on: {
      "click": _vm.changePass
    }
  }, [_vm._v(_vm._s(_vm.$t('index.profile.change_password')))])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isChangePassword,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isChangePassword = $event
      }
    }
  }, [_c('changepassword')], 1)], 1) : _vm._e()])
  var _obj;
  var _obj$1;
  var _obj$2;
},staticRenderFns: []}

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.dateFormat))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.timeFormat))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fas fa-calendar-alt fa"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fas fa-clock fa"
  })])
}]}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card collapse-item",
    class: {
      'is-fullwidth': _vm.$parent.isFullwidth, 'is-active': _vm.isActived
    }
  }, [_c('header', {
    staticClass: "card-header touchable",
    attrs: {
      "role": "tab",
      "aria-expanded": _vm.selected ? 'true' : 'fase'
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('h3', {
    staticClass: "card-header-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collapsed-fade",
      "css": false,
      "appear": ""
    },
    on: {
      "before-appear": _vm.before,
      "appear": _vm.enter,
      "appear-cancel": _vm.cancel,
      "before-enter": _vm.before,
      "enter": _vm.enter,
      "enter-cancel": _vm.cancel,
      "leave": _vm.leave,
      "leave-cancel": _vm.cancel
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActived),
      expression: "isActived"
    }],
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-content-box"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-header-icon"
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])
}]}

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: ['notification', 'animated', _vm.type ? ("is-" + _vm.type) : '']
  }, [_c('button', {
    staticClass: "delete touchable",
    on: {
      "click": function($event) {
        _vm.closedByUser()
      }
    }
  }), _vm._v(" "), (_vm.title) ? _c('div', {
    staticClass: "title is-5"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.message) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('b-loading', {
    attrs: {
      "active": _vm.isloadingUpdate,
      "can-cancel": false
    },
    on: {
      "update:active": function($event) {
        _vm.isloadingUpdate = $event
      }
    }
  }), _vm._v(" "), _c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('index.edit_client_tokens_' + _vm.obj.licenseInfo.byod_type)))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {}, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('b-field', {
    attrs: {
      "label": '* ' + _vm.$t('index.select_configuration_' + _vm.obj.licenseInfo.byod_type)
    }
  }, [_c('b-select', {
    attrs: {
      "placeholder": "Select the configuration and room",
      "required": "",
      "expanded": ""
    },
    on: {
      "input": _vm.selectRoom
    },
    model: {
      value: (_vm.localTokenVal.editKeyValues.configurationId),
      callback: function($$v) {
        _vm.$set(_vm.localTokenVal.editKeyValues, "configurationId", $$v)
      },
      expression: "localTokenVal.editKeyValues.configurationId"
    }
  }, _vm._l((_vm.obj.configurations), function(conf) {
    return _c('option', {
      key: conf.id,
      domProps: {
        "value": conf.id
      }
    }, [_vm._v(_vm._s(conf.name))])
  }))], 1)], 1)]), _vm._v(" "), _c('div', [_c('b-field', [_c('b-radio', {
    attrs: {
      "native-value": "1",
      "type": "is-danger"
    },
    model: {
      value: (_vm.localTokenVal.editKeyValues.limitType),
      callback: function($$v) {
        _vm.$set(_vm.localTokenVal.editKeyValues, "limitType", $$v)
      },
      expression: "localTokenVal.editKeyValues.limitType"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('index.limited_by_datetime')) + "\n            ")])], 1), _vm._v(" "), _c('b-field', [_c('b-radio', {
    attrs: {
      "native-value": "2",
      "type": "is-info"
    },
    model: {
      value: (_vm.localTokenVal.editKeyValues.limitType),
      callback: function($$v) {
        _vm.$set(_vm.localTokenVal.editKeyValues, "limitType", $$v)
      },
      expression: "localTokenVal.editKeyValues.limitType"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('index.unlimited_duration')) + "\n            ")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.localTokenVal.editKeyValues.limitType == 2) ? _c('div', {
    staticClass: "limit_type_2"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.check_frequency')
      }
    }, [_c('b-input', {
      attrs: {
        "type": "number",
        "min": "1",
        "max": "7",
        "icon": "clock",
        "placeholder": _vm.$t('index.days')
      },
      model: {
        value: (_vm.localTokenVal.editKeyValues.frequencyCheckPeriod),
        callback: function($$v) {
          _vm.$set(_vm.localTokenVal.editKeyValues, "frequencyCheckPeriod", $$v)
        },
        expression: "localTokenVal.editKeyValues.frequencyCheckPeriod"
      }
    }, [_vm._v(" > ")])], 1)]
  ], 2)])]) : _vm._e(), _vm._v(" "), (_vm.localTokenVal.editKeyValues.limitType == 1) ? _c('div', {
    staticClass: "limit_type_1"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.arrival_date_' + _vm.obj.licenseInfo.byod_type)
      }
    }, [_c('b-datepicker', {
      attrs: {
        "min-date": _vm.minDate,
        "placeholder": "Click to select...",
        "icon": "calendar-alt"
      },
      model: {
        value: (_vm.localTokenVal.editKeyValues.dateLifeFrom),
        callback: function($$v) {
          _vm.$set(_vm.localTokenVal.editKeyValues, "dateLifeFrom", $$v)
        },
        expression: "localTokenVal.editKeyValues.dateLifeFrom"
      }
    })], 1)]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.arrival_time_' + _vm.obj.licenseInfo.byod_type)
      }
    }, [_c('b-timepicker', {
      attrs: {
        "hour-format": "24",
        "placeholder": "Type or select a date...",
        "icon": "clock",
        "readonly": false
      },
      model: {
        value: (_vm.localTokenVal.editKeyValues.dateLifeFrom),
        callback: function($$v) {
          _vm.$set(_vm.localTokenVal.editKeyValues, "dateLifeFrom", $$v)
        },
        expression: "localTokenVal.editKeyValues.dateLifeFrom"
      }
    })], 1)]
  ], 2)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.departure_date_' + _vm.obj.licenseInfo.byod_type)
      }
    }, [_c('b-datepicker', {
      attrs: {
        "min-date": _vm.minDate,
        "placeholder": "Click to select...",
        "icon": "calendar-alt"
      },
      model: {
        value: (_vm.localTokenVal.editKeyValues.dateLifeTo),
        callback: function($$v) {
          _vm.$set(_vm.localTokenVal.editKeyValues, "dateLifeTo", $$v)
        },
        expression: "localTokenVal.editKeyValues.dateLifeTo"
      }
    })], 1)]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.departure_time_' + _vm.obj.licenseInfo.byod_type)
      }
    }, [_c('b-timepicker', {
      attrs: {
        "hour-format": "24",
        "placeholder": "Type or select a date...",
        "icon": "clock",
        "readonly": false
      },
      model: {
        value: (_vm.localTokenVal.editKeyValues.dateLifeTo),
        callback: function($$v) {
          _vm.$set(_vm.localTokenVal.editKeyValues, "dateLifeTo", $$v)
        },
        expression: "localTokenVal.editKeyValues.dateLifeTo"
      }
    })], 1)]
  ], 2)]), _vm._v(" "), _c('div', {
    staticClass: "columns session_block"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.session_time')))]), _vm._v(" "), _c('b-checkbox', {
    model: {
      value: (_vm.localTokenVal.editKeyValues.sessionTimeOption),
      callback: function($$v) {
        _vm.$set(_vm.localTokenVal.editKeyValues, "sessionTimeOption", $$v)
      },
      expression: "localTokenVal.editKeyValues.sessionTimeOption"
    }
  }, [_vm._v(_vm._s(_vm.$t('index.custom_time_cb')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('b-tooltip', {
    attrs: {
      "label": "Default and max value 30days (43200 minutes)",
      "multilined": ""
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(!_vm.localTokenVal.editKeyValues.sessionTimeOption ? _vm.$t('index.default') : _vm.$t('index.custom_time')))])]), _vm._v(" "), (!_vm.localTokenVal.editKeyValues.sessionTimeOption) ? _c('div', [_c('b', [_vm._v("30 " + _vm._s(_vm.$t('index.days')))])]) : _c('div', [_c('b-field', [_c('b-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "43200",
      "icon": "clock",
      "placeholder": _vm.$t('index.minutes')
    },
    model: {
      value: (_vm.localTokenVal.editKeyValues.sessionTimeValue),
      callback: function($$v) {
        _vm.$set(_vm.localTokenVal.editKeyValues, "sessionTimeValue", $$v)
      },
      expression: "localTokenVal.editKeyValues.sessionTimeValue"
    }
  })], 1)], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('index.email')))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-field', {
    attrs: {
      "message": _vm.localTokenVal.editKeyValues.proLogin ? _vm.$t('index.used_as_login') : ''
    }
  }, [_c('b-input', {
    attrs: {
      "icon": "envelope",
      "type": "email",
      "disabled": _vm.tokenVal.bxRightId
    },
    model: {
      value: (_vm.localTokenVal.editKeyValues.email),
      callback: function($$v) {
        _vm.$set(_vm.localTokenVal.editKeyValues, "email", $$v)
      },
      expression: "localTokenVal.editKeyValues.email"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [
    [_c('b-field', {
      attrs: {
        "label": _vm.$t('index.activation_panels_limit')
      }
    }, [_c('b-input', {
      attrs: {
        "placeholder": _vm.$t('index.activation_panels_limit_placeholder'),
        "type": "number",
        "min": "1",
        "icon": "clock"
      },
      model: {
        value: (_vm.localTokenVal.editKeyValues.activationsCount),
        callback: function($$v) {
          _vm.$set(_vm.localTokenVal.editKeyValues, "activationsCount", $$v)
        },
        expression: "localTokenVal.editKeyValues.activationsCount"
      }
    })], 1)]
  ], 2)])]), _vm._v(" "), (_vm.fields.length) ? _c('div', {
    staticClass: "columns is-multiline",
    staticStyle: {
      "max-width": "480px"
    }
  }, [_c('b-loading', {
    attrs: {
      "is-full-page": false,
      "active": _vm.isLoading,
      "can-cancel": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _vm._l((_vm.fields), function(customField, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (customField.edit),
        expression: "customField.edit"
      }],
      key: i,
      staticClass: "column is-half"
    }, [_c('div', {
      staticClass: "field"
    }, [_c('label', {
      staticClass: "label"
    }, [_vm._v(_vm._s(customField.name))]), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, [_c('b-field', [_c('b-input', {
      attrs: {
        "type": "text"
      },
      on: {
        "input": function($event) {
          _vm.setCustomValue($event, customField, i)
        }
      },
      model: {
        value: (customField.value),
        callback: function($$v) {
          _vm.$set(customField, "value", $$v)
        },
        expression: "customField.value"
      }
    })], 1)], 1)])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    attrs: {
      "type": "is-danger"
    },
    model: {
      value: (_vm.localTokenVal.editKeyValues.deactivated),
      callback: function($$v) {
        _vm.$set(_vm.localTokenVal.editKeyValues, "deactivated", $$v)
      },
      expression: "localTokenVal.editKeyValues.deactivated"
    }
  }, [_vm._v(_vm._s(_vm.$t('index.force_deregister_client')))])], 1)])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.cancel')))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half has-text-right"
  }, [(_vm.localTokenVal.editKeyValues.deactivated) ? _c('button', {
    staticClass: "button is-danger",
    attrs: {
      "disabled": !_vm.validate
    },
    on: {
      "click": _vm.editKey
    }
  }, [_vm._v(_vm._s(_vm.$t('index.deactivate_registration')))]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": !_vm.validate
    },
    on: {
      "click": _vm.editKey
    }
  }, [_vm._v(_vm._s(_vm.$t('index.edit_registration')))])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('index.additional_fields', {
    tagname: _vm.tagName
  })))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('b-table', {
    attrs: {
      "data": _vm.resultFields,
      "striped": true,
      "narrowed": false,
      "mobile-cards": true,
      "paginated": false,
      "per-page": 10,
      "pagination-simple": true,
      "default-sort": "['type', 'desc']"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "name",
            "label": _vm.$t('index.name'),
            "width": "210"
          }
        }, [(props.row.type === 1 && _vm.erroredFiedls[props.index]) ? _c('b-field', {
          attrs: {
            "type": "is-danger",
            "message": _vm.$t('index.additional_fields_message')
          }
        }, [_c('b-input', {
          on: {
            "input": function($event) {
              _vm.validateCustomType($event, props.index)
            }
          },
          model: {
            value: (props.row.name),
            callback: function($$v) {
              _vm.$set(props.row, "name", $$v)
            },
            expression: "props.row.name"
          }
        })], 1) : _vm._e(), _vm._v(" "), (props.row.type === 1 && !_vm.erroredFiedls[props.index]) ? _c('b-field', [_c('b-input', {
          on: {
            "input": function($event) {
              _vm.validateCustomType($event, props.index)
            }
          },
          model: {
            value: (props.row.name),
            callback: function($$v) {
              _vm.$set(props.row, "name", $$v)
            },
            expression: "props.row.name"
          }
        })], 1) : _vm._e(), _vm._v(" "), (props.row.type !== 1) ? _c('span', [_vm._v(_vm._s(props.row.name))]) : _vm._e()], 1), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": _vm.$t('index.default_value'),
            "field": "value",
            "width": "200"
          }
        }, [_c('b-field', [(props.row.value) ? _c('b-input', {
          attrs: {
            "disabled": _vm.isEditable(props.row.name),
            "expanded": ""
          },
          model: {
            value: (props.row.value),
            callback: function($$v) {
              _vm.$set(props.row, "value", $$v)
            },
            expression: "props.row.value"
          }
        }) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": _vm.$t('index.edit_by_customer'),
            "field": "edit",
            "width": "40",
            "centered": ""
          }
        }, [_c('b-checkbox', {
          attrs: {
            "type": "is-info",
            "disabled": props.row.type !== 1
          },
          model: {
            value: (props.row.edit),
            callback: function($$v) {
              _vm.$set(props.row, "edit", $$v)
            },
            expression: "props.row.edit"
          }
        })], 1), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "tools",
            "label": "",
            "width": "40",
            "centered": ""
          }
        }, [_c('button', {
          staticClass: "button is-danger",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.deleteField(props.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('index.delete')))])])]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "buttons has-addons is-centered"
  }, [_c('button', {
    staticClass: "button is-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showAvailableFields
    }
  }, [_vm._v(_vm._s(_vm.$t('index.add_field')))])])], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot  columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('index.close')))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half has-text-right"
  }, [(!_vm.validateCustomFieldError) ? _c('button', {
    staticClass: "button is-info ",
    on: {
      "click": _vm.saveFileds
    }
  }, [_vm._v(_vm._s(_vm.$t('index.save_and_close')))]) : _vm._e()])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isShowAvailableFields,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isShowAvailableFields = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto",
      "min-width": "300px"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('span', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('index.select_fields')) + "\n\n        ")]), _vm._v(" "), (_vm.checkedAvailableFields.length) ? _c('span', {
    staticClass: "button is-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addFiled
    }
  }, [_vm._v(_vm._s(_vm.$t('index.add_selected')))]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body",
    staticStyle: {
      "max-height": "350px"
    }
  }, [_c('b-table', {
    attrs: {
      "data": _vm.availableFields,
      "checked-rows": _vm.checkedAvailableFields,
      "checkable": ""
    },
    on: {
      "update:checkedRows": function($event) {
        _vm.checkedAvailableFields = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "name",
            "label": _vm.$t('index.name'),
            "width": "210"
          }
        }, [_vm._v("\n              " + _vm._s(props.row.name) + "\n\n            ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "name",
            "label": _vm.$t('index.type'),
            "width": "210"
          }
        }, [_vm._v("\n              " + _vm._s(props.row.type !== 1 ? _vm.$t('index.system_field') : _vm.$t('index.custom_field')) + "\n              ")])]
      }
    }])
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 325 */,
/* 326 */,
/* 327 */
/***/ (function(module, exports) {

module.exports = {"name":"byod-admin-vue","version":"1.0.18","description":"Bring Your Own Devices","homepage":"https://byod.iridi.com","license":"SEE LICENSE IN LICENSE","author":"iRidi","engines":{"node":">=4","npm":">=3"},"scripts":{"build":"cross-env NODE_ENV=production node build/build.js","clean":"rm -rf dist","dev":"cross-env NODE_ENV=development node build/dev-server.js","docker_dev":"docker-compose up","electron":"cross-env NODE_ELECTRON=true npm run build && electron electronIndex.js","gh":"npm run build && gh-pages -d dist","lint":"eslint --ext .js .vue client/*","lint:fix":"eslint --fix --ext .js .vue electron.js client/* build/* config/*","test":"echo lol"},"dependencies":{"@fortawesome/fontawesome":"^1.1.5","@fortawesome/fontawesome-free-brands":"^5.0.9","@fortawesome/fontawesome-free-regular":"^5.0.9","@fortawesome/fontawesome-free-solid":"^5.0.9","@websanova/vue-auth":"^2.8.2-beta","animate.css":"3.5.2","animejs":"^2.0.1","axios":"^0.15.3","babel":"^6.23.0","bulma":"github:fruxxx/bulma#master","font-awesome":"4.7.0","mapbox-gl":"^1.10.0","mdi":"^1.8.36","moment":"^2.22.0","moment-timezone":"^0.5.14","plotly.js":"^1.24.2","vue":"^2.5.17","vue-axios":"^2.0.1","vue-bulma-brace":"^0.1.0","vue-bulma-breadcrumb":"^1.0.1","vue-bulma-card":"^1.0.2","vue-bulma-chartist":"^1.1.0","vue-bulma-chartjs":"^1.0.4","vue-bulma-collapse":"1.0.3","vue-bulma-datepicker":"^1.3.0","vue-bulma-emoji":"^0.0.2","vue-bulma-expanding":"^0.0.1","vue-bulma-jump":"^0.0.2","vue-bulma-message":"^1.1.1","vue-bulma-modal":"1.0.1","vue-bulma-notification":"^1.1.1","vue-bulma-progress-bar":"^1.0.2","vue-bulma-progress-tracker":"0.0.4","vue-bulma-quill":"0.0.1","vue-bulma-rating":"^1.0.1","vue-bulma-slider":"^1.0.2","vue-bulma-switch":"^1.0.4","vue-bulma-tabs":"^1.1.2","vue-bulma-tooltip":"^1.0.3","vue-input-facade":"1.3.4","vue-i18n":"^8.24.1","vue-lory":"0.0.4","vue-nprogress":"0.1.5","vue-peity":"0.5.0","vue-qrcode-component":"^2.1.1","vue-router":"^2.3.0","vuex":"^2.2.1","vuex-router-sync":"^4.1.2","wysiwyg.css":"0.0.2"},"devDependencies":{"autoprefixer":"^6.7.7","babel-core":"^6.21.0","babel-eslint":"^7.1.1","babel-loader":"^6.4.0","babel-plugin-transform-async-to-generator":"^6.24.1","babel-plugin-transform-export-extensions":"^6.8.0","babel-polyfill":"^6.26.0","babel-preset-es2015":"^6.14.0","babel-preset-stage-2":"^6.17.0","buefy":"^0.7.10","connect-history-api-fallback":"^1.3.0","cross-env":"^3.1.3","css-loader":"^0.27.1","electron-devtools-installer":"^2.0.1","eslint":"^3.17.1","eslint-config-standard":"^7.0.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.6.1","eslint-plugin-html":"^2.0.1","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^2.1.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^2.0.0-beta.4","file-loader":"^0.10.1","html-webpack-plugin":"^2.25.0","http-proxy-middleware":"^0.17.4","imports-loader":"^0.7.0","node-sass":"^4.14.1","opn":"^4.0.2","ora":"^1.1.0","postcss-loader":"^1.3.3","progress-bar-webpack-plugin":"^1.9.1","regenerator-runtime":"^0.13.7","sass-loader":"^6.0.3","serve-favicon":"^2.4.1","style-loader":"^0.13.1","stylus":"^0.54.5","stylus-loader":"^3.0.1","url-loader":"^0.5.7","vue-html-loader":"^1.2.3","vue-loader":"^11.1.4","vue-template-compiler":"^2.5.17","webpack":"^2.2.1","webpack-dev-middleware":"^1.9.0","webpack-hot-middleware":"^2.14.0","webpack-merge":"^4.0.0"}}

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(162);


/***/ })
],[328]);


// WEBPACK FOOTER //
// assets/js/app.7bc57241d783ea7e064f.js